import moment from "moment";
import * as React from "react";
import * as Compat from "../Compat";
import * as Dati from "../Dati";
import * as Glob from "../Globale";
import { ChiamaAPI } from "../components/";

class CTrad {
    private readonly TestiEN: { [T: string]: string } = {
        ["EmissioneDirettaPOSNonPermessa"]: "Action non permitted",
        ["Save personal data"]: "Save personal data",
        ["ErroreEmissioneOrarioUfficio"]: "Error issuing policy outside business hours",
        ["EmissioneOrarioUfficio"]: "Issue only during business hours",
        ["Passa a: "]: "Move to: ",
        ["Password change"]: "Password change",
        ["Password has been changed"]: "Password has been changed",
        ["PremioImpostatoInferioreAlPremioMinimo"]: "Premium lower than Minimum Premium",
        ["PremioImpostatoSuperioreAlLimite"]: "Premium greater than the limit",
        ["ProroghePremioNetto"]: "Extension - Net premium",
        ["ProrogheAccessori"]: "Extension - Accessories",
        ["ProrogheDirittiEmissione"]: "Extension - Fees",
        ["ProrogheImponibile"]: "Extension - Premium before taxes",
        ["ProrogheImposte"]: "Extension - Taxes",
        ["ProroghePremioFinito"]: "Extension - Gross Premium",
        ["ProrogheTipo"]: "Extension - Type",
        ["ProrogheDa"]: "Extension - From",
        ["ProrogheA"]: "Extension - To",
        ["Trimestrale"]: "Quarterly",
        ["% assicurata"]: "% share",
        ["% CoAssicurazione minima"]: "CoInsurance Minimum Share",
        ["..."]: "...",
        ["CampoWordMassimoUnaTabella"]: "It is allowed to add only one table",
        ["[Dati][Dato][ID_AnagContraente]"]: "Proposal Details",
        ["[DatoRCPPolizza][AltreAttivita][DatiQuestionario][][items][Descrizione]"]: "Other Activities -  Description",
        ["[DatoRCPPolizza][AltreAttivita][RispostaAperturaQuestionario]"]: "Other Activities",
        ["[DatoRCPPolizza][Anagrafiche][]"]: "Details",
        ["[DatoRCPPolizza][Anagrafiche][length]"]: "Insureds",
        ["[DatoRCPPolizza][Ass][DatiQuestionario][][items][PassatoEsercizio]"]: "Last Turnover - Insurance Company",
        ["[DatoRCPPolizza][Ass][DatiQuestionario][][items][PIVA]"]: "Insurance Company - Vat Number",
        ["[DatoRCPPolizza][Ass][DatiQuestionario][][items][Societa]"]: "Insurance Company - Company name",
        ["[DatoRCPPolizza][Ass][RispostaAperturaQuestionario]"]: "Insurance Company",
        ["[DatoRCPPolizza][AttivitaOspedaliera][DatiQuestionario][][items][Struttura]"]: "Hospital activity - Public or private structure",
        ["[DatoRCPPolizza][AttivitaOspedaliera][RispostaAperturaQuestionario]"]: "Hospital activity",
        ["[DatoRCPPolizza][AttivitaPatrocinatore][DatiQuestionario][0][items][PassatoEsercizio]"]: "Last Turnover - Extrajudical Experts",
        ["[DatoRCPPolizza][AttivitaPatrocinatore][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Forecast Revenue - Extrajudical Experts",
        ["[DatoRCPPolizza][Azionisti][DatiQuestionario][][items][Descrizione]"]: "Shareholders who hold more than 10% of the Company's capital - Description",
        ["[DatoRCPPolizza][Azionisti][DatiQuestionario][][items][Percentuale]"]: "Shareholders who hold more than 10% of the Company's capital - Percentage",
        ["[DatoRCPPolizza][Azionisti][RispostaAperturaQuestionario]"]: "Shareholders who hold more than 10% of the Company's capital",
        ["[DatoRCPPolizza][BilancioCertificato][DatiQuestionario][][items][Descrizione]"]: "Company's financial statements are subject to certification - Description",
        ["[DatoRCPPolizza][BilancioCertificato][RispostaAperturaQuestionario]"]: "Company's financial statements are subject to certification",
        ["[DatoRCPPolizza][BilCon][DatiQuestionario][][items][PassatoEsercizio]"]: "Last Turnover - Company bound to issue consolidate balance sheets",
        ["[DatoRCPPolizza][BilCon][DatiQuestionario][][items][PIVA]"]: "Company bound to issue consolidate balance sheets - VAT Number",
        ["[DatoRCPPolizza][BilCon][DatiQuestionario][][items][Societa]"]: "Company bound to issue consolidate balance sheets - Company Name",
        ["[DatoRCPPolizza][BilCon][RispostaAperturaQuestionario]"]: "Company bound to issue consolidate balance sheets",
        ["[DatoRCPPolizza][ClientiFalliti][DatiQuestionario][][items][PIVA]"]: "Bankruptcy proceedings - VAT Number",
        ["[DatoRCPPolizza][ClientiFalliti][DatiQuestionario][][items][Societa]"]: "Bankruptcy proceedings - Company Name",
        ["[DatoRCPPolizza][ClientiFalliti][RispostaAperturaQuestionario]"]: "Bankruptcy proceedings",
        ["[DatoRCPPolizza][Consorzio][DatiQuestionario][][items][PassatoEsercizio]"]:
            "Last Turnover - Consortia and similar ventures which any of the above mentioned operations or companies is party",
        ["[DatoRCPPolizza][Consorzio][DatiQuestionario][][items][PIVA]"]: "Consortia and similar ventures which any of the above mentioned operations or companies is party - VAT Number",
        ["[DatoRCPPolizza][Consorzio][DatiQuestionario][][items][Societa]"]: "Consortia and similar ventures which any of the above mentioned operations or companies is party - Company Name",
        ["[DatoRCPPolizza][Consorzio][RispostaAperturaQuestionario]"]: "Consortia and similar ventures which any of the above mentioned operations or companies is party",
        ["[DatoRCPPolizza][Credito][DatiQuestionario][][items][PassatoEsercizio]"]: "Last Turnover - Banking operations",
        ["[DatoRCPPolizza][Credito][DatiQuestionario][][items][PIVA]"]: "Banking operations - - VAT Number",
        ["[DatoRCPPolizza][Credito][DatiQuestionario][][items][Societa]"]: "Banking operations - Company Name",
        ["[DatoRCPPolizza][Credito][RispostaAperturaQuestionario]"]: "Banking operations",
        ["[DatoRCPPolizza][Curatore][DatiQuestionario][0][items][PassatoEsercizio]"]: "Last Turnover - Liquidator or bankruptcy trustee of companies",
        ["[DatoRCPPolizza][Curatore][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Forecast Revenue - Liquidator or bankruptcy trustee of companies",
        ["[DatoRCPPolizza][Dipendente][DatiQuestionario][][items][Struttura]"]: "National Health Service or hospital employee - Hospital",
        ["[DatoRCPPolizza][Dipendente][RispostaAperturaQuestionario]"]: "National Health Service or hospital employee",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][CAP]"]: "EDP -Postcode",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][Citta]"]: "EDP - City",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][Indirizzo]"]: "EDP - Address",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][PassatoEsercizio]"]: "Last Turnover - EDP",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][PIVA]"]: "EDP - VAT Number",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][Provincia]"]: "EDP - Province",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][Societa]"]: "EDP - Company name",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][StimaEsercizioCorrente]"]: "Forecast Revenue - EDP",
        ["[DatoRCPPolizza][EDP][RispostaAperturaQuestionario]"]: "EDP",
        ["[DatoRCPPolizza][Eventi][DatiQuestionario][][items][Descrizione]"]: "Awareness of facts that could give rise to requests for compensation or criminal proceeding - Description",
        ["[DatoRCPPolizza][Eventi][RispostaAperturaQuestionario]"]: "Awareness of facts that could give rise to requests for compensation or criminal proceeding",
        ["[DatoRCPPolizza][Fin][DatiQuestionario][][items][PassatoEsercizio]"]: "Last Turnover - Financial companies, of any kind",
        ["[DatoRCPPolizza][Fin][DatiQuestionario][][items][PIVA]"]: "Financial companies, of any kind - VAT Number",
        ["[DatoRCPPolizza][Fin][DatiQuestionario][][items][Societa]"]: "Financial companies, of any kind - Company name",
        ["[DatoRCPPolizza][Fin][RispostaAperturaQuestionario]"]: "Financial companies, of any kind",

        ["[DatoRCPPolizza][FunzioniPubbliche][DatiQuestionario][0][items][PassatoEsercizio]"]: "Last Turnover - Public Functions",
        ["[DatoRCPPolizza][FunzioniPubbliche][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Forecast Revenue - Public Functions",

        ["[DatoRCPPolizza][Fusione][DatiQuestionario][][items][Data]"]: "The Company acquired or merged with other Companies - Date",
        ["[DatoRCPPolizza][Fusione][DatiQuestionario][][items][Descrizione]"]: "The Company acquired or merged with other Companies - Description",
        ["[DatoRCPPolizza][Fusione][RispostaAperturaQuestionario]"]: "The Company acquired or merged with other Companies",
        ["[DatoRCPPolizza][ImplantologiaAltre][DatiQuestionario][][items][ImplantologiaAltreDescr]"]: "Type of implantology",
        ["[DatoRCPPolizza][ImplantologiaAltre][RispostaAperturaQuestionario]"]: "Other type of Implantology",
        ["[DatoRCPPolizza][IncarichiProfessionaliRegimeDiGeneralContractor][DatiQuestionario][][items][Descrizione]"]: "Professional assignments as General Contractor - Work description",
        ["[DatoRCPPolizza][IncarichiProfessionaliRegimeDiGeneralContractor][DatiQuestionario][][items][Fatturato]"]: "Professional assignments as General Contractor - Revenue",
        ["[DatoRCPPolizza][IncarichiProfessionaliRegimeDiGeneralContractor][DatiQuestionario][][items][Valore]"]: "Professional assignments as General Contractor - Value",
        ["[DatoRCPPolizza][IncarichiProfessionaliRegimeDiGeneralContractor][RispostaAperturaQuestionario]"]: "Professional assignments as General Contractor",
        ["[DatoRCPPolizza][Indagine][DatiQuestionario][][items][DataEvento]"]: "Investigation - Date of the Event",
        ["[DatoRCPPolizza][Indagine][DatiQuestionario][][items][DescrizioneEvento]"]: "Investigation - Event Description",
        ["[DatoRCPPolizza][Indagine][DatiQuestionario][][items][StatoCircostanza]"]: "Investigation - Event Status",
        ["[DatoRCPPolizza][Indagine][RispostaAperturaQuestionario]"]: "Investigation",
        ["[DatoRCPPolizza][InformazioniAzioni][DatiQuestionario][][items][DataEvento]"]: "Actions, omissions or facts - Date of Event",
        ["[DatoRCPPolizza][InformazioniAzioni][DatiQuestionario][][items][DescrizioneEvento]"]: "Actions, omissions or facts - Details",
        ["[DatoRCPPolizza][InformazioniAzioni][DatiQuestionario][][items][StatoCircostanza]"]: "Actions, omissions or facts - Status",
        ["[DatoRCPPolizza][InformazioniAzioni][RispostaAperturaQuestionario]"]: "Actions, omissions or facts",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][DatiQuestionario][][items][Compagnia]"]: "Previous Policies - Company",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][DatiQuestionario][][items][DataInizio]"]: "Previous Policies - Starting Date",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][DatiQuestionario][][items][DataScadenza]"]: "Previous Policies - Expiry Date",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][DatiQuestionario][][items][Massimale]"]: "Previous Policies - Limit of Authority",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][DatiQuestionario][][items][NumeroAnniCoperturaPrecedenteContinua]"]: "Previous Policies - Years of continuous coverage",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][DatiQuestionario][][items][PremioPagato]"]: "Previous Policies - Payed Premium",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][DatiQuestionario][][items][Retroattivita]"]: "Previous Policies - Retroactivity",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][RispostaAperturaQuestionario]"]: "Previous Policies",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][Compagnia]"]: "Claims - Company",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][DataEvento]"]: "Claims - Date of the Event",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][DataRichiesta]"]: "Claims - Date of Request",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][DenunciaCompagnia]"]: "Claims - Complaint to the Company",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][DescrizioneEvento]"]: "Claims - Event description",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][ImportoRichiesto]"]: "Claims - Request Amount",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][Preventivo]"]: "Claims - Quotation",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][ResponsabilitaAcclarate]"]: "Claims - Responsibility Acclared",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][StatoSinistro]"]: "Claims - Claim Status]",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][TerminiRinnovo]"]: "Claims - Renewal Terms",
        ["[DatoRCPPolizza][InformazioniSinistri][RispostaAperturaQuestionario]"]: "Claims",
        ["[DatoRCPPolizza][LiberoProfessionista] "]: "Self-employed",
        ["[DatoRCPPolizza][LiberoProfSSNExtramoenia]"]: "Self-employed - Agreed upon with the NHS - Extramoenia",
        ["[DatoRCPPolizza][Licenziamento][DatiQuestionario][][items][Descrizione]"]: "Dismissal or early retirement for employees - Description",
        ["[DatoRCPPolizza][Licenziamento][RispostaAperturaQuestionario]"]: "Dismissal or early retirement for employees",
        ["[DatoRCPPolizza][MedicoFrequentatore][DatiQuestionario][][items][Reparto]"]: "Attending Physicians - Ward",
        ["[DatoRCPPolizza][MedicoFrequentatore][DatiQuestionario][][items][Struttura]"]: "Attending Physicians - Public or private structure",
        ["[DatoRCPPolizza][MedicoFrequentatore][RispostaAperturaQuestionario]"]: "Attending Physicians",
        ["[DatoRCPPolizza][MembroCdA][DatiQuestionario][0][items][PassatoEsercizio]"]: "Last Turnover - Member of BoD",
        ["[DatoRCPPolizza][MembroCdA][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Forecast Revenue - Member of BoD",
        ["[DatoRCPPolizza][ModificaRagioneSociale][DatiQuestionario][][items][Data]"]: "Company changed its name - Date",
        ["[DatoRCPPolizza][ModificaRagioneSociale][DatiQuestionario][][items][Descrizione]"]: "Company changed its name - Description",
        ["[DatoRCPPolizza][ModificaRagioneSociale][RispostaAperturaQuestionario]"]: "Company changed its name",
        ["[DatoRCPPolizza][NumeroAssicurati]"]: "Number of Insureds",
        ["[DatoRCPPolizza][NuoviTitoli][DatiQuestionario][][items][Descrizione]"]: "Plan acquisitions, public offers or mergers - Descrizione",
        ["[DatoRCPPolizza][NuoviTitoli][RispostaAperturaQuestionario]"]: "Plan acquisitions, public offers or mergers",
        ["[DatoRCPPolizza][OperaMerloni][DatiQuestionario][][items][DataFineLavori]"]: "Merloni Law - End of the works",
        ["[DatoRCPPolizza][OperaMerloni][DatiQuestionario][][items][DataInizioLavori]"]: "Merloni Law - Starting date of the works",
        ["[DatoRCPPolizza][OperaMerloni][DatiQuestionario][][items][DescrizioneLavori]"]: "Merloni Law - Description",
        ["[DatoRCPPolizza][OperaMerloni][DatiQuestionario][][items][LuogoEsecuzione]"]: "Merloni Law - Place of Execution of the Works",
        ["[DatoRCPPolizza][OperaMerloni][DatiQuestionario][][items][StazioneAppaltante]"]: "Merloni Law - Contracting Authority",
        ["[DatoRCPPolizza][OperaMerloni][DatiQuestionario][][items][ValoreOpera]"]: "Merloni Law - Works value",
        ["[DatoRCPPolizza][OperaMerloni][RispostaAperturaQuestionario]"]: "Merloni Law",
        ["[DatoRCPPolizza][ProcedimentiPenali][DatiQuestionario][][items][Descrizione]"]: "Criminal proceedings - Description",
        ["[DatoRCPPolizza][ProcedimentiPenali][RispostaAperturaQuestionario]"]: "Criminal proceedings",
        ["[DatoRCPPolizza][Quotate][DatiQuestionario][][items][PassatoEsercizio]"]: "Last Turnover - Companies listed on official financial markets",
        ["[DatoRCPPolizza][Quotate][DatiQuestionario][][items][PIVA]"]: "Companies listed on official financial markets - VAT Number",
        ["[DatoRCPPolizza][Quotate][DatiQuestionario][][items][Societa]"]: "Companies listed on official financial markets - Company name",
        ["[DatoRCPPolizza][Quotate][RispostaAperturaQuestionario]"]: "Companies listed on official financial markets",
        ["[DatoRCPPolizza][Revisore][DatiQuestionario][0][items][PassatoEsercizio]"]: "Last Turnover - Auditor",
        ["[DatoRCPPolizza][Revisore][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Forecast Revenue -  Auditor",

        ["[DatoRCPPolizza][RevisoreComm][DatiQuestionario][0][items][PassatoEsercizio]"]: "Last Turnover - Auditor",
        ["[DatoRCPPolizza][RevisoreComm][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Forecast Revenue -  Auditor",


        ["[DatoRCPPolizza][RevisoreEntiPubblici][DatiQuestionario][0][items][PassatoEsercizio]"]: "Last Turnover - Auditor of Public Entities",
        ["[DatoRCPPolizza][RevisoreEntiPubblici][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Forecast Revenue - Auditor of Public Entities",
        ["[DatoRCPPolizza][RichiesteRisarcimento][DatiQuestionario][][items][Descrizione]"]: "Any requests for compensation - Description",
        ["[DatoRCPPolizza][RichiesteRisarcimento][RispostaAperturaQuestionario]"]: "Any requests for compensation",
        ["[DatoRCPPolizza][RifiutoCopertura][DatiQuestionario][][items][AnnoRichiesta]"]: "Insurance Coverage Refusal - Year of request",
        ["[DatoRCPPolizza][RifiutoCopertura][DatiQuestionario][][items][Compagnia]"]: "Insurance Coverage Refusal - Company",
        ["[DatoRCPPolizza][RifiutoCopertura][DatiQuestionario][][items][Motivo]"]: "Insurance Coverage Refusal - Details]",
        ["[DatoRCPPolizza][RifiutoCopertura][RispostaAperturaQuestionario]"]: "Insurance Coverage Refusal",
        ["[DatoRCPPolizza][Rischio][DatiQuestionario][][items][PassatoEsercizio]"]: "Last Turnover - Companies that make use of the risk capital market",
        ["[DatoRCPPolizza][Rischio][DatiQuestionario][][items][PIVA]"]: "Companies that make use of the risk capital market - VAT Number",
        ["[DatoRCPPolizza][Rischio][DatiQuestionario][][items][Societa]"]: "Companies that make use of the risk capital market- Company Name",
        ["[DatoRCPPolizza][Rischio][RispostaAperturaQuestionario]"]: "Companies that make use of the risk capital market",
        ["[DatoRCPPolizza][SediSecondarie][DatiQuestionario][][items][CAP]"]: "Subsidiary Offices - Postecode",
        ["[DatoRCPPolizza][SediSecondarie][DatiQuestionario][][items][Citta]"]: "Subsidiary Offices - City",
        ["[DatoRCPPolizza][SediSecondarie][DatiQuestionario][][items][Indirizzo]"]: "Subsidiary Offices - Address",
        ["[DatoRCPPolizza][SediSecondarie][DatiQuestionario][][items][Provincia]"]: "Subsidiary Offices - Province",
        ["[DatoRCPPolizza][SediSecondarie][RispostaAperturaQuestionario]"]: "Subsidiary Offices",

        ["[DatoRCPPolizza][Sindaco][DatiQuestionario][0][items][PassatoEsercizio]"]: "Last Turnover - Statutory Auditor",
        ["[DatoRCPPolizza][Sindaco][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Forecast Revenue - Statutory Auditor",

        ["[DatoRCPPolizza][StabiliCondominiali][DatiQuestionario][0][items][PassatoEsercizio]"]: "Last Turnover - Buildings Manager",
        ["[DatoRCPPolizza][StabiliCondominiali][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Forecast Revenue - Buildings Manager",
        ["[DatoRCPPolizza][Struttura] è obbligatorio"]: "Questionnaire - Other information - Name of Public or private structure is missing",
        ["[DatoRCPPolizza][Titoli][DatiQuestionario][][items][Data]"]: "Any Company securities traded on regulated markets - Date",
        ["[DatoRCPPolizza][Titoli][DatiQuestionario][][items][Descrizione]"]: "Any Company securities traded on regulated markets - Description",
        ["[DatoRCPPolizza][Titoli][RispostaAperturaQuestionario]"]: "Any Company securities traded on regulated markets",
        ["[DatoRCPPolizza][VariazioneDipendenti][DatiQuestionario][][items][Descrizione]"]: "Reduced or increased the total number of employees - Description",
        ["[DatoRCPPolizza][VariazioneDipendenti][RispostaAperturaQuestionario]"]: "Reduced or increased the total number of employees",
        ["[DatoRCPPolizza][VistoLeggero][DatiQuestionario][0][items][PassatoEsercizio]"]: "Last Turnover - Light Visa",
        ["[DatoRCPPolizza][VistoLeggero][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Forecast Revenue - Light Visa",
        ["[DatoRCPPolizza][VistoPesante][DatiQuestionario][0][items][PassatoEsercizio]"]: "Last Turnover - Heavy Visa",
        ["[DatoRCPPolizza][VistoPesante][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Forecast Revenue - Heavy Visa",
        ["[PreventivoSelezionato]"]: "Quotation Selected",
        ["{1-B}"]: "{1-B}",
        ["{1-D}"]: "{1-D}",
        ["{1-I}"]: "{1-I}",
        ["{1-N}"]: "{1-N}",
        ["{1-P}"]: "{1-P}",
        ["{1-R}"]: "{1-R}",
        ["{1-S} - CFPIVA: {2-S} - ID: {3-S}"]: "{1-S} - VAT: {2-S} - ID: {3-S}",
        ["{1-S}"]: "{1-S}",
        ["{1-S}: Affidamento utilizzato {2-I}"]: "{1-S}: Spent Credit {2-I}",
        ["{1-S}: Limite rimasto {2-I}"]: "{1-S}: Credit still available {2-I}",
        ["{1-S}: Limite utilizzato {2-I}"]: "{1-S}: Spent Credit {2-I}",
        ["{1-S}diversoDa{2-S}"]: "{1-S} different from {2-S}",
        ["{1-S}èObbligatorio"]: "{1-S} is mandatory",
        ["{1-S}inferioreAl{2-S}"]: "{1-S} lower than {2-S}",
        ["{1-S}NonHaRaggiuntoValoreNecessario{2-D}SeiSoloA{3-D}"]: "{1-S} is not enought to complete {2-D}, you wrote {3-D}",
        ["{1-S}superioreDel{2-S}"]: "{1-S} greater than {2-S}",
        ["{1-T}"]: "{1-T}",
        ["0"]: "0",
        ["1"]: "1",
        ["10"]: "10",
        ["1000000"]: "1,000,000",
        ["1000000/2000000"]: "1,000,000/2,000,000",
        ["1500000"]: "1,500,000",
        ["2"]: "2",
        ["2000000"]: "2,000,000",
        ["2500000"]: "2,500,000",
        ["2000000/4000000"]: "2,000,000/4,000,000",
        ["210"]: "210",
        ["250000"]: "250,000",
        ["3"]: "3",
        ["350000"]: "350,000",
        ["3000000"]: "3,000,000",
        ["3500000"]: "3,500,000",
        ["4"]: "4",
        ["4000000"]: "4,000,000",
        ["5"]: "5",
        ["500000"]: "500,000",
        ["5000000"]: "5,000,000",
        ["500000/1000000"]: "500,000/1,000,000",
        ["6"]: "6",
        ["7"]: "7",
        ["730"]: "730",
        ["750000"]: "750,000",
        ["750000/1250000"]: "750,000/1,250,000",
        ["8"]: "8",
        ["9"]: "9",
        ["A seguito di indagine, il Proponente e/o gli Assicurati risultano essere a conoscenza di Circostanze o Eventi che possano dare origine a una richiesta di risarcimento nei confronti del Proponente stesso in relazione all'incarico professionale – Attività di Sindaco/Revisore dei Conti, Amm.re società, Attività OdV 231/2001 (o altro) – indicato nella presente proposta?"]:
            "Following an investigation, the Proponent and/or the Insured are aware of circumstances or events that may give rise to a claim for compensation against the Proponent himself in relation to the professional assignment - Activities of Auditor/Statutory Auditor/Member od BoD -  indicated in this proposal?",
        ["A"]: "To",
        ["A.T.I."]: "Temporary association of companies",
        ["Abilitare alle chiamate Ribes"]: "Download from Ribes",
        ["Abilitazione funzione"]: "Feature Enabling",
        ["Accessori"]: "Accessories",
        ["AccessoriImporto"]: "Accessories Amount",
        ["ACCETTABILE"]: "ACCEPTABLE",
        ["Accettata"]: "Accepted",
        ["Accordi con le Compagnie"]: "Company Binder",
        ["Accordo quadro"]: "Framework agreement",
        ["Adattore"]: "Dubbing dialogist",
        ["ADDENDUM ERROR"]: "ADDENDUM ERROR",
        ["Addendum type"]: "Addendum type",
        ["Addendum"]: "Addendum",
        ["Addendums"]: "Addendums",
        ["Affidamenti gruppo"]: "Limit of exposure of the Group",
        ["Affidamenti non utilizzati {1-I}"]: "Credit still available {1-I}",
        ["Affidamenti per fideiussioni non provvisorie"]: "Limit of Exposure accepted for non-Bid Bonds in respect of",
        ["Affidamenti per fideiussioni provvisorie"]: "Limit of Exposure accepted for Bid Bonds",
        ["Affidamenti per i contraenti"]: "Limit of Exposure - Policyholder",
        ["Affidamenti"]: "Limits of Exposure",
        ["Affidamento morto"]: "Limit of Exposure Ended",
        ["Affidamento per fideiussioni non provvisorie"]: "Limit of Exposure accepted for non-Bid Bonds in respect of",
        ["Affidamento per fideiussioni provvisorie"]: "Limit of Exposure accepted for Bid Bonds",
        ["Affidamento salvato correttamente con ID: {1-S}"]: "Limit of Exposure saved correctly",
        ["Affidamento salvato correttamente"]: "Limit of Exposure saved correctly",
        ["Affidamento"]: "Limit of Exposure",
        ["AFFIDAMENTO"]: "Limit of Exposure",
        ["Affidatario"]: "Insurer",
        ["Affidato"]: "Insured",
        ["Agente"]: "Agent",
        ["Agenti"]: "Credit Agent",
        ["Agenti assicurativi"]: "Insurance agents",
        ["Aggiungi"]: "Add",
        ["AggiungiRubrica"]: "Add Details",
        ["Agricoltura"]: "Farming",
        ["Al Proponente sono mai state rifiutate coperture assicurative per la Responsabilità Civile Professionale?"]: "Has any Insurer ever refused this risk?",
        ["All"]: "All",
        ["Allergologia"]: "Allergology and Clinical Immunology",
        ["AltreAttivita"]: "Other Activities",
        ["AltreAttività"]: "Other Activities",
        ["AltreInformazioni"]: "Other Information",
        ["Altro"]: "Other",
        ["Amministratori"]: "Admin",
        ["AmministratoriCondominio"]: "Property Manager",
        ["Anag"]: "Details",
        ["AnagA"]: "To",
        ["AnagA: {1-S} - Data: {3-D} - Scadenza: {4-D} - Provvisorie: {5-I} - NonProvvisorie: {6-I} - ID: {7-S}"]: "From: {3-D} - To: {4-D} - Bid bonds: {5-I} - No bid bonds: {6-I} - ID: {7-S}",
        ["AnagA: {1-S} - Tipo: {2-T} - Data: {3-D} - Scadenza: {4-D} - Importo: {5-I} - ID: {7-S}"]: "Type: {2-T} - From: {3-D} - To: {4-D} - Limit: {5-I} - ID: {7-S}",
        ["AnagA: {1-S} - Data: {3-D} - Scadenza: {4-D} - Provvisorie: {5-I} - NonProvvisorie: {6-I} - ID: {7-S} - Compagnie: {8-S}"]:
            "From: {3-D} - To: {4-D} - Bid bonds: {5-I} - No bid bonds: {6-I} - Companies: {8-S} - ID: {7-S}",
        ["AnagA: {1-S} - Tipo: {2-T} - Data: {3-D} - Scadenza: {4-D} - Importo: {5-I} - ID: {7-S} - Compagnie: {8-S}"]:
            "Type: {2-T} - From: {3-D} - To: {4-D} - Limit: {5-I} - Companies: {8-S} - ID: {7-S}",
        ["AnagDa"]: "From",
        ["ANAGRAFICA ERRORE"]: "DETAILS ERROR",
        ["AnagraficaErrore Campi nulli"]: "Some field are empty!",
        ["AnagraficaErrore Codice fiscale"]: "Fiscal code are not valid!",
        ["AnagraficaErrore Codice fiscale presente"]: "Fiscal code already inserted!",
        ["AnagraficaErrore Salvataggio Anagrafiche"]: "Error save details : ",
        ["Anagrafica salvata correttamente con ID: {1-S}"]: "Details successfully saved - ID:{1-S}",
        ["Anagrafica"]: "Details",
        ["ANAGRAFICA"]: "DETAILS",
        ["Anagrafiche salvate correttamente"]: "Details saved",
        ["Anagrafiche"]: "Details",
        ["AnagStato"]: "Status",
        ["Analisi"]: "Analysis/Project/Development/Implementation/Installation/Transfer of License/Management: Software - Systems - Network Systems",
        ["AnatomiaPatologica"]: "Pathological anatomy (excluding genetic analysis)",
        ["Andamento dell'attività di produzione"]: "Production Trend",
        ["Andrologia"]: "Andrology",
        ["AnestRianimTerInt"]: "Anesthesiology and Critical Care Medicine",
        ["Angiologia"]: "Angiology",
        ["AnimaliCompagnia"]: "Professional activity related to pets and small animals in general",
        ["Anni"]: "Years",
        ["AnniCostituzione"]: "Years of Establishment",
        ["AnniRetroattivita"]: "Years of Retroactivity",
        ["Anno Bilancio"]: "Financial Year",
        ["Anno precedente"]: "Prior year",
        ["Anno riferimento"]: "Reference Year",
        ["Anno Unico"]: "Tax Return",
        ["AnnoInizioAttivita"]: "Date of commencement of the activity",
        ["AnnoIscrizioneAlbo"]: "Year of enrollment in the Professional Register",
        ["AnnoRichiesta"]: "Year of request",
        ["AnnoRif"]: "Reference Year",
        ["Annuale"]: "Annual",
        ["Annulla"]: "Cancel",
        ["Annullata"]: "Canceled",
        ["AnnullamentoSeo"]: "SEO Cancellation",
        ["AnnullaPolizza"]: "Policy Cancellation",
        ["Anticipazioni"]: "Advanced Payments",
        ["Appendice"]: "Policy Endorsement",
        ["Appendice Binder"]: "Policy Endorsement - Binder",
        ["Appendici"]: "Policy Endorsements",
        ["Appaltante"]: "Appaltante",
        ["Appartenenza"]: "Membership",
        ["Approva"]: "Approve",
        ["Approvata"]: "Approved",
        ["Approvato con parere negativo"]: "Assessed with negative comment",
        ["Approvato con parere positivo"]: "Assessed with positive comment",
        ["ApprovazioneAffidamento"]: "Limit of Exposure Validation",
        ["ApprovazionePolizza"]: "Policy Approved",
        ["APS-Emessa"]: "Approved Endorsement",
        ["APS-Preventivo"]: "Endorsement Draft",
        ["APS-Rifiutata"]: "Rejected Endorsement",
        ["Archeologo"]: "Archaeologist",
        ["Architetti"]: "Architect",
        ["Archivista"]: "Archivist",
        ["Area"]: "Area",
        ["AS-Attivo"]: "Active",
        ["AS-InAcquisizione"]: "Prospect",
        ["Ass"]: "Insurance Company",
        ["Assicuratori"]: "Insurers",
        ["AT-Annullamento"]: "Cancellation Endorsement",
        ["ATI"]: "T.A.C.",
        ["AT-PrecisazioniCondizioniContrattuali"]: "Endorsement of contractual conditions’ clarifications",
        ["AT-Proroga"]: "Extension Endorsement",
        ["Ats"]: "Ats",
        ["AT-Svincolo"]: "Release Endorsement",
        ["Attestazione SOA"]: "SOA Certification",
        ["Attestazione capacità finanziaria autotrasportatori"]: "Attestazione capacità finanziaria autotrasportatori",
        ["Attivita fiscale tributaria e di revisione in Enti Pubblici"]: "Tax and Audit tax activities in public bodies",
        ["AttivitaEsercitata"]: "Activity",
        ["AttivitaOspedaliera"]: "Hospital activity (public employee and other forms of collaboration)",
        ["AttivitaPatrocinatore"]: "Extrajudical Experts",
        ["Attivo circolante"]: "Current Assets",
        ["Attivo"]: "Active",
        ["Atto Costitutivo"]: "Articles of Association",
        ["AT-VariazioneRischio"]: "Risk variation Endorsement",
        ["Autentica digitale notarile"]: "Digital Authentication by the Notary",
        ["Autentica notarile"]: "Authentication by the Notary",
        ["Autorizzazione"]: "Authorization",
        ["Autorizzazioni"]: "Authorizations",
        ["Autoscuola"]: "Driving school",
        ["Avanti"]: "Forward",
        ["Avvocati"]: "Lawyer",
        ["Azienda"]: "Company",
        ["Azioni veloci"]: "Quick actions",
        ["Azioni"]: "Actions",
        ["AzioniJSON"]: "JSON Actions",
        ["Azionista"]: "Shareholder",
        ["BancaGare"]: "Tender's official terms database",
        ["Bando Gara"]: "Tender's official terms",
        ["Beneficenza"]: "Charity organization and promoter",
        ["Beneficiario"]: "Beneficiary",
        ["Bibliotecario"]: "Librarian",
        ["Bilancio"]: "Financial Statements",
        ["BilCon"]: "Company bound to issue consolidate balance sheets",
        ["BINDER ERRORE"]: "BINDER ERROR",
        ["Binder non ancora stipulato"]: "Binder not signed yet",
        ["Binder salvato correttamente con ID: {1-S}"]: "Binder successfully saved - ID: {1-S}",
        ["Binder stipulato"]: "Binder signed",
        ["Binder"]: "Binder",
        ["BINDER"]: "BINDER",
        ["BinderStato"]: "Binder Status",
        ["Biologo"]: "Biologist",
        ["BiologoEsclusioni"]: "Biologist (excluding genetic analyzes)",
        ["Bionaturopata"]: "Bionaturopath",
        ["Blocca"]: "Lock",
        ["Bozza accettata"]: "Draft Accepted",
        ["Bozza emessa"]: "Draft Issued",
        ["BrandManager"]: "Brand manager",
        ["Broker"]: "Broker",
        ["Broker assicurativi"]: "Insurance brokers",
        ["BS-Inserito"]: "Inserted",
        ["BS-Stipulato"]: "Signed",
        ["BUONA"]: "GOOD",
        ["Business Plan"]: "Business Plan",
        ["Calcola"]: "Calculate",
        ["Calcolato in base ai parametri"]: "Calculated based on the parameters",
        ["Calendario"]: "Calendar",
        ["Cambi stati per binder"]: "Binder - changing status",
        ["Cambi stati per gli affidamenti"]: "Limit of exposure - changing status",
        ["Cambi stati per le anagrafiche"]: "Details - changing status",
        ["Cambi stati per le deroghe"]: "Special Acceptance - changing status",
        ["Cambi stati per le polizze"]: "Policy - changing status",
        ["Cambi stati per le valutazioni"]: "Assessments - changing status",
        ["Cambia"]: "Change",
        ["CambioFideAffidamentoEsitoApprovazioneEsitoNonPermesso"]: "Limit of Exposure - status change is not allowed",
        ["CambioFideAffidamentoEsitoApprovazioneEsitoPartenzaNonTrovato"]: "Limit of Exposure - starting status not found",
        ["CambioFideAffidamentoEsitoApprovazioneNonPermesso"]: "Limit of Exposure - status change is not allowed",
        ["CambioPolizzaApprovazioneNonPermesso"]: "Policy  - status change is not allowed",
        ["CambioPolizzaApprovazionePartenzaNonTrovato"]: "Policy  - starting status not found",
        ["CambiStatiPerFideAffidamentoApprovazione"]: "Limit of Exposure - Status Changed",
        ["CambiStatiPerPolizzaApprovazione"]: "Policy - Status Changed",
        ["Camerale aggiornato"]: "Companies House - Updated",
        ["Cancella"]: "Cancel",
        ["CAP Immobile"]: "Real Estate Postcode",
        ["Cap"]: "Postcode",
        ["CAP"]: "Postcode",
        ["C.A.R."]: "C.A.R.",
        ["CAPImmobile"]: "Real Estate Postcode",
        ["Capogruppo"]: "Parent Company",
        ["Cardiochirurgia"]: "Cardiac Surgery",
        ["Cardiologia"]: "Cardiology",
        ["CaricaDocumento"]: "Upload the file",
        ["Caricamento dati polizza"]: "Loading Policy Data",
        ["Caricamento in differita, riprovare più tardi"]: "Loading delayed, try again later",
        ["Caricamento"]: "Loading",
        ["Caricamento..."]: "Loading...",
        ["Carta d'Identità"]: "National Identity Card",
        ["Carta Servizi"]: "Secure Card",
        ["CartaServizi"]: "Secure Card",
        ["Cartacea"]: "On paper",
        ["Categoria"]: "Category",
        ["Cauzione definitiva"]: "Performance Bond",
        ["Cauzione provvisoria forniture"]: "Bid Bond - Supply services",
        ["Cauzione provvisoria lavori"]: "Bid Bond - Projects (constructions)",
        ["Cauzione provvisoria servizi"]: "Bid Bond - Services",
        ["Cellulare"]: "Mobile",
        ["Cerca"]: "Search",
        ["Cerca scaduti"]: "Search expired",
        ["Certificato SAL"]: "Work Progress Report",
        ["Certificatore"]: "Energy Certificatory/Heating Systems",
        ["AutoscuolaPraticheAutomobilistiche"]: "Driving schools and car practices",
        ["MaestroSci"]: "Ski instructor",
        ["CertificatoreGiocattoli"]: "Toys Certifier",
        ["Certificazione Ambientale"]: "Certificate of Environmental Quality",
        ["CertificazioneAmbientale"]: "Environmental Certification",
        ["CertificazioneEnergetica"]: "Energy Certification",
        ["CExt1"]: "Plurality of Insured - Cross liability",
        ["CExt2"]: "Damages caused by design and calculations errors",
        ["CExt3"]: "Actions of third parties",
        ["CExt4"]: "Good faith",
        ["CExt5"]: "Vibration",
        ["CExt6"]: "Undergorund pipes or cables",
        ["CExt7"]: "Third party damages caused by pollution",
        ["CExt8"]: "Third party damages caused by dust",
        ["CExt9"]: "Higher costs for overtime work, night work, holiday work or high speed work",
        ["CExt10"]: "Suspension of works - risk of lay up",
        ["CExt11"]: "Experts and consultants' fees",
        ["CExt12"]: "Search of damage",
        ["CF"]: "Fiscal code",
        ["CFPIVA"]: "VAT Number",
        ["Change password"]: "Change password",
        ["ChirurgiaAppDigerente"]: "Digestive System Surgery",
        ["ChirurgiaGenerale"]: "General Surgery",
        ["ChirurgiaMaxFacc"]: "Maxillofacial Surgery",
        ["ChirurgiaPediatrica"]: "Paediatric surgery",
        ["ChirurgiaPlastica"]: "Plastic, Reconstructive and Aesthetic Surgery",
        ["ChirurgiaToracica"]: "Thoracic Surgery",
        ["ChirurgiaVascolare"]: "Vascular surgery",
        ["Chiudi documenti"]: "Close documents",
        ["Chiudi"]: "Close",
        ["ChiusuraBilancio"]: "Balance-sheet Date",
        ["CIG"]: "CIG",
        ["CIGNonTrovato"]: "CIG not found",
        ["Citta"]: "City",
        ["Classe Appartenenza Rifiuti"]: "Waste Management Class",
        ["Classificazione"]: "Classification",
        ["CoAssicurazione minima"]: "CoInsurance Minimum Share",
        ["CoAssicurazione solo delegataria"]: "CoInsurance Leader Share",
        ["CoAssicurazione: dati errati"]: "Co-insurance: wrong data",
        ["CoAssicurazione: Delegataria non specificata"]: "Co-insurance: Leading Insurer not defined",
        ["CoAssicurazione: Quote totali inferiori al 100%"]: "Co-insurance: CoAssicurazione: total share lower than 100%",
        ["CoAssMinimaSoloDelegataria"]: "{1-P}{2-S}",
        ["Codice binder"]: "Binder Number",
        ["Codice controllo"]: "Check code",
        ["CodiceBinder"]: "Binder Number",
        ["CodiceBinder{1-S}Compagnia{2-S}DataEffetto{3-D}DataFine{4-D}"]: "Binder n. {1-S} Company {2-S} Start Date {3-D} End Date {4-D}",
        ["CodiceFiscale"]: "Fiscal Code",
        ["Cognome"]: "Surname",
        ["Collapse"]: "Collapse",
        ["Collaudi"]: "Test",
        ["Collocamento"]: "Employment Agency",
        ["ColpaGrave"]: "Gross Negligence",
        ["Coltivazione Cave"]: "Cultivation Bond",
        ["Commenti"]: "Notes",
        ["CommentiUW"]: "UW Notes",
        ["Commercialisti"]: "Accountant",
        ["Commercio"]:
            "Wholesale and Retail Trade, Handicraft Activities not similar to the previous ones (car body shops, vehicle repair, laundries, hairdressers, bakers, confectioners, etc.), Transportation, Warehousing, Communications",
        ["Commission Calculation Method"]: "Commission Calculation Method",
        ["Compagnia"]: "Company",
        ["Comparatore RCP"]: "PI Comparator",
        ["Preventivatore RCP"]: "PI Quote",
        ["Comparison issued"]: "Comparison issued",
        ["Completo"]: "Complete",
        ["ComprimiInfo"]: "Hide Info",
        ["Comuni"]: "Municipality",
        ["Confirm"]: "Confirm",
        ["Confirm Data"]: "Confirm Data",
        ["Confirm password"]: "Confirm password",
        ["Consap"]: "Consap",
        ["Consolida compagnia"]: "Generate Draft",
        ["Consolida sottoscrittore"]: "Send request to the underwriter",
        ["Consorzio"]: "Consortia and similar ventures which any of the above mentioned operations or companies is party",
        ["ConsulenteAlim"]: "Food Consultant",
        ["ConsulenteFam"]: "Counsellor/Family Counsellor",
        ["ConsulenteImmagine"]: "Image Consultant",
        ["ConsulentePubb"]: "Advertising Consultant/Marketing Advisor",
        ["ConsulenteLegale"]: "Legal Consultant/business lawyer",
        ["ConsulenzaAmm"]: "Business administrative and management consultancy and business planning services",
        ["ConsulenteMB"]: "Trademark and patent consultant",
        ["OrganizzatoreEventi"]: "Event/Wedding planner",
        ["PromozioneServizi"]: "Promotion of certification and training services",
        ["OperatoreSocio"]: "Social care worker (Social welfare operator)",
        ["ConsulentiDelLavoro"]: "Labour Consultant",
        ["ConsulenzaAdempimentiBurocratici"]: "Bureaucratic advice and compliance",
        ["Consulta"]: "Details",
        ["Contraente"]: "Policyholder",
        ["Contraente/Coobbligato"]: "Policyholder/Co-obligor",
        ["Contraente/Coobbligato/Ati"]: "Policyholder/Co-obligors/Ati",
        ["ContrattiInVigore"]: "Contracts still in force",
        ["ContrattoAppalto"]: "Contratto Appalto",
        ["Contratto Aggiudicazione"]: "Contract Award Tender",
        ["Contratto Binder"]: "Contract - Binder",
        ["Contratto Oggetto"]: "Object of the Contract",
        ["Contratto Preliminare Vendita"]: "Preliminary Sales Contract",
        ["Contributi"]: "Grant bonds",
        ["ContributoConsap"]: "Consap Fee",
        ["Controllare la propria casella email"]: "Check your email",
        ["ControllareLaPropriaCasellaEmail"]: "Check your email",
        ["Controllo validità fideiussione"]: "Bond Validity Check",
        ["Coobbligati per affidamenti"]: "Limit of Exposure Co-obligors",
        ["Coobbligati per polizze"]: "Policies Co-obligors",
        ["Coobbligati"]: "Co-obligors",
        ["Coobbligazioni"]: "Collaterals",
        ["CoordinatoreSicurezza"]: "Safety Coordinator D.Lgs 81/2008 (ex D.Lgs 626/94)",
        ["Copertura patrimoniale"]: "Limit of Exposure VS Net Capital",
        ["Copia Agenzia"]: "Copy for the Agent",
        ["Copy to empty fields"]: "Copy to empty fields",
        ["Copy on the same company"]: "Copy on the same company",
        ["Copy to the same product"]: "Copy to the same product",
        ["Copy values"]: "Copy values",
        ["CopyWriter"]: "Copy Writer/Multimedia Director/Director of photography/Art Director",
        ["Corriere"]: "Express Mail",
        ["CostoAggiudicazione"]: "Insured Sum",
        ["CostoOpera"]: "Cost of the work",
        ["Coverholder JU"]: "Coverholder JU",
        ["Coverholder MD"]: "Coverholder MD",
        ["Coverholder SU"]: "Coverholder SU",
        ["Coverholder"]: "Coverholder",
        ["CQS"]: "CQS - Loan Protection",
        ["Creato"]: "Creation date",
        ["CreaUtente"]: "Save User",
        ["Creazione affidamento"]: "Limit of Exposure - Request",
        ["CreazioneAffidamentoDaCompagniaACoverholderOBroker"]: "Limit of Exposure Insurer - Coverholder - Broker added",
        ["CreazioneSessione"]: "Session Creation",
        ["Credito"]: "Banking operations",
        ["CreditoConsumo"]: "Consumer Credit",
        ["CreditoPersonale"]: "Personal Credit",
        ["CSA-Aggiorna"]: "Update",
        ["CSA-Blocco"]: "Lock",
        ["CSA-Dipendenza"]: "Dependency",
        ["CSP-FideAffidamentoApprovaCompagnia"]: "Company Approval",
        ["CSP-FideAffidamentoApprovaCoverholder"]: "Coverholder Approval",
        ["Curatore"]:
            "Liquidator or bankruptcy trustee of companies, companies, associations, foundations or other bodies other than listed companies in the financial markets / credit or banking / financial / insurance companies / companies that make use of the risk capital market / companies held in the consolidated financial statements / consortia",
        ["CurrentMonth"]: "Current month",
        ["CurrentWeek"]: "Current week",
        ["Da approvare"]: "To be approved",
        ["Da"]: "From",
        ["DanniAttrezzature"]: "Damage to Equipment",
        ["Data aggiudicazione"]: "Awarding Date",
        ["Data collaudo"]: "Test Date",
        ["Data concessione"]: "Grant Date",
        ["Data di acquisizione/fusione"]: "Acquisition/merging date",
        ["Data di ammissione"]: "Admission date",
        ["Data di trasformazione"]: "Date",
        ["Data effetto"]: "Start Date",
        ["Data emissione"]: "Date of Issuing",
        ["Data fine"]: "Termination Date",
        ["DataFineManutenzione"]: "Termination Date of the Maintenance",
        ["Data gara"]: "Tender Date",
        ["Data Inizio Proroga"]: "Starting Date of the Extension",
        ["DataInizioManutenzione"]: "Starting Date of the Maintenance",
        ["Data nascita"]: "Date of Birth",
        ["Data presentazione"]: "Submission Date",
        ["Data rilascio"]: "Issued",
        ["Data scadenza"]: "Date of Expiry",
        ["Data sottoscrizione"]: "Underwriting date",
        ["Data Sottoscrizione"]: "Underwriting Date",
        ["Data stipula"]: "Signing Date",
        ["Data svincolo"]: "Date of Bond Release",
        ["Data valutazione"]: "Date of Assessment",
        ["Data"]: "Date",
        ["DataAggiudicazione"]: "Awarding Date",
        ["DataCollaudo"]: "Test Date",
        ["DataConcessione"]: "Grant Date",
        ["DataCostituzione"]: "Year of Establishment",
        ["DataEffetto"]: "Start Date",
        ["DataEmissione"]: "Date of Issue",
        ["DataEvento"]: "Date of the Event",
        ["DataFine"]: "End Date",
        ["DataFineCopertura"]: "Ending date of coverage",
        ["DataFineLavori"]: "End of the works",
        ["DataGara"]: "Tender Date",
        ["DataInizio"]: "Starting Date",
        ["DataInizioCopertura"]: "Starting date of coverage",
        ["DataInizioLavori"]: "Starting date of the works",
        ["DataInizioProroga"]: "Starting Date of the Extension",
        ["DataNotizie"]: "News Date",
        ["DataPresentazione"]: "Submission Date",
        ["DataRichiesta"]: "Date of Request",
        ["DataRiferimento"]: "Reference Date",
        ["DataScadenza"]: "Expiry Date",
        ["DataSvincolo"]: "Date of Bond Release",
        ["DataUpload"]: "Upload Date",
        ["DataValidita"]: "Validity Date",
        ["DateNonCorrette"]: "Wrong dates",
        ["Dati deroga"]: "Special Acceptance Data",
        ["Dati economici salvati correttamente con ID: {1-S}"]: "Financials successfully saved - ID: {1-S}",
        ["Dati economici"]: "Financials",
        ["DATI ECONOMICI"]: "FINANCIALS",
        ["Dati fideiussione"]: "Bond Data",
        ["Dati Fideiussione"]: "Bond Data",
        ["Dati non presenti"]: "Data not found",
        ["Dati economici estratti correttamente"]: "Financials correctly extracted",
        ["Dati estratti correttamente"]: "Data correctly extracted",
        ["DatiEconomiciEstrattiCorrettamente"]: "Financials correctly extracted",
        ["DatiEmissione"]: "Issuing Data",
        ["DatiEstrattiCorrettamente"]: "Data correctly extracted",
        ["DatiProfessionali"]: "Professional Info",
        ["Dato economico"]: "Financials",
        ["Dazi Doganali"]: "Custom's Duty Bond",
        ["DD/MM/YYYY"]: "MM/DD/YYYY",
        ["Debiti a breve"]: "Current Liabilities",
        ["DebitiBreve"]: "Current Liabilities",
        ["DebitiLungo"]: "Total long-term debts (over 12 months)",
        ["Delegataria"]: "Leading Insurer",
        ["Denominazione"]: "Name",
        ["DenunciaCompagnia"]: "Complaint to the Company",
        ["Dermatologia"]: "Dermatology and Venereology (excluding Aesthetic Medicine)",
        ["DermatologiaVenereologia"]: "Dermatology and Venereology",
        ["DermoPigmentisti"]: "Permanent make-up",
        ["Deroga fideiussione"]: "Special Acceptance Bond",
        ["Deroga polizza"]: "Special Acceptance Policy",
        ["Deroga"]: "Special Acceptance",
        ["DEROGA"]: "SPECIAL ACCEPTANCE",
        ["DerogaStato"]: "Special Acceptance Status",
        ["Deroghe"]: "Special Acceptance",
        ["Descrizione funzione"]: "Description of the Functionality",
        ["Descrizione"]: "Description",
        ["DescrizioneAltreAttivita"]: "Description other activities",
        ["DescrizioneAzionista"]: "Shareholder description",
        ["DescrizioneEvento"]: "Event description",
        ["DescrizioneLavori"]: "Job description",
        ["DescrizioneOpera"]: "Work description",
        ["DesignerInterni"]: "Interior designer",
        ["Dettagli utente"]: "User details",
        ["DettagliRifiutoCopertureAssicurative"]: "Details Insurance Coverage Rejection",
        ["DFIDE-Anni"]: "Years",
        ["DFIDE-Giorni"]: "Days",
        ["DFIDE-Mesi"]: "Months",
        ["Diabetologia"]: "Diabetes and Metabolic diseases",
        ["Dietista"]: "Dietician",
        ["Dietologia"]: "Dietology/Nutrition Science",
        ["Dietologo"]: "Dietician",
        ["Dighe"]: "Dams",
        ["Digita e seleziona..."]: "Type and select...",
        ["Digitale"]: "Digital",
        ["Dipendente"]: "National Health Service or hospital employee",
        ["DirezioneCantiere"]: "Direction of building site",
        ["DirezioneLavori"]: "Supervision",
        ["Diritti emissione"]: "Policy Fees",
        ["Diritti"]: "Policy Fees",
        ["DirittiEmissione"]: "Policy Fees",
        ["Disegnatore"]: "Industrial Designer",
        ["DissociaDaPolizza"]: "Dissociate from Policy",
        ["Disdetta"]: "Cancellation",
        ["Distribuzione"]: "Distribution/Marketing/Installation/Maintanance/Transfer of: Hardware produced by third party",
        ["Ditta individuale"]: "Sole Proprietorship Company",
        ["DittaEDP"]: "Does the Proponent use the services of an EDP company and possess the majority?",
        ["DittaIndividuale/Professionista"]: "Legal Person",
        ["DOCUMENTI "]: "Documents",
        ["Documenti"]: "Documents",
        ["Documento Amministratore"]: "Legal Representative ID",
        ["Documento Coobbligati"]: "Co-obligors' National Identity Cards",
        ["Documento Svincolo"]: "Bond Release Document",
        ["Documento validato correttamente"]: "File validated successfully",
        ["Documento"]: "Document",
        ["DomandaCoordinatoreSicurezza"]: "Safety Coordinator D.Lgs 81/2008 (ex D.Lgs 626/94)",
        ["Domicilio"]: "Domicile",
        ["Domini"]: "Domain services",
        ["Doppiatore"]: "Dubber",
        ["DownloadReport"]: "Download report",
        ["DR-Approvata"]: "Approved",
        ["DR-DaApprovare"]: "To be approved",
        ["DR-Passa"]: "Upgrade",
        ["DR-Rifiutata"]: "Declined",
        ["DT-Fideiussione"]: "Bond",
        ["DT-Polizza"]: "Policy",
        ["Durata"]: "Duration",
        ["DURC"]: "DURC - Fiscal Declaration",
        ["E' richiesta la selezione di un file"]: "Selection of a file is required",
        ["E' stato denunciato alla Compagnia?"]: "Complaint to the Company",
        ["E' stato inserito un valore inferiore al limite MINIMO accettabile: {1-R}"]: "A value below the acceptable MINIMUM limit has been entered:{1-R}",
        ["E' stato inserito un valore superiore al limite MASSIMO accettabile: {1-R}"]: "A value above the acceptable MAXIMUM limit has been entered:{1-R}",
        ["Ecologo"]: "Ecologist",
        ["Economista"]: "Economist",
        ["Editore"]: "Editor",
        ["EDP"]: "EDP",
        ["Elaborazione"]: "Data processing by third party, excluding payment processing i.e. banking online betting and gambling programs, payPal, etc.",
        ["Elimina"]: "Delete",
        ["Email"]: "Email",
        ["Email us"]: "Email us!",
        ["EMAS"]: "Environmental Certifications - EMAS",
        ["Ematologia"]: "Hematology",
        ["Emetti"]: "Issue",
        ["Emetti quietanza"]: "Issue a receipt",
        ["Emettitore"]: "From",
        ["Endocrinologia"]: "Endocrinology and Metabolic diseases",
        ["Endorsement number"]: "Endorsement number",
        ["Endorsement system"]: "Endorsement system",
        ["Enologo"]: "Enologist",
        ["Ente Pubblico"]: "Public Authority",
        ["Enter the address"]: "Enter the address...",
        ["Enti"]: "Authority",
        ["Epatologia"]: "Hepatology",
        ["Equilibrio patrimoniale"]: "Liabilities VS Net Capital",
        ["Equini"]: "Professional activity with livestock and equine",
        ["Erborista"]: "Herbalist",
        ["Errore caricamento dati"]: "Loading error",
        ["Errore lettura"]: "Reading Error",
        ["Errore"]: "Error",
        ["ERRORE"]: "ERROR",
        ["ErroreAggiornamentoAutorizzazione"]: "Authorization Updating Error",
        ["ErroreAggiornamentoFideCoobbligato"]: "Updating Error",
        ["ErroreAggiornamentoGaranzia"]: "Updating Subject of the Cover Error",
        ["ErroreAggiornamentoLimite"]: "Limit Updating Error",
        ["ErroreAggiornamentoProvvigione"]: "Updating Commission Error",
        ["ErroreAggiornamentoUtente"]: "User Updating Error",
        ["ErroreAnagMultipli"]: "Error: there are multiple clients related to the login",
        ["ErroreAnagNonPresente"]: "Error: there are no clients related to the login",
        ["ErroreAzioneAbilitata"]: "Error: permission denied",
        ["ErroreBuildSignProcedure"]: "Error sending request for digital signature",
        ["ErroreCalcola"]: "Calculation Error",
        ["ErroreCambioPolizzaApprovazioneNonPermesso"]: "Error Policy  - status change is not allowed",
        ["ErroreCambioStatoDuplicatoGruppo"]: "Errore: duplicate status",
        ["ErroreCambioStatoNonPermesso"]: "Error: changing status is forbidden",
        ["ErroreCancellazioneBinder"]: "Binder Deleting Error",
        ["ErroreCartaServizi"]: "Secure Card Error",
        ["ErroreCartaServzi"]: "Secure Card Error",
        ["ErroreCoAssicurazione"]: "Co-Insurance Error",
        ["ErroreEmissionePolizza"]: "Policy Issuing Error",
        ["ErroreFileNonEliminabile"]: "Error: file cannot be deleted",
        ["ErroreFileNonPresente"]: "Error: file not found",
        ["ErroreInserimentoAffidamento"]: "Adding Limit of Exposure Error",
        ["ErroreInserimentoAnagrafica"]: "Adding Details Error",
        ["ErroreInserimentoAutorizzazione"]: "Authorization Adding Error",
        ["ErroreInserimentoBinder"]: "Adding Binder Error",
        ["ErroreInserimentoBinderVisibile"]: "Adding Visible Binder Error",
        ["ErroreInserimentoDatoEconomico"]: "Adding Financials Error",
        ["ErroreInserimentoDeroga"]: "Adding Special Acceptance Error",
        ["ErroreInserimentoFideCoobbligato"]: "Adding Co-obligors Error",
        ["ErroreInserimentoFideValutazione"]: "Adding Assessment Error",
        ["ErroreInserimentoFile"]: "Adding File Error",
        ["ErroreInserimentoGaranzia"]: "Adding Subject of the Cover Error",
        ["ErroreInserimentoPolizza"]: "Adding Policy Error",
        ["ErroreInserimentoProvvigione"]: "Adding Commission Error",
        ["ErroreInserimentoTassi"]: "Adding Rates Error",
        ["ErroreInserimentoUtente"]: "Adding User Error",
        ["ErroreLettura"]: "Reading Error",
        ["ErroreLimiteBinderAccessori  (oltre il proprio limite)"]: "Error Binder Admin Fees",
        ["ErroreLimiteBinderDirittiFissi  (oltre il proprio limite)"]: "Error Binder Policy Fees",
        ["ErroreLimiteBinderPremioMinimo  (oltre il proprio limite)"]: "Error Binder Minimum Premium",
        ["ErroreLimiteBinderSingoloProdotto  (oltre il proprio limite)"]: "Error Binder Product Limit",
        ["ErroreLimiteGruppo  (oltre il proprio limite)"]: "Error Group Limit",
        ["ErroreLimiteGruppoNonSettato"]: "Error Group Limit undefined",
        ["ErroreLimiteTassiTassoMin  (oltre il proprio limite)"]: "Error Minimum Rates",
        ["ErroreLoginOTPCodice"]: "OTP Code Login Error",
        ["ErroreLoginOTPEMail"]: "OTP Email Login Error",
        ["ErroreLoginOTPLog"]: "OTP Log Login Error",
        ["ErroreLoginOTPScaduto"]: "Login Error - OTP Expired",
        ["ErroreLoginPasswordScaduta"]: "Expired Password Login - Check your email",
        ["ErrorePremioMinimo"]: "Minimum premium Error",
        ["ErroreRecuperaPasswordAggiornamentoUtente"]: "User Updating - Recovering Password Error ",
        ["ErroreRecuperaPasswordDoppiaRichiesta"]: "Recovering Double Password Error",
        ["ErroreRecuperaPasswordEMail"]: "Recovering Password Email Error",
        ["ErroreRecuperaPasswordLog"]: "Recovering Password Log Error",
        ["ErroreRecuperaPasswordLogin"]: "Recovering Password Login Error",
        ["ErroreRecuperaPasswordScaduta"]: "Recovering Expired Password Error",
        ["ErroreSanzioni:{1-S}"]: "Errore sanctions search: {1-S}",
        ["ErroreSessioneDataRiferimento"]: "Reference Date Session Error",
        ["ErroreSicurezza"]: "Safety Error",
        ["ErroreSovrapposizioneBinder"]: "Error: Binder overlapped",
        ["ErroreSovrapposizioneFideAffidamento"]: "Error: Limit of exposure overlapped",
        ["ErroreTassoMin"]: "Minimum Rates Error",
        ["Esiste già un capogruppo impossibile impostarne un secondo"]: "A new leader of the A.T.I .- Group of companies cannot be added, as one has already been provided",
        ["Esiste già un capogruppo, impossibile impostarne un secondo"]: "A new leader of the A.T.I .- Group of companies cannot be added, as one has already been provided",
        ["Esiste già una deroga in stato di approvazione, impossibile inserirne un'altra"]: "Extension request not available. There is another Extension Request still pending.",
        ["Esiste già una sede legale, impossibile impostarne una seconda"]: "A new Registered Office cannot be added, as one has already been provided",
        ["EsisteGiaUnaSedeLegaleImpossibileImpostarneUnaSeconda"]: "A new Registered Office cannot be added, as one has already been provided",
        ["Esistono azionisti che detengono più del 10% del capitale della società?"]: "Are there shareholders who hold more than 10% of the company's capital?",
        ["Esito"]: "Outcome",
        ["EspandiInfo"]: "Expand Info",
        ["EstensioneEffettuazioneOpereAltoRischio"]: "High risk works",
        ["Estetista"]: "Beautician",
        ["Estrai dati"]: "Extract data",
        ["Estrazione dati da ente esterno"]: "Download from external database",
        ["Estrazione"]: "Mining Extraction, Other Extraction Industries, Construction",
        ["EtichettaATI"]: "Label",
        ["Ex Cliente"]: "Former Client",
        ["Excel"]: "Excel",
        ["Expand"]: "Expand",
        ["Extension Endorsement"]: "Extension Endorsement",
        ["F-730"]: "730",
        ["FAA-ApprovatoNegativo"]: "Assessed with negative comment",
        ["FAA-ApprovatoPositivo"]: "Assessed with positive comment",
        ["FA-Affidamento"]: "Limit of Exposure",
        ["FAA-Proposta"]: "Proposal",
        ["FAE-ApprovatoNegativo"]: "Assessed with negative comment",
        ["FAE-ApprovatoPositivo"]: "Assessed with positive comment",
        ["FAE-CreazioneAffidamento"]: "Limit of Exposure - Request",
        ["FAE-Morto"]: "Ended",
        ["FAE-PreProposta"]: "Pre Proposal",
        ["FAE-Proposta"]: "Proposal",
        ["FAE-PropostaRiapertura"]: "Submission Proposal Reopening",
        ["FAE-Revisione"]: "Review",
        ["FAE-Rifiuto"]: "Declined",
        ["FAE-Rinnovo"]: "Renewal",
        ["FAE-Sospensione"]: "Limit of Exposure - Sospended",
        ["FAE-Sottoposto"]: "Being underwritten",
        ["FAE-Sottoscritto"]: "Underwritten",
        ["F-Altro"]: "Other",
        ["FA-NonProvvisorie"]: "NO Bid Bonds",
        ["F-Appendice"]: "Endorsement",
        ["F-AppendiceBinder"]: "Policy Endorsement - Binder",
        ["FA-Provvisorie"]: "Bid Bonds",
        ["Farmacista"]: "Pharmacist",
        ["Farmacologia"]: "Pharmacology",
        ["F-AttoCostitutivo"]: "Articles of Association",
        ["Fattura"]: "Invoice",

        ["Fatturato"]: "GWP (including taxes)",
        ["NuovoFatturatoPassatoEsercizio"]: "New Turnover",
        ["FatturatoPassatoEsercizio"]: "Turnover",
        ["FatturatoStimaEsercizioCorrente"]: "Forecast Turnover",
        ["FattureDatiEconomici"]: "Fatture Dati Economici",
        ["F-Autorizzazione"]: "Authorization",
        ["Fax"]: "Fax",
        ["F-BandoGara"]: "Tender's official terms",
        ["F-Bilancio"]: "Financial Statements",
        ["F-BusinessPlan"]: "Business Plan",
        ["FC-Anag"]: "Details",
        ["F-CartaIdentita"]: "IC",
        ["FC-Binder"]: "Binder",
        ["FC-DatoEconomico"]: "Financials",
        ["F-CertificatoSal"]: "Work Progress Report",
        ["F-CertificazioneAmbientale"]: "Certificate of Environmental Quality",
        ["FC-FideAffidamento"]: "Limit of Exposure",
        ["FC-FideCoobbligati"]: "Co-obligors",
        ["FC-FideValutazione"]: "Assessment",
        ["F-ClasseAppartenenzaRifiuti"]: "Waste Management Class",
        ["F-Collaudo"]: "Test",
        ["F-ContrattoAggiudicazione"]: "Contract Award Tender",
        ["F-ContrattoBinder"]: "Contract - Binder",
        ["F-ContrattoOggetto"]: "Object of the Contract",
        ["F-ContrattoPreliminareVendita"]: "Preliminary Sales Contract",
        ["F-Convenzione"]: "Agreement",
        ["F-Coobbligazioni"]: "Collaterals",
        ["F-CopiaAgenzia"]: "Copy for the Agent",
        ["FC-Polizza"]: "Policy",
        ["F-DisciplinareGara"]: "Competition Regulations",
        ["F-Documento"]: "Document",
        ["F-DocumentoSvincolo"]: "Bond Release Document",
        ["F-DURC"]: "DURC - Fiscal Declaration",
        ["Femmina"]: "Female",
        ["Ferrovie"]: "Railways",
        ["F-Fattura"]: "Invoice",
        ["FideAffidamento"]: "limit of Exposure",
        ["FideAffidamentoApprovazione - Approvato con parere negativo"]: "Limit of Exposure - Assessed with negative comment",
        ["FideAffidamentoApprovazione - Approvato con parere positivo"]: "Limit of Exposure - Assessed with positive comment",
        ["FideAffidamentoApprovazione - Proposta affidamento"]: "Limit of Exposure - Proposal",
        ["FideAffidamentoDatiPOS"]: "POS Data on Binders",
        ["FideAffidamentoEsito"]: "Outcome",
        ["FideAffidamentoEsitoApprovazioneCommenti"]: "Limit of Exposure - Comments Approved",
        ["FideAffidamentoPadreNonPresente"]: "Limit of Exposure not found",
        ["FideAffidamentoSenzaSOAValidata"]: "Limit of Exposure without SOA - Validated",
        ["FideAffidamentoSenzaValutazioneAccettata"]: "Limit of Exposure without assessment - Approved",
        ["FideCoobbligati"]: "Collaterals",
        ["Fideiussioni non provvisorie"]: "Exposure Limit - No Bid Bonds",
        ["Fideiussioni provvisorie"]: "Exposure Limit - Bid Bonds",
        ["Fideiussioni"]: "Surety Bonds",
        ["FideValutazione"]: "Assessment",
        ["FideValutazioneEsito"]: "Outcome",
        ["File caricato"]: "File uploaded",
        ["File validato"]: "File validated",
        ["FS-Inviato"]: "File sent",
        ["FS-Firmato"]: "File signed",
        ["Firma"]: "Sign",
        ["Firma con marca"]: "Sign with timestamp",
        ["File {1-S} was rejected."]: "File {1-S} was rejected.",
        ["File {1-S} was successfully added."]: "File {1-S} was successfully added.",
        ["Fill in the missing fields"]: "Fill in the missing fields",
        ["Fin"]: "Financial companies, of any kind",
        ["Fine"]: "End",
        ["FineCopertura"]: "Ending date of coverage",
        ["FirmaDigitale"]: "Digital signature",
        ["Fisiatria"]: "Physical medicine and rehabilitation/Physiatry",
        ["Fisioterapista"]: "Physiotherapist",
        ["F-ISO14001"]: "ISO14001",
        ["F-ISO14067"]: "ISO14067",
        ["F-ISO18001"]: "ISO18001",
        ["F-ISO9000"]: "ISO9001",
        ["Flessibilita"]: "Flexibility",
        ["F-ModelloIVA"]: "VAT Statement",
        ["F-Mutuo"]: "Mortgage",
        ["Foniatria"]: "Phoniatrics and Audiology",
        ["Force Legal Interest Amount"]: 'Force "Legal Interest Amount"',
        ["Formatore"]: "Trainers in public and private professional courses (i.e. courses financed with EU funds)",
        ["Fornitura"]: "Internet services",
        ["Fotografo"]: "Photographer",
        ["F-Passaporto"]: "Passaport",
        ["F-Patente"]: "Driving License",
        ["F-PermessoCostruire"]: "Permission to build",
        ["F-PolizzaEmessaP7M"]: "Issued policy (P7M)",
        ["F-PolizzaEmessaPDF"]: "Issued policy (PDF)",
        ["F-Privacy"]: "Privacy",
        ["F-ProgettoContributo"]: "Grant Project",
        ["FR-AffNonProvvisorie"]: "FR-AffNonProvvisorie",
        ["FR-AffProvvisorie"]: "FR-AffProvvisorie",
        ["Franchigia"]: "Deductible",
        ["FranchigiaGaranzia"]: "Deductible",
        ["FraseMandanti"]: "Employees/Staff members (as by list sent to the Authority)",
        ["FraseRPE1"]: "The activities and functions listed below if not selected are not covered",
        ["FraseRPE2"]:
            "Please note that the function of Statutory Auditor for the entities itemized below is excluded from the insurance. Should any of the listed Professionals be in charge of such a function, please specify below for which entities. Underwriters reserve the right to consider a possible extension there to.",
        ["FraseSoggetti"]: "Please add  other subjects insured in addition to the Proponent/Insured",
        ["Frazionamento"]: "Split-up",
        ["FR-CoobAff"]: "FR-CoobAff",
        ["FR-CoobPol"]: "FR-CoobPol",
        ["F-Rendicontazione"]: "Reporting",
        ["F-ReportFatturaDatiEconomici"]: "Bill Report Economic Data",
        ["F-RicevutaPagamento"]: "Receipt of Payment",
        ["FR-NonProvvisorie"]: "FR-NonProvvisorie",
        ["FR-Provvisorie"]: "FR-Provvisorie",
        ["FS-Caricato"]: "Uploaded",
        ["F-SchemaFide"]: "Schema Tipo",
        ["F-SOA"]: "SOA",
        ["FS-Validato"]: "Validated",
        ["F-UnicoPersone"]: "Individual's Income Tax Return",
        ["F-UnicoSocieta"]: "Company's Income Tax Return",
        ["Funivie"]: "Cable railways",
        ["Funzione che aggiorna i dati su altre tabelle"]: "Function that updates data on other tables",
        ["Funzione che blocca il cambio stato"]: "Function that blocks the change of state",
        ["Funzione che controlla dipendenze con altre tabelle"]: "Function that checks dependencies with other tables",
        ["Funzione"]: "Functionality",
        ["Funzioni Pubbliche"]: "Public Functions",

        ["FunzioniPubbliche"]: "Public Functions",

        ["Fusioni"]: "Mergers and Acquisitions, Operations on Companies, Associations, Companies",
        ["F-VisuraCamerale"]: "Chamber of Commerce Company Registration",
        ["F-VisuraCatastale"]: "Cadastral Certificate",
        ["Gallerie"]: "Tunnels",
        ["Garanzie"]: "Guarantees",
        ["GARANZIE"]: "Guarantees",
        ["GaranzieAggiornateCorrettamente"]: "Guarantees successfully updated",
        ["GARANZIEERRORE"]: "Error - Guarantees",
        ["Garanzia Manutenzione"]: "Guaranty Maintenance",
        ["GaranzieNonImpostate"]: "Set the guarantees first",
        ["Gastroenterologia"]: "Gastroenterology",
        ["GeneraCartaServizi"]: "Generate Secure Card",
        ["GENERAZIONE CARTA SERVIZI"]: "Secure Card Issuing",
        ["GenerazioneCartaServiziAvvenutaConSuccesso"]: "Secure Card successfully issued",
        ["GeneticaMedica"]: "Medical Genetics",
        ["Geografo"]: "Geographer",
        ["Geologi"]: "Geologists",
        ["Geometri"]: "Surveyors",
        ["Geriatria"]: "Geriatrics",
        ["Gestione accoppiamenti Binder, Garanzie, Funzioni di calcolo"]: "Management of binders, guarantees, calculation functions",
        ["Gestione affidamenti"]: "Limit of Exposure - Functionalities",
        ["Gestione anagrafica"]: "Details- Functionalities",
        ["Gestione binder"]: "Binder- Functionalities",
        ["Gestione contabilità"]: "Accounting management",
        ["Gestione coobbligati"]: "Co-obligors- Functionalities",
        ["Gestione dati economici"]: "Financials- Functionalities",
        ["Gestione del proprio utente"]: "Management of own user profile",
        ["Gestione documenti"]: "Files- Functionalities",
        ["Gestione Garanzie dei prodotti"]: "Management of products' guarantees",
        ["Gestione gruppi"]: "Groups- Functionalities",
        ["Gestione menu a tendina"]: "Dropdown List- Functionalities",
        ["Gestione news"]: "News - Functionalities",
        ["Gestione password"]: "Password - Functionalities",
        ["Gestione polizze fideiussioni"]: "Bonds management",
        ["Gestione polizze RCP"]: "PI policy management",
        ["Gestione polizze"]: "Policies - Functionalities",
        ["Gestione prodotti"]: "Products - Functionalities",
        ["Gestione provvigioni"]: "Commision- Functionalities",
        ["Gestione Rifiuti"]: "Waste Management Bond",
        ["Gestione tabelle di sistema"]: "Table management - Functionalities",
        ["Gestione tassi"]: "Rates- Functionalities",
        ["Gestione utenti"]: "Users- Functionalities",
        ["Gestione valutazioni"]: "Assessments- Functionalities",
        ["GestioneGaranzie"]: "Guarantees - Functionalities",
        ["Giardiniere"]: "Gardener",
        ["GinecologiaOstetricia"]: "Gynecology and Obstetrics",
        ["Giornalista"]: "Journalist/Publicist",
        ["Giorni"]: "Days",
        ["GL-AffidamentoNonProvvisorie"]: "Limit of Exposure accepted for NO Bid Bonds",
        ["GL-AffidamentoProvvisorie"]: "Limit of Exposure for Bid Bonds",
        ["Gli Amministratori ed i Componenti aziendali anche con riferimento alla Società, sono a conoscenza di fatti che potrebbero dare luogo a richieste di RISARCIMENTO o procedimenti penali anche in materia di diritto del lavoro?"]:
            "Are the Directors and the Company Components also with reference to the Company, are they aware of facts that could give rise to requests for compensation or criminal proceedings also in the field of labor law?",
        ["Gli amministratori ed i componenti aziendali sono mai stati sottoposti a procedimenti penali?"]: "Have administrators and company members ever been subjected to criminal proceedings?",
        ["GL-Massimale"]: "Limit of Authority per User ",
        ["GL-Premio"]: "Premium",
        ["GO"]: "GO",
        ["Grafici"]: "Charts",
        ["Grafologo"]: "Graphologist",
        ["Gruppi"]: "Groups",
        ["GRUPPO ERRORE"]: "GROUP ERROR ",
        ["Gruppo salvato correttamente con ID: {1-S}"]: "Group successfully saved - ID: {1-S}",
        ["Gruppo"]: "Group",
        ["GRUPPO"]: "GROUP",
        ["Gruppo1"]: "Admin",
        ["Gruppo10"]: "Local Producer MD",
        ["Gruppo11"]: "Insurer Senior",
        ["Gruppo12"]: "Insurer Junior",
        ["Gruppo13"]: "Local Producer User",
        ["Gruppo17"]: "Insurer",
        ["Gruppo2"]: "Reader",
        ["Gruppo3"]: "Tester",
        ["Gruppo4"]: "Viewer",
        ["Gruppo6"]: "Insurer MD",
        ["Gruppo7"]: "Coverholder MD",
        ["Gruppo8"]: "Coverholder Senior",
        ["Gruppo9"]: "Coverholder Junior",
        ["HACCP"]: "HACCP/Accident prevention",
        ["Hide"]: "Hide",
        ["Home"]: "Home",
        ["HR"]: "HR",
        ["ID"]: "ID",
        ["ID_AnagBeneficiario"]: "Beneficiary",
        ["ID_AnagContraente"]: "Policyholder",
        ["ID_Gruppo"]: "ID Group",
        ["ID_ModalitaEmissione"]: "Issuing Way",
        ["ID_Polizza"]: "ID Policy",
        ["ID_TipoProdotto"]: "Product Type",
        ["ID_TipoStatoArrivo"]: "Starting Status",
        ["Identificativo"]: "Identifier",
        ["Igiene"]: "Preventive medicine and hygiene",
        ["IgienistaDentale"]: "Dental hygienist",
        ["IgienistiDentali"]: "Dental hygienist",
        ["IgnoreDuplicates"]: "Ignore active practices for the same product",
        ["Il codice fiscale non è valido"]: "Fiscal Code is not valid",
        ["Il Proponente è a conoscenza di azioni, omissioni o fatti dai quali possano derivare richieste di risarcimento o azioni volte all’accertamento di responsabilità civile o penale del Proponente, anche se non notificate all’Assicuratore?"]:
            "Is the Proponent aware of actions, omissions or facts from which compensation claims or actions can be derived for the determination of civil or criminal liability of the Proponent, even if not notified to the Insurer?",
        ["Il Proponente ha mai sottoscritto o è mai stato assicurato per la Responsabilità Civile Professionale?"]: "Has the Proponent ever signed or was ever insured for the Professional Indemnity?",
        ["Il proponente, negli ultimi 5 anni, ha stipulato coperture assicurative per questa tipologia di rischio?"]:
            "Has the proponent stipulated insurance coverage for this type of risk in the last 5 years?",
        ["il tuo profilo"]: "Your profile",
        ["Il contraente/Legale rappresentante"]: "Policyholder/Legal Representative",
        ["IlContraenteHaGiaUnaPraticaAttivaPerLoStessoProdotto"]: "The policyholder has already other issued policies for the same product",
        ["Illimitata"]: "Unlimited",
        ["Immagine"]: "Image",
        ["ImpegnoRilascio"]: "Commitment to the release",
        ["Impianti energie rinnovabili"]: "Renewable Energy Systems",
        ["Implantologia"]: "Implantology",
        ["implantologiaAltre"]: "Other type of Implantology",
        ["ImplantologiaAltreDescr"]: "Type of implantology",
        ["ImplantologiaOsteointegrata"]: "Osseointegrated implantology",
        ["Imponibile"]: "Premium before taxes",
        ["ImponibileCalcolato{1-I}ImponibileInseritoDifferenti{2-I}"]: "Calculated premium before taxes {1-I} is different from written premium before taxes {2-I}",
        ["ImponibileCalcolato{1-I}ImponibileInseritoDifferenti{2-I}Differenza{3-I}"]: "Calculated premium before taxes {1-I} is different from written premium before taxes {2-I}: {3-I}",
        ["Importo affidamento"]: "Limit of Exposure",
        ["Importo complessivo"]: "Total Limit of Exposure",
        ["Importo garantito"]: "Insured sum",
        ["Importo interesse legale"]: "Legal Interest Amount",
        ["Importo"]: "Amount",
        ["ImportoComplessivo"]: "Total Amount",
        ["ImportoComplessivoAnticipazioni"]: "Insured Sum",
        ["ImportoComplessivoProvvisoria"]: "Insured Sum",
        ["ImportoComplessivoRatadiSaldo"]: "Insured Sum",
        ["ImportoGarantito"]: "Insured sum",
        ["ImportoInteresseLegale"]: "Legal Interest Amount",
        ["ImportoRichiesto"]: "Request Amount",
        ["Impossibile emettere la polizza, le quote assicurate non coprono il 100%"]: "Insured Shares are incorrect - they do not cover 100%",
        ["Impossibile impostare la quota di {1-P} perché supererebbe la quota della mandataria"]: "Share incorrect - Lead company shares' exceeded",
        ["Impossibile impostare la quota di {1-P} perché supererebbe la soglia del 100% totale"]: "Share incorrect - Exceed Overall Total 100%",
        ["Imposte"]: "IPT",
        ["In acquisizione"]: "Prospect",
        ["In completamento"]: "Being completed",
        ["In valutazione"]: "In the process of being assessed",
        ["IncarichiProfessionaliRegimeDiGeneralContractor"]: "Professional assignments as General Contractor",
        ["Incassa"]: "Cash out",
        ["Indagine"]:
            "Following an investigation, the Proponent and/or the Insured are aware of circumstances or events that may give rise to a claim for compensation against the Proponent himself in relation to the professional assignment indicated in this proposal?",
        ["IndiceSettorialeAssetTurnover"]: "Asset Turnover",
        ["IndiceSettorialeCoperturaInteressi"]: "Interest Coverage",
        ["IndiceSettorialeCurrentRatio"]: "Current Ratio",
        ["IndiceSettorialeDurataMediaDeiDebiti"]: "Average Duration of Liabilities",
        ["IndiceSettorialeIndiceDiAutocoperturaDelleImmobilizzazioni"]: "Self-Coverage of Fixed Assets",
        ["IndiceSettorialeLeverage"]: "Leverage",
        ["IndiceSettorialeOneriFinanziariValoreProduzione"]: "Financials Costs Turnover",
        ["IndiceSettorialeQuickRatio"]: "Quick Ratio",
        ["IndiceSettorialeROE"]: "ROE",
        ["IndiceSettorialeROI"]: "ROI",
        ["IndiceSettorialeROS"]: "ROS",
        ["Indietro"]: "Back",
        ["IndietroLista"]: "Back to list",
        ["Indirizzi"]: "Addresses",
        ["Indirizzo"]: "Address",
        ["Industrie"]:
            "Manufacturing Industries, Food Industries, Textiles, Clothing, Leather, Wood, Furniture, Paper, Publishing, Printing, Non-Metallic Minerals, Metal Production and Processing, Manufacture of Machinery - Mechanical Appliances - Electrical and Electronic Equipment, Automotive, Energy Production and Distribution electric - gas - water, Waste disposal",
        ["InfoFatturato"]: "Turnover",
        ["InfoFatturatoTotale"]: "Total Turnover",
        ["Informatici"]: "IT Services",
        ["Information"]: "Dashlet",
        ["Informatore"]: "Pharma Sales Rep",
        ["Informazioni"]: "Info",
        ["Info"]: "Info",
        ["InformazioniAccessorie"]: "Additional info",
        ["InformazioniAzioni"]:
            "Is the Proponent aware of actions, omissions or facts from which compensation claims or actions can be derived for the determination of civil or criminal liability of the Proponent, even if not notified to the Insurer?",
        ["InformazioniPrecedentiAssicurativi"]: "Has the Proponent ever signed or was ever insured for the Professional Indemnity?",
        ["InformazioniSinistri"]: "Previous policies, claims, circumstances",
        ["Infortuni"]: "Personal Accident",
        ["Ingegneri"]: "Engineer",
        ["Inglese"]: "English",
        ["Inizio"]: "Start",
        ["InizioCopertura"]: "Starting date of coverage",
        ["Inserimento Legale Rappresentante"]: "Add Legal Representative",
        ["Inserisci"]: "Add",
        ["Insurer JU"]: "Insurer JU",
        ["Insurer RCP"]: "Insurer RCP",
        ["Insurer SU"]: "Insurer SU",
        ["Insurer"]: "Insurer",
        ["IntrattenitoreCulturale"]: "Cultural entertainer",
        ["Invalid Date Format"]: "Invalid Date Format",
        ["InvestigatorePrivato"]: "Private detective",
        ["Invia"]: "Send",
        ["InviaSchermo"]: "Send Screen for help",
        ["Iscrizione Albo Rifiuti"]: "Waste Management Register Enrollment",
        ["ISO 14001"]: "ISO 14001",
        ["ISO 14067"]: "ISO 14067",
        ["ISO 18001"]: "ISO 18001",
        ["ISO 9000"]: "ISO 9001",
        ["Issued"]: "Issued",
        ["IstruttoreGuida"]: "Driving Instructor",
        ["IstruttoreYoga"]: "Yoga Instructor",
        ["Italiana"]: "Italian",
        ["Kinesiologo"]: "Kinesiologist",
        ["La compagnia {1-S} richiede di essere delegataria ma ha una quota del {2-P} inferiore o uguale alla quota di {3-S} pari al {4-P}"]:
            "The Company {1-S} asks to be the Leading Insurer but it has a quota of the {2-P}less then or equal to the quota of {3-S} equal to {4-P}",
        ["La compagnia {1-S} richiede di essere delegataria"]: "The Company {1-S} asks to be the Leading Insurer",
        ["La data non può essere posteriore il: {1-D}"]: "The date cannot be greater than {1-D}",
        ["La Partita iva non è valida"]: "VAT is not valid",
        ["La società ha acquisito o si è fusa con altre società negli ultimi 3 anni?"]: "Has the company acquired or merged with other companies in the last 3 years?",
        ["La Società ha avuto o ha in programma di avviare nei prossimi 12 mesi procedure di licenziamento o pensionamento anticipato?"]:
            "Has the Company had or is planning to launch dismissal or early retirement for employees in the next 12 months?",
        ["La società ha in programma acquisizioni, offerte pubbliche o fusioni, oppure intende effettuare un’offerta pubblica o privata di titoli entro il prossimo anno?"]:
            "Does the company plan acquisitions, public offers or mergers, or does it intend to make a public or private offer of securities within the next year?",
        ["La Società ha modificato la propria ragione sociale negli ultimi 5 anni?"]: "Has the Company changed its name in the last 5 years?",
        ["La data non può essere antecedente il: {1-D}"]: "The date cannot be before: {1-D}",
        ["LaDataNonPuoEssereAntecedenteIl{1-D}"]: "The date can not be lower than {1-D}",
        ["LAR-Appendice"]: "Policy Endorsement",
        ["LAR-FideAffidamento"]: "Limit of Exposure",
        ["LAR-FideAffidamentoContraente"]: "Limit of Exposure - Policyholder",
        ["LAR-Polizza"]: "Policy",
        ["LastMonth"]: "Last month",
        ["LastQuarter"]: "Last quarter",
        ["LastWeek"]: "Last week",
        ["Le valutazioni per gli affidamenti"]: "Assessments",
        ["LeasingAuto"]: "Car Leasing",
        ["LeasingStrutturale"]: "Leasing",
        ["Legale Rappresentante"]: "Legal Representative",
        ["LeggiTutto"]: "Read more",
        ["Lettori"]: "Reader",
        ["Lettura"]: "Reading",
        ["Level up della richiesta di deroga"]: "Special Acceptance - Level Up",
        ["LevelUP"]: "Level up",
        ["LiberoProfessionista"]: "Self-employed",
        ["LiberoProfSSNExtramoenia"]: "Self-employed - Agreed upon with the NHS - Extramoenia",
        ["Lim. Fideiussione POS"]: "Bond Limit - Local Producer",
        ["Lim. Fideiussione"]: "Bond Limit",
        ["Lim. Max Contraente"]: "Max Limit for the Policyholder",
        ["Lim. max contraente"]: "Max limit of the Policyholder",
        ["Lim. Max Contraente_NonProvvisorie"]: "No bid bonds - Max Limit for the Policyholder",
        ["Lim. Max Contraente_Provvisorie"]: "Bid bonds - Max Limit for the Policyholder",
        ["Lim. max fideiussione - POS"]: "Maximum Limit - Local Producer",
        ["Lim. Max Fideiussione POS"]: "Maximum Limit - Local Producer",
        ["Lim. Max Fideiussione POS_NonProvvisorie"]: "No bid bonds - Maximum Limit - Local Producer",
        ["Lim. Max Fideiussione POS_Provvisorie"]: "Bid bonds - Maximum Limit - Local Producer",
        ["Lim. Max Fideiussione"]: "Max Limit Bond",
        ["Lim. Max Fideiussione_NonProvvisorie"]: "No bid bonds - Max Limit Bond",
        ["Lim. Max Fideiussione_Provvisorie"]: "Bid bonds - Max Limit Bond",
        ["Lim. max sottoscrittore"]: "Maximum Limit - Underwriter",
        ["Limite accessori"]: "Admin Fees - Maximum Limit",
        ["Limite Affidamento"]: "Limit of Exposure",
        ["Limite diritti fissi"]: "Policy Fees - Maximum ",
        ["Limite flessibilita"]: "Flexibility limit",
        ["LIMITE INFERIORE SUPERATO"]: "LOWER LIMIT EXCEEDED",
        ["Limite per Contraente / Importo Affidamento"]: "Maximum Exposure - Policyholder",
        ["Limite per contraente"]: "Maximum exposure - Each Policyholder",
        ["Limite per singolo contraente"]: "Maximum Exposure -Each Policyholder",
        ["Limite per singolo prodotto"]: "Maximum exposure - Each Policy",
        ["Limite rimasto"]: "Credit still available",
        ["Limite sottoscrittore"]: "Underwriter Limit",
        ["Limite su importo affidamento non provvisorie"]: "Exposure Limit - No Bid Bonds",
        ["Limite su importo affidamento non provvisorio"]: "Exposure Limit - No Bid Bonds",
        ["Limite su importo affidamento provvisorie"]: "Exposure Limit - Bid Bonds",
        ["Limite su importo affidamento provvisorio"]: "Exposure Limit - Bid Bonds",
        ["Limite su importo affidamento"]: "Exposure Limit",
        ["Limite su massimale"]: "Limit of Authority per User (Underwriting)",
        ["Limite su premio"]: "Limit of Authority per User (Amount)",
        ["LIMITE SUPERIORE SUPERATO"]: "UPPER LIMIT EXCEEDED",
        ["Limite utilizzato"]: "Spent Credit",
        ["LimiteMassimoContraente"]: "Maximum Exposure - Each Policyholder",
        ["LimiteMassimoContraente_NonProvvisorie"]: "No bid bonds - Maximum Exposure - Each Policyholder",
        ["LimiteMassimoContraente_Provvisorie"]: "Bid bonds - Maximum Exposure - Each Policyholder",
        ["LimiteMassimoFideiussione"]: "Maximum Limit of Exposure",
        ["LimiteMassimoFideiussione_NonProvvisorie"]: "No bid bonds - Maximum Limit of Exposure",
        ["LimiteMassimoFideiussione_Provvisorie"]: "Bid bonds - Maximum Limit of Exposure",
        ["Limiti aggiornati correttamente"]: "Limits updated successfully",
        ["Limiti"]: "Limits",
        ["LIMITI"]: "LIMITS",
        ["LinguaNotifiche"]: "Language",
        ["ListaApprovazioniRichieste"]: "Approval Requests List",
        ["ListaBinder"]: "List of binders",
        ["ListaBinderErrataCompagnia"]: "List of binders is not correct",
        ["ListaBinderRichiesta"]: "This limit of Exposure requires a list of binders",
        ["ListaBinderVuota"]: "There are not binders for this limit of exposure",
        ["ListaErrore"]: "Error",
        ["ListaGruppiNotificaJSON"]: "Group List - JSON",
        ["Livello"]: "Level",
        ["Livello1"]: "Level 1",
        ["Livello2"]: "Level 2",
        ["Livello3"]: "Level 3",
        ["Livello4"]: "Level 4",
        ["Local Producer MD"]: "Local Producer MD",
        ["Local Producer User"]: "Local Producer User",
        ["Login"]: "Login",
        ["Logopedista"]: "Speech therapist",
        ["Logout"]: "Logout",
        ["Lordo"]: "Gross Premium",
        ["LoScopertoMaxDeveEssereMaggioreUgualeDelloScopertoMin"]: "The maximum of  the percentage excess has to be greater or equal than the minimum",
        ["Luogo esecuzione"]: "Place of Execution of the Works",
        ["Luogo nascita"]: "Place of Birth",
        ["LuogoEsecuzione"]: "Place of Execution of the Works",
        ["MalattieAppCardiovasc"]: "Cardiovascular Disease",
        ["MalattieInfettive"]: "Infectious diseases",
        ["MalattieTropicali"]: "Infectious tropical",
        ["Mandante"]: "Principal",
        ["Mandanti"]: "Group of Companies",
        ["Manuale utente"]: "User Manual",
        ["Margine Operativo Lordo"]: "Gross Operating Margin",
        ["Margine Operativo"]: "Operating Margin",
        ["Maschio"]: "Male",
        ["Massaggiatore"]: "Masseur",
        ["Massimale"]: "Limit of Authority",
        ["MassimaleCopertura"]: "Limit of Authority for claim - for year",
        ["MassimaleCoperturaAggregato"]: "Limit of Authority for year",
        ["MassimaleCoperturaSingolo"]: "Limit of Authority for claim",
        ["Massimale / Sinistro alla Stipula"]: "Limit / Claim to the Stipula",
        ["Massofisioterapista"]: "Physiotherapist",
        ["Massoterapista"]: "Massage therapist",
        ["Mediatore"]: "intermediary",
        ["Mediatori"]: "Credit broker",
        ["Medici"]: "Medical",
        ["MedicinaDelLavoro"]: "Occupational medicine",
        ["MedicinaEmergenza"]: "Emergency Medicine",
        ["MedicinaER"]: "Emergency Medicine",
        ["MedicinaGenerale"]: "General Medicine",
        ["MedicinaInterna"]: "Internal Medicine",
        ["MedicinaLavoro"]: "Occupational medicine - Environmental Health Officer",
        ["MedicinaLegale"]: "Forensic Medicine",
        ["MedicinaNucleare"]: "Nuclear Medicine",
        ["MedicinaSport"]: "Sports Medicine",
        ["MedicinaTropicale"]: "Tropical Medicine",
        ["MedicoFrequentatore"]: "Attending physicians",
        ["MedicoGenerico"]: "General Practitioner - Family Doctor",
        ["MedicoSES"]: "Health Emergency Service",
        ["MembroCDA"]: "Member of BoD",
        ["Menu amministrativo"]: "Admin Menu",
        ["Mesi"]: "Months",
        ["Meteorologo"]: "Meteorologist",
        ["Miscellaneous"]: "Miscellaneous",
        ["Microcredito"]: "Microcredit Tutor",
        ["Modalita emissione"]: "Issuing Way",
        ["Modello IVA"]: "VAT Statement",
        ["Modifica"]: "Edit",
        ["Modificato"]: "Edited",
        ["MoneyTransfer"]: "Money Transfer",
        ["Motivo"]: "Justification",
        ["Musicista"]: "Musician and producer",
        ["Mutui"]: "Mortgage",
        ["Mutuo"]: "Mortgage",
        ["Naturopata"]: "Naturopath",
        ["Nazione"]: "Country",
        ["ND"]: "ND",
        ["Ne{1-S}ne{2-S}sonoStatiCompilati"]: "That field {1-S} and that field {2-S} are empty",
        ["Nefrologia"]: "Nephrology",
        ["Negli ultimi tre anni e con riferimento ad ogni singolo anno, la Società ha ridotto o incrementato il numero totale dei dipendenti in misura superiore al 25% della forza lavorativa in essere l’anno precedente?"]:
            "In the last three years and with reference to every single year, has the Company reduced or increased the total number of employees by more than 25% of the work force in force in the previous year?",
        ["nel formato giorno/mese/anno"]: "in the format month/day/year",
        ["Neolaureato"]: "NEW GRADUATED - The insured declares not to be registered in the Register of Physicians-Surgeons for more than 4 years and to be not older than 34 years of age",
        ["Nessun dato presente"]: "No data found",
        ["Nessun record corrisponde ai parametri di ricerca"]: "No data found",
        ["Nessun risultato trovato"]: "No result found",
        ["Nessuna"]: "None",
        ["Neurochirurgia"]: "Neurosurgery",
        ["NeurologiaNeuropsichiatria"]: "Neurology and Neuro-Psychiatry (even child)",
        /* ["Neuropsichiatria"]: "Neuro-Psychiatry",*/
        ["NeuropsichiatriaSolo"]: "Neuro-Psychiatry",
        ["News"]: "News",
        ["New password"]: "New password",
        ["Next"]: "Next",
        ["No"]: "No",
        ["NO"]: "NO",
        ["No, è un cliente diretto"]: "No, he's a direct customer",
        ["Nome"]: "Name",
        ["Nome del Intermediario"]: "Name of the Intermediary",
        ["NomeFile"]: "File name",
        ["Nominativo"]: "Name",
        ["Non è possibile invalidare un file, potrebbe essere in uso in altre pratiche, contattare l'amministratore di sistema"]:
            "The validation of the file is not available, contact the system admin",
        ["Non hai i permessi per accedere alla pagina"]: "You do not have permission to access this page",
        ["Non provvisorie"]: " No Bid Bonds",
        ["Non tutti i file necessari sono stati selezionati e validati"]: "Select and validate all the needed documents",
        ["Non tutti i file necessari sono stati validati correttamente"]: "Please validate all the documents",
        ["NonèPossibileRichiedereLEmissioneDiUnaPolizzaNonEmettibile"]: "It's not allowed to issue this policy",
        ["NonèPossibileRichiedereLEmissioneDiUnaPolizzaNonEmettibileInviareRichiestaSottoscrittore"]: "It's not allowed to issue this policy - Send a request to the Underwriter",
        ["NonEStatoIndicatoNessunFatturatoSindacoRevisoreMembroCDA"]: "Missing Turnover of Statutory Auditor/Auditor/Member of the Board of Directors",
        ["NonProvvisorie{1-I}"]: "No bid bonds: {1-I}",
        ["Note deroga"]: "Note",
        ["Note"]: "Note",
        ["Notizia"]: "News",
        ["NP Annullata"]: "NP Canceled",
        ["NP Bozza accettata"]: "NP Draft Accepted",
        ["NP Bozza emessa"]: "NP Draft Issued",
        ["NP Polizza emessa"]: "NP policy Issued",
        ["NP Polizza sottoscritta"]: "NP Policy Underwritten",
        ["NP Preventivo di polizza"]: "NP Draft",
        ["NP Proposta riaperta"]: "Proposal Reopening",
        ["NP Proposta rifiutata"]: "Proposal Declined",
        ["NP Proposta sospesa"]: "Proposal Sospended",
        ["NP Stornata"]: "NP Reversed",
        ["NP Svincolata"]: "NP Released",
        ["NP Titolo emesso"]: "NP Issued Document",
        ["NP Titolo incassato"]: "NP Paid Document",
        ["NP Trattativa chiusa"]: "NP Closed Negotiation",
        ["null"]: " ",
        ["NULL"]: " ",
        ["Numero"]: "Number",
        ["Numero documento"]: "N° document",
        ["Numero Polizza"]: "Policy Number",
        ["NumeroAnniCoperturaPrecedenteContinua"]: "Years of continuous coverage",
        ["NumeroAssicurati"]: "Number of insureds",
        ["NumeroDipendenti"]: "Number of employees",
        ["NumeroIscrizione"]: "Number of enrollment in the Professional Register",
        ["NumeroMassimoInformazioniInseribiliRaggiunto"]: "Maximum number of info inserted",
        ["NumeroPolizza"]: "Policy Number",
        ["Nuova password"]: "New Password",
        ["Nuova polizza neutra"]: "New policy neutral",
        ["Nuova polizza CAR"]: "New policy CAR",
        ["Nuovi affidamenti/Nuove fideiussioni"]: "Bonds: new limit of exposure/new Policy",
        ["Nuovo indirizzo"]: "New Address",
        ["Nuovo preventivo"]: "New quotation",
        ["Nuovo mandante"]: "New Insurer",
        ["Nuovo recapito"]: "New Contact Details",
        ["Nuovo"]: "New",
        ["NUOVO"]: "NEW",
        ["Nutrizionista"]: "Nutritionist",
        ["OCCOrganismoComposizioneCrisiSovraintendimento"]: "OCC Organization for the composition of the over-indebted crisis",
        ["Odontoiatri"]: "Dentist",
        ["Odontoiatria"]: "Dentistry without implantology",
        ["OdontoiatriaImplantologia"]: "Dentistry with implantology",
        ["Odontotecnico"]: "Dental Technician",
        ["ODV"]: "ODV Supervisory Body",
        ["of"]: "of",
        ["Oftalmologia"]: "Ophthalmology",
        ["Oggetto"]: "Object",
        ["OggettoGaranzia"]: "Subject of the Cover",
        ["Oncologia"]: "Oncology",
        ["Oneri di Urbanizzazione"]: "Development Costs Bond",
        ["OperaMerloni"]: "Merloni Law",
        ["Operatività"]: "Turnover vs Curret Assets",
        ["Operazione avvenuta correttamente"]: "Operation successfully completed",
        ["Operazione"]: "Operation",
        ["OpereSubacquee"]: "Underwater works",
        ["Optometrista"]: "Optometrist",
        ["Ordina"]: "Sort",
        ["Ordine"]: "Order",
        ["OrtopediaTraumatologia"]: "Orthopaedic Trauma",
        ["OSS"]: "Socio-healthcare worker",
        ["Osteopata"]: "Osteopath",
        ["Otorinolaringoiatria"]: "Otorhinolaryngology",
        ["PA"]: "Public administration, education",
        ["PA-ApprovatoNegativo"]: "Assessed with negative comment",
        ["PA-ApprovatoPositivo"]: "Assessed with positive comment",
        ["Pannello Autorizzazioni"]: "Authorizations Panel",
        ["PA-Proposta"]: "Proposal",
        ["ParametriRiferimento"]: "Industry Benchmarks",
        ["Parere"]: "Analyst Opinion",
        ["Passaporto"]: "Passaport",
        ["PassatoEsercizio"]: "Last Turnover",
        ["Password"]: "Password",
        ["PasswordAggiornata"]: "Password updated",
        ["PasswordBloccata"]: "Locked Password",
        ["PasswordErrata"]: "User and/or password not correct",
        ["Passwords mismatch"]: "Passwords mismatch",
        ["Patente"]: "Driving License",
        ["Patologia"]: "Clinical pathology, excluding  genetic tests",
        ["PatologiaClinica"]: "Clinical Pathology",
        ["Patrimonio netto"]: "Net Worth",
        ["Patrocinatori"]: "Extra-judicial Lawyer",
        ["PCP-Calcolo"]: "Calculation",
        ["PCP-Compagnia"]: "Company",
        ["PCP-POS"]: "Local Producer",
        ["PCP-UW"]: "Underwriter",
        ["PEC"]: "Legal Mail",
        ["Pedagogista"]: "Pedagogist",
        ["PediatraLiberaScelta"]: "Specialized Pediatric Diagnostics",
        ["Pediatria"]: "Paediatricians (Excluding Neonatology and Reanimation)",
        ["PediatriaSolo"]: "Paediatricians",
        ["Pegno"]: "Pawn",
        ["Per contraente"]: "For each Policyholder",
        ["Per fideiussione"]: "For each Surety Bond",
        ["Per questa polizza ti sei avvalso della collaborazione di un altro intermediario assicurativo (iscritto in sezione A o B del RUI)?"]: "Did you cooperate with another insurance intermediary (registered in section A or B of the RUI) for this policy?",
        ["Percentuale del Capitale Sociale"]: "% of capital share",
        ["Percentuale"]: "Percentage",
        ["PercentualeAttivita"]: "% Activity",
        ["PercentualeDighe"]: "% Dams",
        ["PercentualeFerrovie"]: "% Railways",
        ["PercentualeFunivie"]: "% Cable railways",
        ["PercentualeGallerie"]: "% Tunnels",
        ["PercentualeOpereSubacquee"]: "% Underwater works",
        ["PerditePatrimoniali"]: "Asset losses",
        ["PeritiAssicurativi"]: "Insurance Expert",
        ["PeritiIndustriali"]: "Industrial Expert",
        ["PeritiStandard"]: "Expert",
        ["Perito"]: "Experts",
        ["PeritoAgrario"]: "Agronomist/ Agricultural / Forestry / Environmental Expert",
        ["Permesso di costruire"]: "Permission to build",
        ["Persona fisica"]: "Natural Person",
        ["Persona giuridica"]: "Legal Entity",
        ["Persona giuridica/Professionista"]: "Legal entity",
        ["PersonaFisica"]: "Natural Person",
        ["PersonaGiuridica"]: "Legal Entity",
        ["Personale"]: "Personal",
        ["PersonalTrainer"]: "Personal Trainer",
        ["Pesca"]: "Settore Pesca",
        ["PIVA"]: "VAT Number",
        ["PIVACF"]: "VAT Number",
        ["PlaceholderData"]: "Date",
        ["Pneumologia"]: "Pneumology/Respiratory Diseases",
        ["Policies Number"]: "Policies Number",
        ["Policy ID"]: "Policy ID",
        ["Polizza AgentiMediatori"]: "Brokerage Agents Policy",
        ["Polizza AmministratoriCondominio"]: "Building Manager Policy",
        ["Polizza AreaMedica"]: "Doctors Liability",
        ["Polizza AreaOdontoiatrica"]: "Dental Area Policy",
        ["Polizza Avvocati"]: "Lawyer Policy",
        ["Polizza bloccata correttamente con ID: {1-S}"]: "Policy locked - ID: {1-S}",
        ["Polizza ColpaGrave"]: "Gross Negligence Policy",
        ["Polizza Commercialisti Sindaci/Revisori/Membri CdA"]: "Statutory Auditors/Accounting/Auditors/Board Members",
        ["Polizza Commercialisti"]: "Accountant",
        ["Polizza Consulenti del lavoro Sindaci/Revisori/Membri CdA"]: "Statutory Auditors/Accounting/Auditors/Board Members",
        ["Polizza Consulenti del lavoro"]: "Labour Consultant",
        ["Polizza emessa correttamente"]: "Policy successfully issued",
        ["Polizza annullata correttamente"]: "Policy successfully cancelled",
        ["Polizza inviata correttamente"]: "Policy successfully sended",
        ["Polizza emessa"]: "Issued Policy",
        ["Polizza emessa e firmata"]: "Issued and signed policy",
        ["Polizza emessa e rinnovata"]: "Policy issued and renewed",
        ["Quietanza di rinnovo emessa"]: "Renewal receipt issued",
        ["Polizza in rinnovo consolidato"]: "Consolidated renewal policy",
        ["Polizza in rinnovo approvata"]: "Renewal policy approved",
        ["Polizza in rinnovo"]: "Renewal policy",
        ["Polizza Miscellaneous"]: "Miscellaneous Policy",
        ["Polizza non verificata"]: "Policy not Verified",
        ["Polizza Patrocinatori"]: "Lawyer Policy",
        ["Polizza PeritoAgrario"]: "Agronomist",
        ["Polizza RCAmministratori"]: "D&O Policy",
        ["Polizza RespServProtPrev"]: "Prevention and Safety Manager Policy",
        ["Polizza rifiutata"]: "Policy Declined",
        ["Polizza salvata correttamente con ID: {1-S}"]: "Policy successfully saved - ID: {1-S}",
        ["Polizza SanitariNonMedici"]: "Policy Healthy Professions Non-Doctors",
        ["Polizza ServiziInformatici"]: "IT Services Policy",
        ["Polizza sottoscritta POS"]: "POS Underwritten Policy",
        ["Polizza sottoscritta"]: "Underwritten Policy",
        ["Polizza Veterinari"]: "Veterinarian Policy",
        ["Polizza"]: "Policy",
        ["Polizza Neutra"]: "Policy Neutra",
        ["Polizza CAR"]: "Policy CAR",
        ["POLIZZA"]: "POLICY",
        ["PolizzaApprovazione - Approvato con parere negativo"]: "Policy - Assessed with negative comment",
        ["PolizzaApprovazione - Approvato con parere positivo"]: "Policy - Assessed with positive comment",
        ["PolizzaApprovazione - Proposta"]: "Policy - Proposal",
        ["PolizzaStato"]: "Status",
        ["PolizzaStatoApprovazioneCommenti"]: "Notes on approval (policies)",
        ["PolizzePreventivi"]: "Policies and Quotations",
        ["Polizze"]: "Policies",
        ["PompeFunebri"]: "Funeral directors",
        ["POS RCP FIDE"]: "POS RCP FIDE",
        ["POS RCP"]: "POS RCP",
        ["POS"]: "Local Producers",
        ["Possibilità di effettuare il logout"]: "Logout available",
        ["Possibilità di gestire il pannello di amministrazione"]: "Admin Panel Management",
        ["Possibilità di gestire la carta servizi"]: "Management of secure card",
        ["Possibilità di richiedere deroghe"]: "Special Acceptance Availability",
        ["PR"]: "PR",
        ["Precedente ragione sociale"]: "Previous company name",
        ["Pregiudizievoli"]: "Prejudicials",
        ["Premio calcolato correttamente"]: "Premium successfully calculated",
        ["Premio finito"]: "Premium Including Taxes",
        ["Premio fisso"]: "Flat Premium",
        ["Premio minimo"]: "Minimum Premium",
        ["Premio netto"]: "GWP",
        ["Premio proposto dal POS"]: "Local Producers - Desired Premium",
        ["Premio proposto dal sottoscrittore"]: "Underwriter - Premium",
        ["Premio proposto dalla compagnia (special acceptance)"]: "Insurer - Premium (Referals only)",
        ["Premio"]: "Premium",
        ["PremioFinito"]: "Premium Including Taxes",
        ["PremioImponibile"]: "Premium before taxes",
        ["PremioNetto"]: "GWP",
        ["PremioNettoMaggiorato"]: "GWP prop.",
        ["PremioPagato"]: "Payed Premium",
        ["Preventivi"]: "Quotations",
        ["Preventivi bozza inviata"]: "Quotations",//todo
        ["Preventivo di polizza approvato"]: "Quotation assessed",
        ["Preventivo di polizza consolidato"]: "Quotation to be approved",
        ["Preventivo di polizza sottoposto al sottoscrittore"]: "Quotation submitted to the underwriter",
        ["Preventivo di polizza"]: "Quotation",
        ["Preventivo di polizza(bozza inviata)"]: "Quotation draft sent",
        ["Preventivo non modificabile"]: "Quotation not editable ",
        ["Preventivo salvato correttamente con ID: {1-S}"]: "Quotation saved with ID: {1-S}",
        ["Preventivo"]: "Quotation",
        ["Previous"]: "Prev",
        ["Privacy"]: "Privacy",
        ["Procedi"]: "Proceed",
        ["Procedure concorsuali"]: "Insolvency proceedings",
        ["ProcedureConcorsuali"]: "Insolvency proceedings",
        ["Prodotti emessi"]: "Products Issued",
        ["Prodotti"]: "Products",
        ["ProdottiEmessi"]: "Report for type of product",
        ["Prodotto"]: "Product",
        ["Ramo"]: "CoB",
        ["Professional Indemnity"]: "Professional Indemnity",
        ["Professionale"]: "Professional",
        ["Professione"]: "Activity",
        ["Profilo utente"]: "User Profile",
        ["Progettazione"]: "Design",
        ["Progetto Contributo"]: "Grant Project",
        ["Progressivo"]: "Progressive",
        ["Pre proposta affidamento"]: "Pre submission",
        ["Property"]: "Property",
        ["Proposta affidamento"]: "Submission",
        ["Proposta riaperta"]: "Proposal Reopening",
        ["Proposta riapertura affidamento"]: "Submission Proposal Reopening",
        ["Proposta sospesa"]: "Proposal Sospended",
        ["Proposta"]: "Proposal",
        ["Protesti"]: "Protests",
        ["Provincia"]: "Province",
        ["Provv-Accessori"]: "Accessories Commissions",
        ["Provv-Diritti"]: "Accessories Commissions - Fees",
        ["Provvigione calcolata sugli accessori"]: "Accessories Commissions",
        ["Provvigione calcolata sui diritti fissi"]: "Accessories Commissions on policy fees",
        ["Provvigione calcolata sul premio netto"]: "Accessories Commissions on net premium",
        ["ProvvigionePercentuale"]: "Commission rate (%)",
        ["Provvigioni"]: "Commission",
        ["PROVVIGIONI"]: "COMMISSION",
        ["ProvvigioniAggiornateCorrettamente"]: "Commission successfully updated",
        ["PROVVIGIONIERRORE"]: "Error - Commission",
        ["ProvvigioniNonImpostate"]: "Set the Commission first",
        ["Provvisorie"]: "Bid Bonds",
        ["Provvisorie{1-I}"]: "Bid bonds: {1-I}",
        ["Provv-Netto"]: "Net Commisions",
        ["PS-Annullata"]: "Canceled",
        ["PS-Bloccata"]: "Locked",
        ["PS-BozzaAccettata"]: "Draft Copy Accepted",
        ["PS-BozzaEmessa"]: "Draft Copy Issued",
        ["PS-Emessa"]: "Issued",
        ["PS-EmessaFirmata"]: "Issued and signed",
        ["Psichiatria"]: "Psychiatry",
        ["Psicologia"]: "Psychology",
        ["Psicologo"]: "Psychologist",
        ["PS-NP-Annullata"]: "Canceled",
        ["PS-NP-BozzaAccettata"]: "Draft Copy Accepted",
        ["PS-NP-BozzaEmessa"]: "Draft Copy Issued",
        ["PS-NP-PolizzaEmessa"]: "Policy Issued",
        ["PS-NP-PolizzaSottoscritta"]: "Policy Underwritten",
        ["PS-NP-Preventivo"]: "Quotation",
        ["PS-NP-PropostaRiaperta"]: "Proposal Reopening",
        ["PS-NP-PropostaRifiutata"]: "Proposal Declined",
        ["PS-NP-PropostaSospesa"]: "Proposal Sospended",
        ["PS-NP-Stornata"]: "Charged Off",
        ["PS-NP-Svincolata"]: "Cleared",
        ["PS-NP-TitoloEmesso"]: "Invoice Issued",
        ["PS-NP-TitoloIncassato"]: "Invoice Cashed",
        ["PS-NP-TrattativaChiusa"]: "Archived",
        ["PS-PolizzaSottoscritta"]: "Policy Underwritten",
        ["PS-PolizzaSottoscrittaPOS"]: "Policy Underwritten LP",
        ["PS-Preventivo"]: "Quotation",
        ["PS-PropostaRiaperta"]: "Proposal Reopening",
        ["PS-PropostaSospesa"]: "Proposal Sospended",
        ["PS-Rifiuto"]: "Declined",
        ["PS-Stornata"]: "Charged Off",
        ["PS-Svincolata"]: "Cleared",
        ["PS-TitoloEmesso"]: "Invoice Issued",
        ["PS-TitoloIncassato"]: "Invoice Cashed",
        ["PS-TrattativaChiusa"]: "Archived",
        ["Punteggio"]: "Score",
        ["Q-Appendice"]: "Policy Endorsement",
        ["Q-Polizza"]: "Q-Polizza",
        ["Q-Rata"]: "Q-Rata",
        ["QS-Emessa"]: "QS-Emessa",
        ["QS-Incassata"]: "QS-Incassata",
        ["Q-StornoConImposte"]: "Q-StornoConImposte",
        ["Q-StornoSenzaImposte"]: "Q-StornoSenzaImposte",
        ["Quadrimestrale"]: "Four-monthly",
        ["Qualita"]: "Quality control technician",
        ["Qualora il bilancio della Società sia soggetto a certificazione, la relativa società di revisione ha certificato il bilancio apportando commenti?"]:
            "If the Company's financial statements are subject to certification, has the relevant auditing firm certified the financial statements by making comments?",
        ["Questionario"]: "Questionnaire",
        ["Quietanza che non comporta pagamento"]: "Receipt that does not involve payment",
        ["Quietanza di storno con imposte"]: "Reverse order with taxes",
        ["Quietanza di storno senza imposte"]: "Reverse order without taxes",
        ["Quietanza emessa"]: "Receipt",
        ["Quietanza incassata"]: "Recepit collected",
        ["Quietanza per l'intera polizza"]: "Receipt fot the policy",
        ["Quietanza per una rata"]: "Receipt for one instalment",
        ["Quietanza per un'appendice"]: "Policy Endorsement - Receipt",
        ["Quietanza"]: "Receipt",
        ["Quietanze"]: "Receipts",
        ["Quota mandataria"]: "Lead company share",
        ["Quota rimanente"]: "Outstanding Share",
        ["Quota"]: "Share",
        ["Quotate"]:
            "Auditor of companies listed on the financial markets / credit companies or banks / financial / insurance companies / companies that make use of the risk capital market / companies held in the consolidated financial statements / consortia",
        ["Q-Zero"]: "Q-Zero",
        ["Radiodiagnostica"]: "Radiology",
        ["Radioterapia"]: "Radiotherapy",
        ["Raffinerie"]: "Refineries, Nuclear Fuel Treatment, Chemical Industry, Fibers, Plastic Rubber",
        ["Ragione Sociale"]: "Company Name",
        ["RagioneSocialeIVA"]: "Company name (including VAT number)",
        ["Range"]: "Range",
        ["Rata di saldo"]: "Performance Bonds 10-20% Instalments",
        ["RCAmministratori"]: "D&O",
        ["RCP"]: "PI",
        ["RCPG-Accessoria-AmministratoreCondomini"]: "Building Manager Policy",
        ["RCPG-Accessoria-AttFiscRevEntiPubb"]: "Fiscal activity Public Bodies",
        ["RCPG-Accessoria-DanniATerziDaInterruzioneAttivita"]: "Third party damage from business interruption",
        ["RCPG-Accessoria-DanniAttrezzatureLaboratorio"]: "Damage to Lab Equipment",
        ["RCPG-Accessoria-EffettuazioneOpereAltoRischio"]: "High risk works",

        ["RCPG-Accessoria-FunzioniPubbliche"]: "Public Functions",

        ["RCPG-Accessoria-GeneralContractor"]: "General Contractor",
        ["RCPG-Accessoria-Implantologia"]: "Implantology",
        ["RCPG-Accessoria-LiquidazioneCuratela"]: "Loss Adjuster",
        ["RCPG-Accessoria-Neolaureati"]: "New Graduated",
        ["RCPG-Accessoria-OCC"]: "OCC Organization for the composition of the over-indebted crisis",
        ["RCPG-Accessoria-ODV"]: "ODV Supervisory Body",
        ["RCPG-Accessoria-PatrocinatoriStragiudiziali"]: "Extrajudicial Expert",
        ["RCPG-Accessoria-PerditePatrimoniali"]: "Asset losses",
        ["RCPG-Accessoria-Postuma"]: "Discovery Period",
        ["RCPG-Accessoria-Retroattivita"]: "Retroactivity",
        ["RCPG-Accessoria-FunzioneRevisoreContabile"]: "Funzione di revisione contabile(ENG)",
        ["RCPG-Accessoria-FunzioneRevisoreContabileEP"]: "Funzione di revisione contabili in Enti Pubblici(ENG)",
        ["RCPG-Accessoria-MembroCdA"]: "Membro del consiglio di amministrazione(ENG)",
        ["RCPG-Accessoria-Sindaco"]: "Statutory Auditor",
        ["RCPG-Accessoria-SindacoRevisoreMembroCdA"]: "Statutory Auditor/Auditor/Member of the Board of Directors",
        ["RCPG-Accessoria-VistoLeggero"]: "Light Visa",
        ["RCPG-Accessoria-VistoPesante"]: "Heavy Visa",
        ["RCPG-BaseAgenti"]: "Agents",
        ["RCPG-BaseAgentiMediatori"]: "Agents and brokers",
        ["RCPG-BaseAmministratoriCondominio"]: "Building Manager",
        ["RCPG-BaseArchitetti"]: "Architect",
        ["RCPG-BaseAreaMedica"]: "Doctors Liability",
        ["RCPG-BaseAreaOdontoiatrica"]: "Dentist",
        ["RCPG-BaseAvvocati"]: "Lawyer",
        ["RCPG-BaseColpaGrave"]: "Gross Negligence Policy",
        ["RCPG-BaseCommercialisti"]: "Accountant",
        ["RCPG-BaseCommercialistiRevisori"]: "Accountant Auditor",
        ["RCPG-BaseConsulentiLavoro"]: "Labour Consultant",
        ["RCPG-BaseConsulentiLavoroRevisori"]: "Labour Consultant Auditor",
        ["RCPG-BaseGeologi"]: "Geologist",
        ["RCPG-BaseGeometri"]: "Surveyor",
        ["RCPG-BaseIgienistiDentali"]: "Dental Higienist",
        ["RCPG-BaseIngegneri"]: "Engineer",
        ["RCPG-BaseMediatori"]: "Brokers",
        ["RCPG-BaseMiscellaneous"]: "Miscellaneous",
        ["RCPG-BasePatrocinatori"]: "Lawyer Policy",
        ["RCPG-BasePeritiStandard"]: "Expert",
        ["RCPG-BasePeritoAgrario"]: "Agronomist/ Agricultural / Forestry / Environmental Expert",
        ["RCPG-BaseRCAmministratori D&O"]: "D&O – Director & Officers",
        ["RCPG-BaseRCAmministratori"]: "D&O – Director & Officers",
        ["RCPG-BaseRespServProtPrev"]: "Health and Safety Manager",
        ["RCPG-BaseSanitariNonMedici"]: "Non-medical Health profession",
        ["RCPG-BaseServiziInformatici"]: "IT Services",
        ["RCPG-BaseVeterinari"]: "Veterinarians",
        ["Recapiti"]: "Contact Details",
        ["Recapito"]: "Contact Details",
        ["Record non trovato clicca il bottone per crearne uno"]: "Record not found click here to add ",
        ["Recuoera password"]: "Password Recovery",
        ["Redditivita"]: "Profitability",
        ["Reddito complessivo"]: "Total Earnings",
        ["Reddito Immobili"]: "Real Estate Earnings",
        ["REFERRAL"]: "REFERRAL",
        ["Regola{1-S}NonPresente"]: "Rule {1-S} unfound",
        ["Regole da applicare sui campi delle form"]: "Roles to be applied on forms",
        ["Reinsurer"]: "Reinsurer",
        ["Relativo Mercato"]: "Related market",
        ["Release Endorsement"]: "Release Endorsement",
        ["Rendicontazione"]: "Reporting",
        ["Reparto"]: "Ward",
        ["Residenza"]: "Residence",
        ["ResponsabilitaAcclarate"]: "Responsibility Acclared",
        ["Rete distributiva"]: "Distribution network",
        ["Retroattivita"]: "Retroactivity",
        ["Reumatologia"]: "Rheumatology",
        ["Revisione affidamento"]: "Submission Review",
        ["Revisore"]: "Auditor",
        ["RevisoreComm"]: "Independent Auditor",
        ["RevisoreEntiPubblici"]: "Auditor of Public Entities",
        ["Ribasso asta"]: "Discount",
        ["RibassoAsta"]: "Discount",
        ["Ricerca"]: "Search",
        ["Ricevente"]: "To",
        ["Ricevuta Pagamento"]: "Receipt of Payment",
        ["Richiedi deroga"]: "Request special acceptance",
        ["Richiedi"]: "Request",
        ["RichiediDeroga"]: "Special Acceptance",
        ["Richiesta cambio stato avvenuto con successo"]: "Request correctly recorded",
        ["Richiesta deroga inserita correttamente"]: "Extension Request correctly recorded",
        ["Richiesta deroga"]: "Special Acceptance",
        ["Richiesta riapertura"]: "Reopening Request",
        ["Richiesta per la firma digitale inviata correttamente"]: "Request for digital signature sent successfully",
        ["Richiesto"]: "Required",
        ["RicostruttoriUnghie"]: "Nails reconstructions",
        ["Rifiuta"]: "Decline",
        ["Rifiutata"]: "Declined",
        ["Rifiuto affidamento"]: "Submission Rejected",
        ["RifiutoCopertura"]: "Has any Insurer ever refused this risk?",
        ["RifiutoCopertureAssicurative"]: "Insurance Covers Refusal",
        ["Rilasciato da"]: "Issued by",
        ["Rilasciato in data"]: "Issued on",
        ["RilascioFideiussioni"]: "Bonds Release",
        ["RilieviCatastaliTopografici"]: "Cadastral surveys",
        ["Rimborsi IVA"]: "VAT Refund Bond",
        ["Rimuovi"]: "Remove",
        ["Rinnovi"]: "Renewals",
        ["Rinnova"]: "Renewal",
        ["Rinnovo"]: "Renewal",
        ["Rinnovo affidamento"]: "Limit of Exposure - Renewal",
        ["Ripristino"]: "Restoring",
        ["Rischio"]: "Companies that make use of the risk capital market",
        ["RischiPattuizioneEspressa"]: "Special Conditions",
        ["Rows per page"]: "Rows per page:",
        ["RSPP"]: "Prevention and Safety Manager",
        ["RTI"]: "T.G.C.",
        ["Ruolo"]: "Role",
        ["RUP"]: "R.U.P.",
        ["S.a.s."]: "S.a.s.",
        ["S.c.a.r.l."]: "S.c.a.r.l.",
        ["S.n.c."]: "S.n.c.",
        ["S.P.A."]: "S.P.A.",
        ["S.r.l."]: "S.r.l.",
        ["S.r.l.s."]: "S.r.l.s.",
        ["S.s."]: "S.s.",
        ["Salva anagrafica"]: "Save Details",
        ["Salva Anagrafica"]: "Save Details",
        ["Salva"]: "Save",
        ["Salva (bozza inviata)"]: "Save (draft sent)",
        ["SalvaAnagrafica"]: "Save Details",
        ["Sanita"]: "Health, social affairs",
        ["Sanitari"]: "Health Professions Non-Doctors",
        ["Scadenza Affidamento"]: "Submission Date of Expiry",
        ["ScadenzaAffidamento"]: "Submission Date of Expiry",
        ["ScaricaFile"]: "Download the file",
        ["SCARSA"]: "LOW",
        ["Scoperto {1-P} con il minimo di {2-I} e massimo {3-I}"]: "Uncovered share {1-P} from the minimum of {2-I} and maximum of {3-I}",
        ["Scoperto"]: "Uncovered share",
        ["Scoperto Partita 1"]: "Uncovered share - Partita 1",
        ["Scoperto Partita 2"]: "Uncovered share - Partita 2",
        ["Scoperto Partita 3"]: "Uncovered share - Partita 3",
        ["Scoperto Sezione B"]: "Uncovered share - Section B",
        ["Sezione B Limit"]: "Section B Limit",
        ["Scoperto Minimo Partita 1"]: "Uncovered share minimum - Partita 1",
        ["Scoperto Minimo Partita 2"]: "Uncovered share minimum - Partita 2",
        ["Scoperto Minimo Partita 3"]: "Uncovered share minimum - Partita 3",
        ["Scoperto Minimo Sezione B"]: "Uncovered share minimum - Section B",
        ["Scoperto10Minimi1500Massimo3000"]: "Uncoverd share 10%, minum € 1.500,00 maximum € 3.000,00",
        ["ScopertoMax"]: "Maximum",
        ["ScopertoMin"]: "Minimum",
        ["Scrittura"]: "Writing",
        ["Sede Legale"]: "Registered Office",
        ["Sede Principale"]: "Headquarter",
        ["Sede Secondaria"]: "Secondary Office",
        ["Sede"]: "Office",
        ["SediSecondarie"]: "Subsidiary Offices",
        ["Seleziona"]: "Select",
        ["Seleziona..."]: "Select...",
        ["SelezionareAnagraficaContraente"]: "Choose Customer",
        ["SelezionareGaranziaAccessoriaRetroattivita"]: "Select retroactivity guaraneee",
        ["SelezionareProfessione"]: "Choose activity",
        ["Selezionati"]: "Selected",
        ["Selezionato"]: "Selected",
        ["Semestrale"]: "Six-monthly",
        ["Sessione duplicata"]: "Session Duplicated",
        ["Sessione scaduta"]: "Session Expired",
        ["SessioneNonValida"]: "Session not Valid",
        ["SessioneScaduta"]: "Session Expired",
        ["Sesso"]: "Gender",
        ["SetInformativo"]: "Policy documents",
        ["Sezioni"]: "Sections",
        ["Show"]: "Show",
        ["SI"]: "YES",
        ["Si"]: "Yes",
        ["Sindaco"]: "Statutory Auditor",
        ["SindacoComm"]: "Statutory Auditor",
        ["SindacoQuotate"]:
            "Statutory Auditor of companies listed on the financial markets / credit companies or banks / financial / insurance companies / companies that make use of the risk capital market / companies held in the consolidated financial statements / consortia",
        ["Sinistri"]: "Claims",
        ["Situazione finanziaria"]: "Financial Situation",
        ["SOA"]: "SOA",
        ["SOA-I"]: "SOA-I",
        ["SOA-II"]: "SOA-II",
        ["SOA-III"]: "SOA-III",
        ["SOA-IIIbis"]: "SOA-IIIbis",
        ["SOA-IV"]: "SOA-IV",
        ["SOA-IVbis"]: "SOA-IVbis",
        ["SOA-V"]: "SOA-V",
        ["SOA-VI"]: "SOA-VI",
        ["SOA-VII"]: "SOA-VII",
        ["SOA-VIII"]: "SOA-VIII",
        ["SocEDP"]: "EDP",
        ["Società acquisita"]: "Acquired Company",
        ["Società consortile"]: "Consortium",
        ["Societa"]: "Company",
        ["Società"]: "Company",
        ["SoftwareTerzi"]: "Third party software distribution/commercialization/transfer",
        ["Somma garantitaA"]: "Bond Amount to",
        ["Somma garantitaDa"]: "Bond Amount from",
        ["Somme Assicurate Partita 1"]: "Sum Insured - Partita 1",
        ["Somme Assicurate Partita 2"]: "Sum Insured - Partita 2",
        ["Somme Assicurate Partita 3"]: "Sum Insured - Partita 3",
        ["Sono ammessi solo numeri, caratteri e virgole"]: "Only letters, numbers and commas are allowed",
        ["Sono mai state avanzate richieste di RISARCIMENTO, anche in materia di diritto del lavoro, nei confronti della società e/o degli amministratori?"]:
            "Have there been any requests for compensation, including in the field of labor law, against the company and/or directors?",
        ["Sono state avanzate richieste di risarcimento o sono state promosse azioni volte ad accertare la responsabilità civile o penale nei confronti del Proponente negli ultimi 5 (cinque) anni, anche se non notificate all’Assicuratore?"]:
            "Complaints have been made or actions have been taken to ascertain civil or criminal liability against the Applicant in the last 5 (five) years, even if not notified to the Insurer?",
        ["Sono stati ricoperti o si ricoprono tutt'ora incarichi di Sindaco o di Amministratore presso società sottoposte a procedure concorsuali?"]:
            "Have any offices of Statutory Auditor or Director been held or are still held in companies subject to bankruptcy proceedings?",
        ["Sospensione affidamento"]: "Limit of Exposure - Sospended",
        ["Sottoposto a sottoscrizione"]: "Being underwritten",
        ["Sottoscrittore"]: "Underwriter",
        ["Sottoscrizione affidamento"]: "Limit of Exposure - Approval",
        ["Specializzando"]: "Trainee (in one of the branches above - in the first five years of enrollment)",
        ["Specializzazioni"]: "Specialty",
        ["StabiliCondominiali"]: "Buildings Manager",
        ["Stampa bozza"]: "Print Draft Copy",
        ["Stampa"]: "Print",
        ["Stampa Word"]: "Print Word",
        ["Stati aggiornati correttamente"]: "Status successfully updated",
        ["STATI ERRORE"]: "ERROR",
        ["STATI"]: "STATES",
        ["Stati"]: "Status",
        ["Statistico"]: "Statistician",
        ["Stato aggiornato correttamente"]: "Status successfully updated",
        ["Stato dell’azienda"]: "Company Status",
        ["Stato Deroga"]: "Status",
        ["Stato polizza"]: "Policy status",
        ["Stato"]: "Status",
        ["StatoCircostanza"]: "Event Status",
        ["StatoSinistro"]: "Claim Status",
        ["Status"]: "Status",
        ["StazioneAppaltante"]: "Contracting Authority",
        ["Stilista"]: "Designer",
        ["StimaEsercizioCorrente"]: "Forecast Revenue",
        ["StimePerizie"]: "Evaluation, survey",
        ["Storico"]: "Historian/Art historian",
        ["Stornata"]: "Reversed",
        ["StornoSenzaImposta"]: "Reversal without tax",
        ["StornoConImposta"]: "Reversal with tax",
        ["StornoSenzaImposte"]: "Reversal without tax",
        ["StornoConImposte"]: "Reversal with tax",
        ["Struttura"]: "Public or private structure",
        ["StudioAssociato"]: "Insured",
        ["StudioAssociatoOdontoiatriIgienistiDentali"]: "Studio Associato Odontoiatri Igienisti Dentali",
        ["Sub Agente"]: "Sub Agent",
        ["Subappaltatore"]: "Subcontractor",
        ["SUCCESS"]: "SUCCESS",
        ["Supporto"]: "Help",
        ["Svincolata"]: "Released",
        ["TacitoRinnovo"]: "Tacit renewal",
        ["EmissioneDirettaPOS"]: "Local producer can issue policy directly",
        ["Tasse"]: "Taxes",
        ["Tassi salvati correttamente"]: "Rates successfully saved",
        ["Tassi"]: "Rates",
        ["TASSI"]: "RATES",
        ["Tasso interesse legale"]: "Legal Interest Rate",
        ["Tasso min"]: "Minimum Rate",
        ["Tasso"]: "Rate",
        ["TassoInteresseLegale"]: "Legal Interest Rate",
        ["Tatuatore"]: "Tattoo artist",
        ["TecnicoAudiometrista"]: "Audiometrist Technician",
        ["TecnicoAudioprotesista"]: "Technician in Audio prothesis",
        ["TecnicoDietista"]: "Technician in Dietetics",
        ["Telefono"]: "Telephone",
        ["Template salvato correttamente"]: "Template successfully saved",
        ["TerapistaShiatsu"]: "Shiatsu Therapist",
        ["TerminiRinnovo"]: "Renewal Terms",
        ["Test"]: "Test",
        ["Testo richiesto"]: "Required Text",
        ["Testo"]: "Text",
        ["TestoRichiesto"]: "Required Text",
        ["The status is changed successfully"]: "The status is changed successfully",
        ["TipiProdotti"]: "Product type",
        ["TipiProdotto"]: "Product type",
        ["TypeWorks"]: "Type of Works",
        ["Tipo affidamento"]: "Submission type",
        ["Tipo Anagrafica"]: "Details type",
        ["Tipo Deroga"]: "Type",
        ["Tipo durata"]: "Duration type",
        ["Tipo Società"]: "Company type",
        ["Tipo"]: "Type",
        ["TipoAnag"]: "Details Type",
        ["TipoAnagStato"]: "Status",
        ["TipoCambioStato"]: "Status Workflow",
        ["TipoCambioStatoPercorso"]: "Change Flow Status",
        ["TipoDocumento"]: "Document type",
        ["Tipo Documento"]: "Type of document checked and valid",
        ["TipoFile"]: "File type",
        ["TipoFileStati"]: "Status",
        ["TipoFileStato"]: "Status",
        ["TipologiaAttivita"]: "Activity",
        ["TipoProdotto"]: "Product type",
        ["TipoRamo"]: "LOB/Product",
        ["TipoStatoArrivo"]: "End Status",
        ["TipoStatoPartenza"]: "Start Status",
        ["TipoValutazioneEsito"]: "Assessment Result type",
        ["Titolo emesso"]: "Issued Document",
        ["Titolo incassato"]: "Paid Document",
        ["Titolo"]: "Title",
        ["Tossicologia"]: "Medical Toxicology",
        ["Totale"]: "Total",
        ["Totale interesse legale"]: "Total Legal Interest",
        ["Totale passivo"]: "Total Liabilities",
        ["TotaleInteresseLegale"]: "Total Legal Interest",
        ["TotalePremioLordo"]: "Premium Lordo",
        ["Traduttore"]: "Translator/Interpreter",
        ["Trattativa chiusa"]: "Closed Negotiation",
        ["Turistico"]: "Tourist Promoter",
        ["Tutti i documenti caricati"]: "All documents uploaded correctly",
        ["Ufficio"]: "Office",
        ["UltimiAggiornamenti"]: "Latest updates",
        ["Ultimo anno"]: "Last Year",
        ["Ultimo Bilancio Coobbligati"]: "Most Recent Financials for Co-obligors",
        ["Ultimo Bilancio depositato"]: "Last Filed Balance Sheet",
        ["Ultimo Unico Amministratore"]: "Last Income Tax Return for the Sole Director",
        ["Ultimo Unico per societa"]: "Last Company's Income Tax Return",
        ["Ultimo Unico persone"]: "Last Individual's Income Tax Return",
        ["undefined"]: "undefined",
        ["Underwriter"]: "Underwriter",
        ["Unico Coobbligati"]: "Income Tax Return for Co-obligors",
        ["Unico Persone"]: "Income Tax Return for Individual",
        ["Unico Società"]: "Income Tax Return for Companies",
        ["UnitaImmobiliare"]: "Subject of the Cover",
        ["Upload"]: "Upload",
        ["Urologia"]: "Urology",
        ["Username"]: "Username",
        ["Utente sottoscrittore"]: "Underwriter User",
        ["Utente"]: "User",
        ["UtenteAnag"]: "User",
        ["UtenteErrato"]: "Wrong User",
        ["Utenti"]: "Users",
        ["Utile (perdita) d'esercizio"]: "Net Profit (Loss)",
        ["Utility"]: "Utility",
        ["Utilizzo affidamento"]: "Credit Line",
        ["UW RCP"]: "UW RCP",
        ["Va inserito solo il codice numero delle ISO delimitato da ,"]: "Please insert ISO codes between commas",
        ["VA-Accettata"]: "Accepted",
        ["Vai"]: "Go",
        ["VA-InValutazione"]: "In the process of being assessed",
        ["Validato"]: "Validated",
        ["Validazione Affidamento"]: "Client Approved",
        ["Valore produzione anno precedente"]: "Previous Year Turnover",
        ["Valore Produzione Ultimo Anno"]: "Last Year Turnover",
        ["Valore Produzione"]: "Turnover",
        ["Valore"]: "Value",
        ["ValoreOpera"]: "Works value",
        ["Value is not valid"]: "Value is not valid",
        ["Valutazione salvata correttamente con ID: {1-S}"]: "Assessment successfully saved with ID: {1-S}",
        ["Valutazione"]: "Assessment",
        ["VALUTAZIONE"]: "ASSESSMENT",
        ["ValutazioneNegativa"]: "Negative Assessment",
        ["ValutazioneNonValida"]: "Assessment declined: it's impossible to issue a policy",
        ["ValutazionePositiva"]: "Positive Assessment",
        ["Valutazioni"]: "Assessments",
        ["VA-Rifiutata"]: "Declined",
        ["Vecchia password"]: "Old Password",
        ["Verifica salvata correttamente"]: "Assessment successfully saved",
        ["Verifica"]: "Check",
        ["Veterinari"]: "Vet",
        ["Vi sono titoli della Società negoziati in mercati regolamentati?"]: "Are there any Company securities traded on regulated markets?",
        ["VistoLeggero"]: "Light Visa",
        ["VistoPesante"]: "Heavy Visa",
        ["Visualizza il capogruppo"]: "Group Leader - Field visible",
        ["Visualizza"]: "View",
        ["Visualizzatori"]: "Viewer",
        ["Visura Camerale"]: "Chamber of Commerce Company Registration",
        ["Visura Catastale"]: "Cadastral Certificate",
        ["Visure Coobbligati"]: "Cadastral Certificate Co-obligors",
        ["WARNING"]: "WARNING",
        ["Warning"]: "Warning",
        ["WebDesign"]: "Web design",
        ["Year - Month - Week"]: "Year - Month - Week",
        ["ErroreDataScadenzaPolizzaInferioreDataInizioPolizza"]: "Expiry date lower than start date",
        ["ErroreSovrapposizionePeriodiAssicurativi"]: "Policies dates overlap",
        ["ErroreDataInizio"]: "Start date error",
        ["ErroreDataScadenza"]: "Expiry date error",
        ["ErrorePolizzaPrecedenteAlpha"]: "Alpha previous policy",
        ["PolizzaGiaEmessa"]: "Policy already issued",
        ["Utilizza"]: "Copy",
        ["StessoID_Anag"]: "Same company",
        ["StessoID_Utente"]: "Same user",
        ["NumeroUtilizzi"]: "Count",
        ["BancaDatiGare"]: "Tenders database",
        ["NoMaxNoDistraintInstallmentReduction"]: "Non è possibile procedere con la Delega perchè il Cedente raggiunge i Requisiti Pensionistici durante il Finanziamento",
        ["NoMaxDistraintInstallmentReduction"]:
            "Non è possibile procedere con la Delega in considerazione dei PIGNORAMENTI presenti; inoltre il Cedente raggiunge i Requisiti Pensionistici durante la durata del Finanziamento",
        ["NoMaxDistraintNoInstallmentReduction"]: "Non è possibile procedere con la Delega in considerazione dei PIGNORAMENTI presenti",
        ["MaxNoDistraintInstallmentReduction"]:
            "La Rata Ceduta è oltre il Quinto Cedibile pari ad {1-I} inoltre non è possibile procedere con la Delega perchè il Cedente raggiunge i Requisiti Pensionistici durante il Finanziamento",
        ["MaxNoDistraintNoInstallmentReduction"]: "La rata non può superare 1/5 dello Stipendio Netto Mensile. In questo caso la Rata Ceduta Massima è pari ad {1-I}",
        ["MaxDistraintInstallmentReduction"]:
            "La Rata Ceduta è oltre il Quinto Cedibile pari ad {1-I} inoltre non è possibile procedere con la Delega perchè sono presenti PIGNORAMENTI e perchè il Cedente raggiunge i Requisiti Pensionistici durante la durata del Finanziamento",
        ["MaxDistraintNoInstallmentReduction"]: "La Rata Ceduta è oltre il Quinto Cedibile pari ad {1-I} inoltre non è possibile procedere con la Delega in considerazione dei PIGNORAMENTI presenti",
        ["MilitaryNoMaxNoDistraintInstallmentReduction"]: "Non è possibile procedere con la Delega perchè il Cedente (Militare) raggiunge i Requisiti Pensionistici durante il Finanziamento",
        ["MilitaryNoMaxDistraintInstallmentReduction"]:
            "Non è possibile procedere con la Delega in considerazione dei PIGNORAMENTI presenti; inoltre il Cedente (Militare) raggiunge i Requisiti Pensionistici durante la durata del Finanziamento",
        ["MilitaryMaxNoDistraintInstallmentReduction"]:
            "La Rata Ceduta è oltre il Quinto Cedibile pari ad {1-I} inoltre, non è possibile procedere con la Delega perchè il Cedente (Militare) raggiunge i Requisiti Pensionistici durante il Finanziamento",
        ["MilitaryMaxDistraintInstallmentReduction"]:
            "La Rata Ceduta è oltre il Quinto Cedibile pari ad {1-I} inoltre non è possibile procedere con la Delega perchè sono presenti PIGNORAMENTI e perchè il Cedente (Militare) raggiunge i Requisiti Pensionistici durante la durata del Finanziamento",
        ["No Copertura"]: "No coverage",
        ["12 mesi"]: "12 months",
        ["24 mesi"]: "24 months",
        ["Nuovi edifici civili commerciali  industriali, scuole, ospedali, garages etc"]: "New civil buildings commercials, industrials, schools, hospitals, garages, etc",
        ["Ristrutturazione edifici di cui al punto 1) senza intervento su strutture portanti"]: "Renovation of the civil buildings of point 1) excluding works on bearing structures",
        ["Ristrutturazione edifici di cui al punto 1) con  intervento su strutture portanti (escluse sottomurazioni e sottofondazioni)"]: "Renovation of the civil buildings of point 1) including works on bearing structures (excluding foundations)",
        ["Interventi su edifici che prevedano sottomurazioni e/o sottofondazioni"]: "Works on buildings including works on foundations",
        ["Relizzazione o ristrutturazione strade con opere d'arte inferiori al 20% contratto (ponti viadotto gallerie art. - no gallerie naturali )"]: "Realisation or renovation of streets  with great works lower than 20%  of the value of the contract (great works: bridges, viaducts, galleries, etc.. - excluding natural galleries)",
        ["Relizzazione o ristrutturazione strade con opere d'arte dal 20% al 50% contratto (ponti viadotto gallerie art. - no gallerie naturali )"]: "Realisation or renovation of streets with great works between 20% and 50% of the value of the contract",
        ["Relizzazione o ristrutturazione strade con opere d'arte superiori al 50% contratto (ponti viadotto gallerie art. - no gallerie naturali )"]: "Realisation or renovation of streets with great works higher than 50% of the value of the contract",
        ["Opere urbanizzazioni primarie e secondarie, impianti depurazioni e discariche"]: "Realisation or renovation of streets with great works higher than 50% of the value of the contract",
        ["Realizzazione acquedotti e opere irrigazione"]: "Acqueducts and water main",
        ["Opere Bagnate"]: "In water works (i.e: harbours, off-shore, etc..)",
        ["€ 500.000,00"]: "€ 500.000,00",
        ["€ 750.000,00"]: "€ 750.000,00",
        ["€ 1.000.000,00"]: "€ 1.000.000,00",
        [""]: "",
    };

    private readonly TestiIT: { [T: string]: string } = {
        ["EmissioneDirettaPOSNonPermessa"]: "Emissione diretta non permessa",
        ["Save personal data"]: "Salva i dati personali",
        ["ErroreEmissioneOrarioUfficio"]: "Errore emissione polizza fuori orari lavorativi",
        ["EmissioneOrarioUfficio"]: "Emissione solo in orari lavorativi",
        ["Passa a: "]: "Passa a: ",
        ["Password change"]: "Cambio di password",
        ["Password has been changed"]: "La password è stata cambiata",
        ["CampoWordMassimoUnaTabella"]: "E' consentito inserire una sola tabella",
        ["PremioImpostatoInferioreAlPremioMinimo"]: "Premio impostato inferiore al premio minimo",
        ["PremioImpostatoSuperioreAlLimite"]: "Premio impostato superiore al limite",
        ["ProroghePremioNetto"]: "Proroghe - Premio netto",
        ["ProrogheAccessori"]: "Proroghe - Accessori",
        ["ProrogheDirittiEmissione"]: "Proroghe - Diritti",
        ["ProrogheImponibile"]: "Proroghe - Imponibile",
        ["ProrogheImposte"]: "Proroghe - Imposte",
        ["ProroghePremioFinito"]: "Proroghe - Lordo",
        ["ProrogheTipo"]: "Proroghe - Tipo",
        ["ProrogheDa"]: "Proroghe - Dal",
        ["ProrogheA"]: "Proroghe - Al",
        ["Trimestrale"]: "Trimestrale",
        ["% assicurata"]: "% assicurata",
        ["% CoAssicurazione minima"]: "% CoAssicurazione minima",
        ["[Dati][Dato][ID_AnagContraente]"]: "Anagrafica Contraente",
        ["[DatoRCPPolizza][AltreAttivita][DatiQuestionario][][items][Descrizione]"]: "Altre attività - Descrizione",
        ["[DatoRCPPolizza][AltreAttivita][RispostaAperturaQuestionario]"]: "Altre attività",
        ["[DatoRCPPolizza][Anagrafiche][]"]: "Anagrafiche",
        ["[DatoRCPPolizza][Anagrafiche][length]"]: "Numero di Anagrafiche inserite",
        ["[DatoRCPPolizza][Ass][DatiQuestionario][][items][PassatoEsercizio]"]: "Fatturato Consuntivo - Imprese di Assicurazione",
        ["[DatoRCPPolizza][Ass][DatiQuestionario][][items][PIVA]"]: "Imprese di assicurazione - P.IVA",
        ["[DatoRCPPolizza][Ass][DatiQuestionario][][items][Societa]"]: "Imprese di assicurazione - Società",
        ["[DatoRCPPolizza][Ass][RispostaAperturaQuestionario]"]: "Imprese di assicurazione",
        ["[DatoRCPPolizza][AttivitaOspedaliera][DatiQuestionario][][items][Struttura]"]: "Attività Ospedaliera - Struttura pubblica o privata",
        ["[DatoRCPPolizza][AttivitaOspedaliera][RispostaAperturaQuestionario]"]: "Attività Ospedaliera",
        ["[DatoRCPPolizza][AttivitaPatrocinatore][DatiQuestionario][0][items][PassatoEsercizio]"]: "Fatturato Consuntivo - Patrocinatore",
        ["[DatoRCPPolizza][AttivitaPatrocinatore][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Fatturato Preventivo - Patrocinatore",
        ["[DatoRCPPolizza][Azionisti][DatiQuestionario][][items][Descrizione]"]: "Azionisti che detengono più del 10% del capitale della Società - Descrizione",
        ["[DatoRCPPolizza][Azionisti][DatiQuestionario][][items][Percentuale]"]: "Azionisti che detengono più del 10% del capitale della Società - Percentuale",
        ["[DatoRCPPolizza][Azionisti][RispostaAperturaQuestionario]"]: "Azionisti che detengono più del 10% del capitale della Società",
        ["[DatoRCPPolizza][BilancioCertificato][DatiQuestionario][][items][Descrizione]"]: "Bilancio della Società soggetto a certificazione - Descrizione",
        ["[DatoRCPPolizza][BilancioCertificato][RispostaAperturaQuestionario]"]: "Bilancio della Società soggetto a certificazione",
        ["[DatoRCPPolizza][BilCon][DatiQuestionario][][items][PassatoEsercizio]"]: "Fatturato Consuntivo - Società tenute alla redazione del bilancio consolidato",
        ["[DatoRCPPolizza][BilCon][DatiQuestionario][][items][PIVA]"]: "Società tenute alla redazione del bilancio consolidato - P.IVA]",
        ["[DatoRCPPolizza][BilCon][DatiQuestionario][][items][Societa]"]: "Società tenute alla redazione del bilancio consolidato - Società",
        ["[DatoRCPPolizza][BilCon][RispostaAperturaQuestionario]"]: "Società tenute alla redazione del bilancio consolidato",
        ["[DatoRCPPolizza][ClientiFalliti][DatiQuestionario][][items][PIVA]"]: "Sindaco o Amministratore presso società sottoposte a procedure concorsuali - P.IVA",
        ["[DatoRCPPolizza][ClientiFalliti][DatiQuestionario][][items][Societa]"]: "Sindaco o Amministratore presso società sottoposte a procedure concorsuali - Società",
        ["[DatoRCPPolizza][ClientiFalliti][RispostaAperturaQuestionario]"]: "Sindaco o Amministratore presso società sottoposte a procedure concorsuali",
        ["[DatoRCPPolizza][Consorzio][DatiQuestionario][][items][PassatoEsercizio]"]:
            "Fatturato Consuntivo - Consorzi o altri simili organismi in cui qualcuna delle precedenti società/aziende/imprese, partecipi",
        ["[DatoRCPPolizza][Consorzio][DatiQuestionario][][items][PIVA]"]: "Consorzi o altri simili organismi in cui qualcuna delle precedenti società/aziende/imprese, partecipi - P.IVA]",
        ["[DatoRCPPolizza][Consorzio][DatiQuestionario][][items][Societa]"]: "Consorzi o altri simili organismi in cui qualcuna delle precedenti società/aziende/imprese, partecipi - Societa]",
        ["[DatoRCPPolizza][Consorzio][RispostaAperturaQuestionario]"]: "Consorzi o altri simili organismi in cui qualcuna delle precedenti società/aziende/imprese, partecipi",
        ["[DatoRCPPolizza][Credito][DatiQuestionario][][items][PassatoEsercizio]"]: "Fatturato Consuntivo - Aziende di credito o bancarie",
        ["[DatoRCPPolizza][Credito][DatiQuestionario][][items][PIVA]"]: "Aziende di credito o bancarie - P.IVA",
        ["[DatoRCPPolizza][Credito][DatiQuestionario][][items][Societa]"]: "Aziende di credito o bancarie - Società",
        ["[DatoRCPPolizza][Credito][RispostaAperturaQuestionario]"]: "Aziende di credito o bancarie",
        ["[DatoRCPPolizza][Curatore][DatiQuestionario][0][items][PassatoEsercizio]"]: "Fatturato Consuntivo - Liquidatore o curatore fallimentare",
        ["[DatoRCPPolizza][Curatore][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Fatturato Preventivo - Liquidatore o curatore fallimentare",
        ["[DatoRCPPolizza][Dipendente][DatiQuestionario][][items][Struttura]"]: "Dipendente - Ente o Azienda sanitaria pubblica]",
        ["[DatoRCPPolizza][Dipendente][RispostaAperturaQuestionario]"]: "Dipendente di Ente o Azienda sanitaria pubblica",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][CAP]"]: "EDP - CAP",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][Citta]"]: "EDP - Città",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][Indirizzo]"]: "EDP - Indirizzo",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][PassatoEsercizio]"]: "Fatturato Consuntivo - EDP",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][PIVA]"]: "EDP - P.IVA",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][Provincia]"]: "EDP - Provincia",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][Societa]"]: "EDP - Società",
        ["[DatoRCPPolizza][EDP][DatiQuestionario][][items][StimaEsercizioCorrente]"]: "Fatturato Preventivo - EDP",
        ["[DatoRCPPolizza][EDP][RispostaAperturaQuestionario]"]: "EDP",
        ["[DatoRCPPolizza][Eventi][DatiQuestionario][][items][Descrizione]"]: "Conoscenza di fatti che potrebbero dare luogo a richieste di RISARCIMENTO o procedimenti penali - Descrizione",
        ["[DatoRCPPolizza][Eventi][RispostaAperturaQuestionario]"]: "Conoscenza di fatti che potrebbero dare luogo a richieste di RISARCIMENTO o procedimenti penali",
        ["[DatoRCPPolizza][Fin][DatiQuestionario][][items][PassatoEsercizio]"]: "Fatturato Consuntivo - Società finanziarie, di qualunque tipo",
        ["[DatoRCPPolizza][Fin][DatiQuestionario][][items][PIVA]"]: "Società finanziarie, di qualunque tipo - P.IVA",
        ["[DatoRCPPolizza][Fin][DatiQuestionario][][items][Societa]"]: "Società finanziarie, di qualunque tipo - Società",
        ["[DatoRCPPolizza][Fin][RispostaAperturaQuestionario]"]: "Società finanziarie, di qualunque tipo",

        ["[DatoRCPPolizza][FunzioniPubbliche][DatiQuestionario][0][items][PassatoEsercizio]"]: "Fatturato Consuntivo - Funzioni Pubbliche",
        ["[DatoRCPPolizza][FunzioniPubbliche][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Fatturato Preventivo - Funzioni Pubbliche",

        ["[DatoRCPPolizza][OCC][DatiQuestionario][0][items][PassatoEsercizio]"]: "Fatturato Consuntivo - OCC",
        ["[DatoRCPPolizza][OCC][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Fatturato Preventivo - OCC",
        ["[DatoRCPPolizza][ODV][DatiQuestionario][0][items][PassatoEsercizio]"]: "Fatturato Consuntivo - ODV",
        ["[DatoRCPPolizza][ODV][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Fatturato Preventivo -ODV",

        ["[DatoRCPPolizza][Fusione][DatiQuestionario][][items][Data]"]: "Acquisizioni o fusioni con altre Società - Data",
        ["[DatoRCPPolizza][Fusione][DatiQuestionario][][items][Descrizione]"]: "Acquisizioni o fusioni con altre Società - Descrizione",
        ["[DatoRCPPolizza][Fusione][RispostaAperturaQuestionario]"]: "Acquisizioni o fusioni con altre Società",
        ["[DatoRCPPolizza][ImplantologiaAltre][DatiQuestionario][][items][ImplantologiaAltreDescr]"]: "Descrizione tipo di Implantologia",
        ["[DatoRCPPolizza][ImplantologiaAltre][RispostaAperturaQuestionario]"]: "Altra Implantologia",
        ["[DatoRCPPolizza][IncarichiProfessionaliRegimeDiGeneralContractor][DatiQuestionario][][items][Descrizione]"]: "Incarichi professionali in regime di General Contractor - Descrizione",
        ["[DatoRCPPolizza][IncarichiProfessionaliRegimeDiGeneralContractor][DatiQuestionario][][items][Fatturato]"]: "Incarichi professionali in regime di General Contractor - Fatturato",
        ["[DatoRCPPolizza][IncarichiProfessionaliRegimeDiGeneralContractor][DatiQuestionario][][items][Valore]"]: "Incarichi professionali in regime di General Contractor - Valore",
        ["[DatoRCPPolizza][IncarichiProfessionaliRegimeDiGeneralContractor][RispostaAperturaQuestionario]"]: "Incarichi professionali in regime di General Contractor",
        ["[DatoRCPPolizza][Indagine][DatiQuestionario][][items][DataEvento]"]: "Indagine - Data Evento",
        ["[DatoRCPPolizza][Indagine][DatiQuestionario][][items][DescrizioneEvento]"]: "Indagine - Descrizione Evento",
        ["[DatoRCPPolizza][Indagine][DatiQuestionario][][items][StatoCircostanza]"]: "Indagine - Stato dell'Evento",
        ["[DatoRCPPolizza][Indagine][RispostaAperturaQuestionario]"]: "Indagine",
        ["[DatoRCPPolizza][InformazioniAzioni][DatiQuestionario][][items][DataEvento]"]: "Azioni, omissioni o circostanze - Data Evento]",
        ["[DatoRCPPolizza][InformazioniAzioni][DatiQuestionario][][items][DescrizioneEvento]"]: "Azioni, omissioni o circostanze - Descrizione Evento]",
        ["[DatoRCPPolizza][InformazioniAzioni][DatiQuestionario][][items][StatoCircostanza]"]: "Azioni, omissioni o circostanze - Stato]",
        ["[DatoRCPPolizza][InformazioniAzioni][RispostaAperturaQuestionario]"]: "Azioni, omissioni o circostanze",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][DatiQuestionario][][items][Compagnia]"]: "Precedenti Assicurativi - Compagnia",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][DatiQuestionario][][items][DataInizio]"]: "Precedenti Assicurativi - Data di Inizio",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][DatiQuestionario][][items][DataScadenza]"]: "Precedenti Assicurativi - Data di Scadenza",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][DatiQuestionario][][items][Massimale]"]: "Precedenti Assicurativi - Massimale",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][DatiQuestionario][][items][NumeroAnniCoperturaPrecedenteContinua]"]: "Precedenti Assicurativi -Anni copertura continua",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][DatiQuestionario][][items][PremioPagato]"]: "Precedenti Assicurativi - Premio Pagato",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][DatiQuestionario][][items][Retroattivita]"]: "Precedenti Assicurativi - Retroattivita",
        ["[DatoRCPPolizza][InformazioniPrecedentiAssicurativi][RispostaAperturaQuestionario]"]: "Precedenti Assicurativi",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][Compagnia]"]: "Richieste di risarcimento - Compagnia",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][DataEvento]"]: "Richieste di risarcimento - Data Evento",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][DataRichiesta]"]: "Richieste di risarcimento - Data Richiesta",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][DenunciaCompagnia]"]: "Richieste di risarcimento - Denuncia a Compagnia",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][DescrizioneEvento]"]: "Richieste di risarcimento - Descrizione Evento",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][ImportoRichiesto]"]: "Richieste di risarcimento - Importo Richiesto",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][Preventivo]"]: "Richieste di risarcimento - Preventivo",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][ResponsabilitaAcclarate]"]: "Richieste di risarcimento - Responsabilità Acclarate",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][StatoSinistro]"]: "Richieste di risarcimento - Stato",
        ["[DatoRCPPolizza][InformazioniSinistri][DatiQuestionario][][items][TerminiRinnovo]"]: "Richieste di risarcimento - Termini di Rinnovo",
        ["[DatoRCPPolizza][InformazioniSinistri][RispostaAperturaQuestionario]"]: "Richieste di risarcimento",
        ["[DatoRCPPolizza][LiberoProfessionista] "]: "Libero Professionista",
        ["[DatoRCPPolizza][LiberoProfSSNExtramoenia]"]: "Attività Libero Professionale - Convenzionato SSN - Extramoenia",
        ["[DatoRCPPolizza][Licenziamento][DatiQuestionario][][items][Descrizione]"]: "Procedure di licenziamento o pensionamento anticipato - Descrizione",
        ["[DatoRCPPolizza][Licenziamento][RispostaAperturaQuestionario]"]: "Procedure di licenziamento o pensionamento anticipato",
        ["[DatoRCPPolizza][MedicoFrequentatore][DatiQuestionario][][items][Reparto]"]: "Medico Frequentatore - Reparto",
        ["[DatoRCPPolizza][MedicoFrequentatore][DatiQuestionario][][items][Struttura]"]: "Medico Frequentatore - Struttura pubblica o privata",
        ["[DatoRCPPolizza][MedicoFrequentatore][RispostaAperturaQuestionario]"]: "Medico Frequentatore",
        ["[DatoRCPPolizza][MembroCdA][DatiQuestionario][0][items][PassatoEsercizio]"]: "Fatturato Consuntivo - Membro CdA",
        ["[DatoRCPPolizza][MembroCdA][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Fatturato Preventivo - Membro CdA",
        ["[DatoRCPPolizza][ModificaRagioneSociale][DatiQuestionario][][items][Data]"]: "Modifica Ragione Sociale - Data",
        ["[DatoRCPPolizza][ModificaRagioneSociale][DatiQuestionario][][items][Descrizione]"]: "Modifica Ragione Sociale - Descrizione",
        ["[DatoRCPPolizza][ModificaRagioneSociale][RispostaAperturaQuestionario]"]: " Modifica Ragione Sociale",
        ["[DatoRCPPolizza][NumeroAssicurati]"]: "Numero degli Assicurati",
        ["[DatoRCPPolizza][NuoviTitoli][DatiQuestionario][][items][Descrizione]"]: "Acquisizioni, offerte pubbliche o fusioni - Descrizione",
        ["[DatoRCPPolizza][NuoviTitoli][RispostaAperturaQuestionario]"]: "Acquisizioni, offerte pubbliche o fusioni",
        ["[DatoRCPPolizza][OperaMerloni][DatiQuestionario][][items][DataFineLavori]"]: "Opera Merloni - Data Fine Lavori",
        ["[DatoRCPPolizza][OperaMerloni][DatiQuestionario][][items][DataInizioLavori]"]: "Opera Merloni - Data Inizio Lavori",
        ["[DatoRCPPolizza][OperaMerloni][DatiQuestionario][][items][DescrizioneLavori]"]: "Opera Merloni - Descrizione Lavori",
        ["[DatoRCPPolizza][OperaMerloni][DatiQuestionario][][items][LuogoEsecuzione]"]: "Opera Merloni - LuogoEsecuzione",
        ["[DatoRCPPolizza][OperaMerloni][DatiQuestionario][][items][StazioneAppaltante]"]: "Opera Merloni - Stazione Appaltante",
        ["[DatoRCPPolizza][OperaMerloni][DatiQuestionario][][items][ValoreOpera]"]: "Opera Merloni - Valore Opera",
        ["[DatoRCPPolizza][OperaMerloni][RispostaAperturaQuestionario]"]: "Opera Merloni",
        ["[DatoRCPPolizza][ProcedimentiPenali][DatiQuestionario][][items][Descrizione]"]: "Procedimenti Penali - Descrizione",
        ["[DatoRCPPolizza][ProcedimentiPenali][RispostaAperturaQuestionario]"]: "Procedimenti Penali",
        ["[DatoRCPPolizza][Quotate][DatiQuestionario][][items][PassatoEsercizio]"]: "Fatturato Consuntivo -  Società quotate nei mercati finanziari ufficiali",
        ["[DatoRCPPolizza][Quotate][DatiQuestionario][][items][PIVA]"]: "Società quotate nei mercati finanziari ufficiali - P.IVA",
        ["[DatoRCPPolizza][Quotate][DatiQuestionario][][items][Societa]"]: "Società quotate nei mercati finanziari ufficiali - Società",
        ["[DatoRCPPolizza][Quotate][RispostaAperturaQuestionario]"]: "Società quotate nei mercati finanziari ufficiali",
        ["[DatoRCPPolizza][Revisore][DatiQuestionario][0][items][PassatoEsercizio]"]: "Fatturato Consuntivo - Attività FT",
        ["[DatoRCPPolizza][Revisore][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Fatturato Preventivo - Attività FT",

        ["[DatoRCPPolizza][RevisoreComm][DatiQuestionario][0][items][PassatoEsercizio]"]: "Fatturato Consuntivo - Revisore",
        ["[DatoRCPPolizza][RevisoreComm][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Fatturato Preventivo - Revisore",

        ["[DatoRCPPolizza][RevisoreEntiPubblici][DatiQuestionario][0][items][PassatoEsercizio]"]: "Fatturato Consuntivo - Revisore Enti Pubblici",
        ["[DatoRCPPolizza][RevisoreEntiPubblici][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Fatturato Preventivo - Revisore Enti Pubblici",
        ["[DatoRCPPolizza][RichiesteRisarcimento][DatiQuestionario][][items][Descrizione]"]: "Richieste di risarcimento - Descrizione",
        ["[DatoRCPPolizza][RichiesteRisarcimento][RispostaAperturaQuestionario]"]: "Richieste di risarcimento",
        ["[DatoRCPPolizza][RifiutoCopertura][DatiQuestionario][][items][AnnoRichiesta]"]: "Rifiuto Coperture Assicurative - Anno Richiesta",
        ["[DatoRCPPolizza][RifiutoCopertura][DatiQuestionario][][items][Compagnia]"]: "Rifiuto Coperture Assicurative - Compagnia",
        ["[DatoRCPPolizza][RifiutoCopertura][DatiQuestionario][][items][Motivo]"]: "Rifiuto Coperture Assicurative - Motivo",
        ["[DatoRCPPolizza][RifiutoCopertura][RispostaAperturaQuestionario]"]: "Rifiuto Coperture Assicurative",
        ["[DatoRCPPolizza][Rischio][DatiQuestionario][][items][PassatoEsercizio]"]: "Fatturato Consuntivo - Società che fanno ricorso al mercato del capitale di rischio",
        ["[DatoRCPPolizza][Rischio][DatiQuestionario][][items][PIVA]"]: "Società che fanno ricorso al mercato del capitale di rischio - P.IVA",
        ["[DatoRCPPolizza][Rischio][DatiQuestionario][][items][Societa]"]: "Società che fanno ricorso al mercato del capitale di rischio - Società",
        ["[DatoRCPPolizza][Rischio][RispostaAperturaQuestionario]"]: "Società che fanno ricorso al mercato del capitale di rischio",
        ["[DatoRCPPolizza][SediSecondarie][DatiQuestionario][][items][CAP]"]: "Sedi Secondarie - CAP",
        ["[DatoRCPPolizza][SediSecondarie][DatiQuestionario][][items][Citta]"]: "Sedi Secondarie - Città",
        ["[DatoRCPPolizza][SediSecondarie][DatiQuestionario][][items][Indirizzo]"]: "Sedi Secondarie - Indirizzo",
        ["[DatoRCPPolizza][SediSecondarie][DatiQuestionario][][items][Provincia]"]: "Sedi Secondarie - Provincia",
        ["[DatoRCPPolizza][SediSecondarie][RispostaAperturaQuestionario]"]: "Sedi Secondarie",

        ["[DatoRCPPolizza][Sindaco][DatiQuestionario][0][items][PassatoEsercizio]"]: "Fatturato Consuntivo - Sindaco",
        ["[DatoRCPPolizza][Sindaco][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Fatturato Preventivo - Sindaco",


        ["[DatoRCPPolizza][StabiliCondominiali][DatiQuestionario][0][items][PassatoEsercizio]"]: "Fatturato Consuntivo - Amministratore di stabili condominiali",
        ["[DatoRCPPolizza][StabiliCondominiali][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Fatturato Preventivo -  - Amministratore di stabili condominiali",
        ["[DatoRCPPolizza][Struttura] è obbligatorio"]: "Compilare nella sezione del Questionario 'Altre Informazioni' il nome della Struttura",
        ["[DatoRCPPolizza][Titoli][DatiQuestionario][][items][Data]"]: "Titoli della Società negoziati in mercati regolamentati - Data",
        ["[DatoRCPPolizza][Titoli][DatiQuestionario][][items][Descrizione]"]: "Titoli della Società negoziati in mercati regolamentati - Descrizione",
        ["[DatoRCPPolizza][Titoli][RispostaAperturaQuestionario]"]: "Titoli della Società negoziati in mercati regolamentati",
        ["[DatoRCPPolizza][VariazioneDipendenti][DatiQuestionario][][items][Descrizione]"]: "Riduzione o incremento del numero totale dei dipendenti - Descrizione",
        ["[DatoRCPPolizza][VariazioneDipendenti][RispostaAperturaQuestionario]"]: "Riduzione o incremento del numero totale dei dipendenti",
        ["[DatoRCPPolizza][VistoLeggero][DatiQuestionario][0][items][PassatoEsercizio]"]: "Fatturato Consuntivo - Visto Leggero",
        ["[DatoRCPPolizza][VistoLeggero][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Fatturato Preventivo - Visto Leggero",
        ["[DatoRCPPolizza][VistoPesante][DatiQuestionario][0][items][PassatoEsercizio]"]: "Fatturato Consuntivo - VistoPesante",
        ["[DatoRCPPolizza][VistoPesante][DatiQuestionario][0][items][StimaEsercizioCorrente]"]: "Fatturato Preventivo - Visto Pesante",
        ["[PreventivoSelezionato]"]: "Preventivo Selezionato",
        ["{1-B}"]: "{1-B}",
        ["{1-D}"]: "{1-D}",
        ["{1-I}"]: "{1-I}",
        ["{1-N}"]: "{1-N}",
        ["{1-P}"]: "{1-P}",
        ["{1-R}"]: "{1-R}",
        ["{1-S} - CFPIVA: {2-S} - ID: {3-S}"]: "{1-S} - C.F./P.IVA: {2-S} - ID: {3-S}",
        ["{1-S}"]: "{1-S}",
        ["{1-S}: Affidamento utilizzato {2-I}"]: "{1-S}: Aff. utilizzato {2-I}",
        ["{1-S}: Limite rimasto {2-I}"]: "{1-S}: Limite rimasto {2-I}",
        ["{1-S}: Limite utilizzato {2-I}"]: "{1-S}: Limite utilizzato {2-I}",
        ["{1-S}diversoDa{2-S}"]: "{1-S }diverso da {2-S}",
        ["{1-S}èObbligatorio"]: "{1-S} è obbligatorio",
        ["{1-S}inferioreAl{2-S}"]: "{1-S} inferiore a {2-S}",
        ["{1-S}NonHaRaggiuntoValoreNecessario{2-D}SeiSoloA{3-D}"]: "{1-S} non ha raggiunto il valore necessario {2-D}, hai scritto {3-D}",
        ["{1-S}superioreDel{2-S}"]: "{1-S} superiore Del {2-S}",
        ["{1-T}"]: "{1-T}",
        ["…"]: "…",
        ["0"]: "0",
        ["1"]: "1",
        ["10"]: "10",
        ["1000000"]: "1.000.000",
        ["1000000/2000000"]: "1.000.000/2.000.000",
        ["1500000"]: "1.500.000",
        ["2"]: "2",
        ["2000000"]: "2.000.000",
        ["2500000"]: "2.500.000",
        ["2000000/4000000"]: "2.000.000/4.000.000",
        ["210"]: "210",
        ["250000"]: "250.000",
        ["3"]: "3",
        ["350000"]: "350.000",
        ["3000000"]: "3.000.000",
        ["3500000"]: "3.500.000",
        ["4"]: "4",
        ["4000000"]: "4.000.000",
        ["5"]: "5",
        ["500000"]: "500.000",
        ["5000000"]: "5.000.000",
        ["500000/1000000"]: "500.000/1.000.000",
        ["6"]: "6",
        ["7"]: "7",
        ["730"]: "730",
        ["750000"]: "750.000",
        ["750000/1250000"]: "750.000/1.250.000",
        ["8"]: "8",
        ["9"]: "9",
        ["A seguito di indagine, il Proponente e/o gli Assicurati risultano essere a conoscenza di Circostanze o Eventi che possano dare origine a una richiesta di risarcimento nei confronti del Proponente stesso in relazione all'incarico professionale – Attività di Sindaco/Revisore dei Conti, Amm.re società, Attività OdV 231/2001 (o altro) – indicato nella presente proposta?"]:
            "A seguito di indagine, il Proponente e/o gli Assicurati risultano essere a conoscenza delle seguenti Circostanze o Eventi che possano dare origine a una richiesta di risarcimento nei confronti del Proponente stesso in relazione all'incarico professionale – Attività di Sindaco/Revisore dei Conti, Amm.re società, Attività OdV 231/2001 (o altro) – indicato nella presente proposta?",
        ["A"]: "A",
        ["A.T.I."]: "A.T.I.",
        ["Abilitare alle chiamate Ribes"]: "Abilitare alle chiamate Ribes",
        ["Abilitazione funzione"]: "Abilitazione funzione",
        ["Accessori"]: "Accessori",
        ["AccessoriImporto"]: "Accessori Importo",
        ["ACCETTABILE"]: "ACCETTABILE",
        ["Accettata"]: "Accettata",
        ["Accordi con le Compagnie"]: "Accordi con le Compagnie",
        ["Accordo quadro"]: "Accordo quadro",
        ["Adattore"]: "Adattatore di dialoghi",
        ["ADDENDUM ERROR"]: "APPENDICE ERRORE",
        ["Addendum type"]: "Tipo appendice",
        ["Addendum"]: "Appendice",
        ["Addendums"]: "Appendici",
        ["Affidamenti gruppo"]: "Affidamenti gruppo",
        ["Affidamenti non utilizzati {1-I}"]: "Affidamenti non utilizzati {1-I}",
        ["Affidamenti per fideiussioni non provvisorie"]: "Affidamenti per fideiussioni non provvisorie",
        ["Affidamenti per fideiussioni provvisorie"]: "Affidamenti per fideiussioni provvisorie",
        ["Affidamenti per i contraenti"]: "Affidamenti per i contraenti",
        ["Affidamenti"]: "Affidamenti",
        ["Affidamento morto"]: "Affidamento morto",
        ["Affidamento per fideiussioni non provvisorie"]: "Affidamento per fideiussioni non provvisorie",
        ["Affidamento per fideiussioni provvisorie"]: "Affidamento per fideiussioni provvisorie",
        ["Affidamento salvato correttamente con ID: {1-S}"]: "Affidamento salvato correttamente con ID: {1-S}",
        ["Affidamento salvato correttamente"]: "Affidamento salvato correttamente",
        ["Affidamento"]: "Affidamento",
        ["AFFIDAMENTO"]: "AFFIDAMENTO",
        ["Affidatario"]: "Da",
        ["Affidato"]: "A",
        ["Agente"]: "Agente",
        ["Agenti"]: "Agenti in Attività Finanziaria",
        ["Agenti assicurativi"]: "Agenti assicurativi",
        ["Aggiungi"]: "Aggiungi",
        ["AggiungiRubrica"]: "Aggiungi in rubrica",
        ["Agricoltura"]: "Agricoltura",
        ["Al Proponente sono mai state rifiutate coperture assicurative per la Responsabilità Civile Professionale?"]:
            "Al Proponente sono state rifiutate le seguenti coperture assicurative per la Responsabilità Civile Professionale?",
        ["All"]: "Tutti",
        ["Allergologia"]: "Allergologia ed Immunologia Clinica",
        ["AltreAttivita"]: "Altre attività",
        ["AltreAttività"]: "Altre Attività",
        ["AltreInformazioni"]: "Altre informazioni",
        ["Altro"]: "Altro",
        ["Amministratori"]: "Amministratori",
        ["AmministratoriCondominio"]: "Amministratori Stabili Condominiali",
        ["Anag"]: "Anagrafica",
        ["AnagA"]: "A",
        ["AnagA: {1-S} - Data: {3-D} - Scadenza: {4-D} - Provvisorie: {5-I} - NonProvvisorie: {6-I} - ID: {7-S}"]: "Dal: {3-D} - Al: {4-D} - Provv.: {5-I} - Non provv.: {6-I} - ID: {7-S}",
        ["AnagA: {1-S} - Tipo: {2-T} - Data: {3-D} - Scadenza: {4-D} - Importo: {5-I} - ID: {7-S}"]: "Tipo: {2-T} - Dal: {3-D} - Al: {4-D} - Limite: {5-I} - ID: {7-S}",
        ["AnagA: {1-S} - Data: {3-D} - Scadenza: {4-D} - Provvisorie: {5-I} - NonProvvisorie: {6-I} - ID: {7-S} - Compagnie: {8-S}"]:
            "Dal: {3-D} - Al: {4-D} - Provv.: {5-I} - Non provv.: {6-I} - Compagnie: {8-S} - ID: {7-S}",
        ["AnagA: {1-S} - Tipo: {2-T} - Data: {3-D} - Scadenza: {4-D} - Importo: {5-I} - ID: {7-S} - Compagnie: {8-S}"]:
            "Tipo: {2-T} - Dal: {3-D} - Al: {4-D} - Limite: {5-I} - Compagnie: {8-S} - ID: {7-S}",
        ["AnagDa"]: "Da",
        ["ANAGRAFICA ERRORE"]: "ANAGRAFICA ERRORE",
        ["AnagraficaErrore Campi nulli"]: "Alcuni campi sono vuoti!",
        ["AnagraficaErrore Codice fiscale"]: "Codici fiscali non validi!",
        ["AnagraficaErrore Codice fiscale presente"]: "Hai gia inserito questo codice fiscale!",
        ["AnagraficaErrore Salvataggio Anagrafiche"]: "Errore salvataggio dati per le anagrafiche : ",
        ["Anagrafica salvata correttamente con ID: {1-S}"]: "Anagrafica salvata correttamente con ID: {1-S}",
        ["Anagrafica"]: "Anagrafica",
        ["ANAGRAFICA"]: "ANAGRAFICA",
        ["Anagrafiche salvate correttamente"]: "Anagrafiche salvate correttamente",
        ["Anagrafiche"]: "Anagrafiche",
        ["AnagStato"]: "Stato",
        ["Analisi"]: "Analisi/Progettazione/Sviluppo/Realizzazione/Modifica/Installazione/Cessione di Licenza/Gestione: Software - Sistemi informatici - Sistemi di rete",
        ["AnatomiaPatologica"]: "Anatomia Patologica (escluse analisi genetiche)",
        ["Andamento dell'attività di produzione"]: "Andamento dell'attività di produzione",
        ["Andrologia"]: "Andrologia",
        ["AnestRianimTerInt"]: "Anestesia E Rianimazione E Terapia Intensiva",
        ["Angiologia"]: "Angiologia",
        ["AnimaliCompagnia"]: "Attività professionale relativa ad animali da compagnia e piccoli animali in genere",
        ["Anni"]: "Anni",
        ["AnniCostituzione"]: "Anni di Costituzione",
        ["AnniRetroattivita"]: "Anni di retroattività",
        ["Anno Bilancio"]: "Anno Bilancio",
        ["Anno precedente"]: "Anno precedente",
        ["Anno riferimento"]: "Anno riferimento",
        ["Anno Unico"]: "Anno Unico",
        ["AnnoInizioAttivita"]: "Anno Inizio Attivita",
        ["AnnoIscrizioneAlbo"]: "Anno Iscrizione Albo",
        ["AnnoRichiesta"]: "Anno Richiesta",
        ["AnnoRif"]: "Anno riferimento",
        ["Annuale"]: "Annuale",
        ["Annulla"]: "Annulla",
        ["Annullata"]: "Annullata",
        ["Annullamento"]: "Annullamento",
        ["AnnullamentoSeo"]: "Annullamento SEO",
        ["AnnullaPolizza"]: "Annullamento Polizza",
        ["Anticipazioni"]: "Anticipazioni",
        ["Appaltante"]: "Appaltante",
        ["Appartenenza"]: "Appartenenza",
        ["Appendice"]: "Appendice",
        ["Appendice Binder"]: "Appendice Binder",
        ["Appendici"]: "Appendici",
        ["Approva"]: "Approva",
        ["Approvata"]: "Approvata",
        ["Approvato con parere negativo"]: "Valutato con parere negativo",
        ["Approvato con parere positivo"]: "Valutato con parere positivo",
        ["ApprovazioneAffidamento"]: "Approvazione Affidamento",
        ["ApprovazionePolizza"]: "Approvazione Polizza",
        ["APS-Emessa"]: "Appendice approvata",
        ["APS-Preventivo"]: "Preventivo di appendice",
        ["APS-Rifiutata"]: "Appendice rifiutata",
        ["Archeologo"]: "Archeologo",
        ["Architetti"]: "Architetti",
        ["Archivista"]: "Archivista",
        ["Area"]: "Area",
        ["AS-Attivo"]: "Attivo",
        ["AS-InAcquisizione"]: "In Acquisizione",
        ["Ass"]: "Imprese di assicurazione",
        ["Assicuratori"]: "Assicuratori",
        ["AT-Annullamento"]: "Appendice di annullamento",
        ["AT-AnnullamentoSeo"]: "Appendice di annullamento SEO",
        ["ATI"]: "A.T.I.",
        ["AT-Postuma"]: "Appendice di postuma",
        ["AT-DifferimentoDeiTermini"]: "Appendice di differimento dei termini di gara",
        ["AT-PrecisazioniCondizioniContrattuali"]: "Appendice di precisazioni condizioni contrattuali",
        ["AT-Proroga"]: "Appendice di proroga",
        ["AT-PreventivoProroga"]: "Preventivo di appendice di proroga",
        ["Ats"]: "Ats",
        ["AT-Svincolo"]: "Appendice di svincolo",
        ["Attestazione SOA"]: "Attestazione SOA",
        ["Attestazione capacità finanziaria autotrasportatori"]: "Attestazione capacità finanziaria autotrasportatori",
        ["Attivita fiscale tributaria e di revisione in Enti Pubblici"]: "Attività fiscale tributaria e di revisione in Enti Pubblici",
        ["AttivitaEsercitata"]: "Attività Esercitata",
        ["AttivitaOspedaliera"]: "Attività Ospedaliera (dipendente pubblico e altre forme di collaborazione)",
        ["AttivitaPatrocinatore"]: "Attività di patrocinatore stragiudiziale",
        ["Attivo circolante"]: "Attivo circolante",
        ["Attivo"]: "Attivo",
        ["Atto Costitutivo"]: "Atto Costitutivo",
        ["AT-VariazioneRischio"]: "Appendice di variazione Rischio",
        ["AT-VariazioneDati"]: "Appendice di variazione dati",
        ["Autentica digitale notarile"]: "Autentica digitale notarile",
        ["Autentica notarile"]: "Autentica notarile",
        ["Autorizzazione"]: "Autorizzazione",
        ["Autorizzazioni"]: "Autorizzazioni",
        ["Autoscuola"]: "Autoscuola (guida)",
        ["Avanti"]: "Avanti",
        ["Avvocati"]: "Avvocati",
        ["Azienda"]: "Azienda",
        ["Azioni veloci"]: "Azioni veloci",
        ["Azioni"]: "Azioni",
        ["AzioniJSON"]: "Azioni JSON",
        ["Azionista"]: "Azionista",
        ["BancaGare"]: "Banca dati Gare",
        ["Bando Gara"]: "Bando Gara",
        ["Beneficenza"]: "Promotore Organizzazioni Benefiche/Beneficenza",
        ["Beneficiario"]: "Beneficiario",
        ["Bibliotecario"]: "Bibliotecario",
        ["Bilancio"]: "Bilancio",
        ["BilCon"]: "Società tenute alla redazione del bilancio consolidato",
        ["BINDER ERRORE"]: "BINDER ERRORE",
        ["Binder non ancora stipulato"]: "Binder non ancora stipulato",
        ["Binder salvato correttamente con ID: {1-S}"]: "Binder salvato correttamente con ID: {1-S}",
        ["Binder stipulato"]: "Binder stipulato",
        ["Binder"]: "Binder",
        ["BINDER"]: "BINDER",
        ["BinderStato"]: "Binder Stato",
        ["Biologo"]: "Biologo",
        ["BiologoEsclusioni"]: "Biologo (escluse analisi genetiche)",
        ["Bionaturopata"]: "Bionaturopata",
        ["Blocca"]: "Blocca",
        ["Bozza accettata"]: "Bozza accettata",
        ["Bozza emessa"]: "Bozza emessa",
        ["BrandManager"]: "Brand manager",
        ["Broker"]: "Broker",
        ["Broker assicurativi"]: "Broker assicurativi",
        ["BS-Inserito"]: "Inserito",
        ["BS-Stipulato"]: "Stipulato",
        ["BUONA"]: "BUONA",
        ["Business Plan"]: "Business Plan",
        ["Calcola"]: "Calcola",
        ["Calcolato in base ai parametri"]: "Calcolato in base ai parametri",
        ["Calendario"]: "Calendario",
        ["Cambi stati per binder"]: "Cambi stati per binder",
        ["Cambi stati per gli affidamenti"]: "Cambi stati per gli affidamenti",
        ["Cambi stati per le anagrafiche"]: "Cambi stati per le anagrafiche",
        ["Cambi stati per le deroghe"]: "Cambi stati per le deroghe",
        ["Cambi stati per le polizze"]: "Cambi stati per le polizze",
        ["Cambi stati per le valutazioni"]: "Cambi stati per le valutazioni",
        ["Cambia"]: "Cambia",
        ["CambioFideAffidamentoEsitoApprovazioneEsitoNonPermesso"]: "Cambio stato non permesso",
        ["CambioFideAffidamentoEsitoApprovazioneEsitoPartenzaNonTrovato"]: "Stato di Partenza non trovato",
        ["CambioFideAffidamentoEsitoApprovazioneNonPermesso"]: "Cambio Stato non permesso",
        ["CambioPolizzaApprovazioneNonPermesso"]: "Cambio Polizza Approvazione Non Permesso",
        ["CambioPolizzaApprovazionePartenzaNonTrovato"]: "Cambio Polizza Approvazione Partenza Non Trovato",
        ["CambiStatiPerFideAffidamentoApprovazione"]: "Cambi Stati Per Fide Affidamento Approvazione",
        ["CambiStatiPerPolizzaApprovazione"]: "Cambi Stati Per Polizza Approvazione",
        ["Camerale aggiornato"]: "Camerale aggiornato",
        ["Cancella"]: "Cancella",
        ["CAP Immobile"]: "CAP Immobile",
        ["Cap"]: "CAP",
        ["CAP"]: "CAP",
        ["C.A.R."]: "C.A.R.",
        ["CAPImmobile"]: "CAP Immobile",
        ["Capogruppo"]: "Capo gruppo",
        ["Cardiochirurgia"]: "Cardiochirurgia",
        ["Cardiologia"]: "Cardiologia",
        ["CaricaDocumento"]: "Carica il documento",
        ["Caricamento dati polizza"]: "Caricamento dati polizza",
        ["Caricamento in differita, riprovare più tardi"]: "Caricamento in differita, riprovare più tardi",
        ["Caricamento"]: "Caricamento",
        ["Caricamento..."]: "Caricamento...",
        ["Carta d'Identità"]: "Carta d'Identità",
        ["Carta Servizi"]: "Carta Servizi",
        ["CartaServizi"]: "Carta Servizi",
        ["Cartacea"]: "Cartacea",
        ["Categoria"]: "Categoria",
        ["Cauzione definitiva"]: "Cauzione definitiva",
        ["Cauzione provvisoria forniture"]: "Cauzione provvisoria forniture",
        ["Cauzione provvisoria lavori"]: "Cauzione provvisoria lavori",
        ["Cauzione provvisoria servizi"]: "Cauzione provvisoria servizi",
        ["Cellulare"]: "Cellulare",
        ["Cerca"]: "Cerca",
        ["Cerca scaduti"]: "Cerca scaduti",
        ["Certificato SAL"]: "Certificato SAL",
        ["Certificatore"]: "Certificatore Energetico / Sistemi riscaldamento",
        ["AutoscuolaPraticheAutomobilistiche"]: "Autoscuola  e pratiche automobilistiche",
        ["MaestroSci"]: "Maestro di Sci",
        ["CertificatoreGiocattoli"]: "Certificatore giocattoli",
        ["Certificazione Ambientale"]: "Certificazione Ambientale",
        ["CertificazioneAmbientale"]: "Certificazione ambientale",
        ["CertificazioneEnergetica"]: "Certificazione energetica",
        ["CExt1"]: "Pluralità di Assicurati - Responsabilità Civile Incrociata",
        ["CExt2"]: "Danni causati da errori di progettazione e di calcolo",
        ["CExt3"]: "Atti di terzi",
        ["CExt4"]: "Buona fede",
        ["CExt5"]: "RC Danni da Vibrazioni",
        ["CExt6"]: "Cavi o condutture sotterranee",
        ["CExt7"]: "Inquinamento ambientale",
        ["CExt8"]: "Danni da polvere",
        ["CExt9"]: "Maggiori costi per lavoro straordinario, notturno, festivo o trasporto a grande velocità",
        ["CExt10"]: "Interruzione o sospensione dei lavori",
        ["CExt11"]: "Onorario periti",
        ["CExt12"]: "Spese per localizzare il danno",
        ["CF"]: "C.F.",
        ["CFPIVA"]: "P.IVA/C.F.",
        ["Change password"]: "Cambia la password",
        ["ChirurgiaAppDigerente"]: "Chirurgia dell'Apparato Digerente",
        ["ChirurgiaGenerale"]: "Chirurgia Generale",
        ["ChirurgiaMaxFacc"]: "Chirurgia Maxillo - Facciale",
        ["ChirurgiaPediatrica"]: "Chirurgia Pediatrica",
        ["ChirurgiaPlastica"]: "Chirurgia Plastica, Ricostruttiva Ed Estetica",
        ["ChirurgiaToracica"]: "Chirurgia Toracica",
        ["ChirurgiaVascolare"]: "Chirurgia Vascolare",
        ["Chiudi documenti"]: "Chiudi documenti",
        ["Chiudi"]: "Chiudi",
        ["ChiusuraBilancio"]: "Data chiusura del bilancio",
        ["CIG"]: "CIG",
        ["CIGNonTrovato"]: "CIG non trovato",
        ["Citta"]: "Città",
        ["Classe Appartenenza Rifiuti"]: "Classe Appartenenza Rifiuti",
        ["Classificazione"]: "Classificazione",
        ["CoAssicurazione minima"]: "CoAssicurazione minima",
        ["CoAssicurazione solo delegataria"]: "CoAssicurazione solo delegataria",
        ["CoAssicurazione: dati errati"]: "CoAssicurazione: dati errati",
        ["CoAssicurazione: Delegataria non specificata"]: "CoAssicurazione: Delegataria non specificata",
        ["CoAssicurazione: Quote totali inferiori al 100%"]: "CoAssicurazione: Quote totali inferiori al 100%",
        ["CoAssMinimaSoloDelegataria"]: "{1-P}{2-S}",
        ["Codice binder"]: "Numero binder",
        ["Codice controllo"]: "Codice controllo",
        ["CodiceBinder"]: "Codice Binder",
        ["CodiceBinder{1-S}Compagnia{2-S}DataEffetto{3-D}DataFine{4-D}"]: "Codice Binder {1-S} Compagnia {2-S} DataEffetto {3-D} DataFine {4-D}",
        ["CodiceFiscale"]: "Codice Fiscale",
        ["Cognome"]: "Cognome",
        ["Collapse"]: "Nascondi",
        ["Collaudi"]: "Collaudi",
        ["Collocamento"]: "Collocamento Agenzia",
        ["ColpaGrave"]: "Colpa Grave Medici",
        ["Coltivazione Cave"]: "Coltivazione Cave",
        ["Commenti"]: "Commenti",
        ["CommentiUW"]: "Commento del Sottoscrittore",
        ["Commercialisti"]: "Commercialisti",
        ["Commercio"]:
            "Commercio Ingrosso e Dettaglio, Attività Artigianali non assimilabili alle precedenti (carrozzerie, riparazione veicoli, lavanderie, parrucchieri, panificatori, pasticceri, ecc.), Trasporti, Magazzinaggi, Comunicazioni",
        ["Commission Calculation Method"]: "Tipo",
        ["Compagnia"]: "Compagnia",
        ["Comparatore RCP"]: "Comparatore RCP",
        ["Preventivatore RCP"]: "Preventivatore RCP",
        ["Comparison issued"]: "Confronto emesso",
        ["Completo"]: "Completo",
        ["ComprimiInfo"]: "Comprimi Info",
        ["Comuni"]: "Comuni",
        ["Confirm"]: "Conferma",
        ["Confirm Data"]: "Conferma Dati",
        ["Confirm password"]: "Conferma password",
        ["Consap"]: "Consap",
        ["Consolida compagnia"]: "Genera Preventivo",
        ["Consolida sottoscrittore"]: "Invia richiesta al sottoscrittore",
        ["Consorzio"]: "Consorzi o altri simili organismi in cui qualcuna delle precedenti società/aziende/imprese, partecipi",
        ["ConsulenteAlim"]: "Consulente alimentare",
        ["ConsulenteFam"]: "Consulente/Consulente Familiare",
        ["ConsulenteImmagine"]: "Consulente di immagine",
        ["ConsulentePubb"]: "Consulente pubblicitario/ Consulente Marketing",
        ["ConsulenteLegale"]: "Consulente legale/giurista d’impresa",
        ["ConsulenzaAmm"]: "Servizi di consulenza amministrativo gestionale e di pianificazione aziendale",
        ["ConsulenteMB"]: "Consulente in marchi e brevetti",
        ["OrganizzatoreEventi"]: "Organizzatore eventi e matrimoni",
        ["PromozioneServizi"]: "Promozione di servizi di certificazione e formazione",
        ["OperatoreSocio"]: "Operatore socio-assistenziale",
        ["ConsulentiDelLavoro"]: "Consulenti del Lavoro",
        ["ConsulenzaAdempimentiBurocratici"]: "Consulenza ed adempimenti burocratici",
        ["Consulta"]: "Consulta",
        ["Contraente/Coobbligato"]: "Contraente/Coobbligato",
        ["Contraente/Coobbligato/Ati"]: "Contraente/Coobbligato/Ati",
        ["ContrattiInVigore"]: "Contratti In Vigore",
        ["ContrattoAppalto"]: "Contratto Appalto",
        ["Contratto Aggiudicazione"]: "Contratto Aggiudicazione",
        ["Contratto Binder"]: "Contratto Binder",
        ["Contratto Oggetto"]: "Contratto Oggetto",
        ["Contratto Preliminare Vendita"]: "Contratto Preliminare Vendita",
        ["Contributi"]: "Contributi",
        ["ContributoConsap"]: "Contributo Consap",
        ["Controllare la propria casella email"]: "Controllare la propria casella email",
        ["ControllareLaPropriaCasellaEmail"]: "Controllare la propria casella email",
        ["Controllo validità fideiussione"]: "Controllo validità fideiussione",
        ["Coobbligati per affidamenti"]: "Coobbligati per affidamenti",
        ["Coobbligati per polizze"]: "Coobbligati per polizze",
        ["Coobbligati"]: "Coobbligati",
        ["Coobbligazioni"]: "Coobbligazioni",
        ["CoordinatoreSicurezza"]: "Coordinatore sicurezza D.Lgs 81/2008 (ex D.Lgs 626/94)",
        ["Copertura patrimoniale"]: "Copertura patrimoniale",
        ["Copia Agenzia"]: "Copia Agenzia",
        ["Copy to empty fields"]: "Copia su campi vuoti",
        ["Copy on the same company"]: "Copia sulla stessa compagnia",
        ["Copy to the same product"]: "Copia sullo stesso prodotto",
        ["Copy values"]: "Copia valori",
        ["CopyWriter"]: "Copy Writer/Direttore Multimedia/Direttore della Fotografia/Direttore Artistico",
        ["Corriere"]: "Corriere",
        ["CostoAggiudicazione"]: "Costo di Aggiudicazione",
        ["CostoOpera"]: "Costo Opera",
        ["Coverholder JU"]: "Coverholder JU",
        ["Coverholder MD"]: "Coverholder MD",
        ["Coverholder SU"]: "Coverholder SU",
        ["Coverholder"]: "Coverholder",
        ["CQS"]: "CQS",
        ["Creato"]: "Creato",
        ["CreaUtente"]: "Crea Utente",
        ["Creazione affidamento"]: "Creazione affidamento",
        ["CreazioneAffidamentoDaCompagniaACoverholderOBroker"]: "Affidamento Da Compagnia A Coverholder O Broker creato",
        ["CreazioneSessione"]: "CreazioneSessione",
        ["Credito"]: "Aziende di credito o bancarie",
        ["CreditoConsumo"]: "Credito Consumo",
        ["CreditoPersonale"]: "Credito Personale",
        ["CSA-Aggiorna"]: "Aggiorna",
        ["CSA-Blocco"]: "Blocco",
        ["CSA-Dipendenza"]: "Dipendenza",
        ["CSP-FideAffidamentoApprovaCompagnia"]: "Approvazione della Compagnia",
        ["CSP-FideAffidamentoApprovaCoverholder"]: "Approvazione del Coverholder",
        ["Curatore"]:
            "Liquidatore o curatore fallimentare di Società, Aziende, Associazioni, Fondazioni od altri organismi diversi da Società quotate nei mercati finanziari/aziende di credito o bancarie/finanziarie/assicurazioni/aziende che fanno ricorso al mercato del capitale di rischio/aziende tenute al bilancio consolidato/consorzi",
        ["CurrentMonth"]: "Mese corrente",
        ["CurrentWeek"]: "Settimana corrente",
        ["Da approvare"]: "Da approvare",
        ["Da"]: "Da",
        ["DanniAttrezzature"]: "Danni Attrezzature",
        ["Data aggiudicazione"]: "Data aggiudicazione",
        ["Data collaudo"]: "Data collaudo",
        ["Data concessione"]: "Data concessione",
        ["Data di acquisizione/fusione"]: "Data di acquisizione/fusione",
        ["Data di ammissione"]: "Data di ammissione",
        ["Data di trasformazione"]: "Data di trasformazione",
        ["Data effetto"]: "Data effetto",
        ["Data emissione"]: "Data emissione",
        ["Data fine"]: "Data scadenza",
        ["DataFineManutenzione"]: "Data Fine Manutenzione",
        ["Data gara"]: "Data gara",
        ["Data Inizio Proroga"]: "Data Inizio Proroga",
        ["DataInizioManutenzione"]: "Data Inizio Manutenzione",
        ["Data nascita"]: "Data di nascita",
        ["Data presentazione"]: "Data presentazione",
        ["Data rilascio"]: "Data rilascio",
        ["Data scadenza"]: "Data scadenza",
        ["Data sottoscrizione"]: "Data sottoscrizione",
        ["Data Sottoscrizione"]: "Data Sottoscrizione",
        ["Data stipula"]: "Data stipula",
        ["Data svincolo"]: "Data svincolo",
        ["Data valutazione"]: "Data valutazione",
        ["Data"]: "Data",
        ["DataAggiudicazione"]: "Data aggiudicazione",
        ["DataCollaudo"]: "Data collaudo",
        ["DataConcessione"]: "Data concessione",
        ["DataCostituzione"]: "Data Costituzione",
        ["DataEffetto"]: "Data effetto",
        ["DataEmissione"]: "Data Emissione",
        ["DataEvento"]: "Data Evento",
        ["DataFine"]: "Data scadenza",
        ["DataFineCopertura"]: "Fine Copertura",
        ["Data Fine Copertura"]: "Fine Copertura",
        ["DataFineLavori"]: "Data fine lavori",
        ["DataGara"]: "Data gara",
        ["DataInizio"]: "Data Inizio",
        ["DataInizioCopertura"]: "Inizio Copertura",
        ["Data Inizio Copertura"]: "Data Inizio Copertura",
        ["DataInizioLavori"]: "Data inizio lavori",
        ["DataInizioProroga"]: "Data inizio proroga",
        ["DataNotizie"]: "Data Notizie",
        ["DataPresentazione"]: "Data presentazione offerta",
        ["DataRichiesta"]: "Data Richiesta",
        ["DataRiferimento"]: "Data Riferimento",
        ["DataScadenza"]: "Data Scadenza",
        ["DataSvincolo"]: "Data svincolo",
        ["Data Termine Copertura"]: "Data Termine Copertura",
        ["DataUpload"]: "Data di caricamento",
        ["DataValidita"]: "Data Validità",
        ["DateNonCorrette"]: "Date non corrette",
        ["Dati deroga"]: "Dati deroga",
        ["Dati economici salvati correttamente con ID: {1-S}"]: "Dati economici salvati correttamente con ID: {1-S}",
        ["Dati economici"]: "Dati economici",
        ["DATI ECONOMICI"]: "DATI ECONOMICI",
        ["Dati fideiussione"]: "Dati fideiussione",
        ["Dati Fideiussione"]: "Dati fideiussione",
        ["Dati non presenti"]: "Dati non presenti",
        ["Dati economici estratti correttamente"]: "Dati economici estratti correttamente",
        ["Dati estratti correttamente"]: "Dati estratti correttamente",
        ["DatiEconomiciEstrattiCorrettamente"]: "Dati Economici Estratti Correttamente",
        ["DatiEmissione"]: "Dati Emissione",
        ["DatiEstrattiCorrettamente"]: "Dati estratti correttamente",
        ["DatiProfessionali"]: "Dati Professionali",
        ["Dato economico"]: "Dato economico",
        ["Dazi Doganali"]: "Dazi Doganali",
        ["DD/MM/YYYY"]: "DD/MM/YYYY",
        ["Debiti a breve"]: "Debiti a breve",
        ["DebitiBreve"]: "Totale debiti a breve termine (entro 12 mesi)",
        ["DebitiLungo"]: "Totale debiti a lungo termine (oltre 12 mesi)",
        ["Delegataria"]: "Delegataria",
        ["Denominazione"]: "Denominazione",
        ["DenunciaCompagnia"]: "E' stato denunciato alla Compagnia",
        ["Dermatologia"]: "Dermatologia E Venereologia (esclusa la Medicina Estetica)",
        ["DermatologiaVenereologia"]: "Dermatologia e Venereologia",
        ["DermoPigmentisti"]: "Dermo-pigmentisti / Trucco Permanente",
        ["Deroga fideiussione"]: "Deroga fideiussione",
        ["Deroga polizza"]: "Deroga polizza",
        ["Deroga"]: "Deroga",
        ["DEROGA"]: "DEROGA",
        ["DerogaStato"]: "Stato Deroga",
        ["Deroghe"]: "Deroghe",
        ["Descrizione funzione"]: "Descrizione funzione",
        ["Descrizione"]: "Descrizione",
        ["DescrizioneAltreAttivita"]: "Descrizione Altre attività",
        ["DescrizioneAzionista"]: "Descrizione Azionista",
        ["DescrizioneEvento"]: "Descrizione Evento",
        ["DescrizioneLavori"]: "Descrizione lavori",
        ["DescrizioneOpera"]: "Descrizione Opera",
        ["DesignerInterni"]: "Designer/Progettista di interni",
        ["Dettagli utente"]: "Dettagli utente",
        ["DettagliRifiutoCopertureAssicurative"]: "Dettagli Rifiuto Coperture Assicurative",
        ["DFIDE-Anni"]: "Anni",
        ["DFIDE-Giorni"]: "Giorni",
        ["DFIDE-Mesi"]: "Mesi",
        ["Diabetologia"]: "Diabetologia e Malattie Metaboliche",
        ["Dietista"]: "Dietista",
        ["Dietologia"]: "Dietologia/Scienza dell'Alimentazione",
        ["Dietologo"]: "Dietologo",
        ["Dighe"]: "Dighe",
        ["Digita e seleziona..."]: "Digita e seleziona...",
        ["Digitale"]: "Digitale",
        ["Dipendente"]: "Dipendente di Ente o Azienda sanitaria pubblica",
        ["DirezioneCantiere"]: "Direzione di cantiere",
        ["DirezioneLavori"]: "Direzione lavori",
        ["Diritti emissione"]: "Diritti emissione",
        ["Diritti"]: "Diritti",
        ["DirittiEmissione"]: "Diritti emissione",
        ["Disegnatore"]: "Disegnatore industriale",
        ["DissociaDaPolizza"]: "Dissocia Da Polizza",
        ["Disdetta"]: "Disdetta",
        ["Distribuzione"]: "Distribuzione/Commercializzazione/Installazione/Manutenzione/Ampliamento/Cessione di: Hardware e componenti - Hardware prodotti da terzi",
        ["Ditta individuale"]: "Ditta individuale",
        ["DittaEDP"]: "Il Proponente si avvale dei servizi di una ditta EDP e ne possiede la maggioranza?",
        ["DittaIndividuale/Professionista"]: "Ditta individuale / Professionista",
        ["DOCUMENTI "]: "DOCUMENTI ",
        ["Documenti"]: "Documenti",
        ["Documento Amministratore"]: "Documento Amministratore",
        ["Documento Coobbligati"]: "Documento Coobbligati",
        ["Documento Svincolo"]: "Documento Svincolo",
        ["Documento validato correttamente"]: "Documento validato correttamente",
        ["Documento"]: "Documento",
        ["DomandaCoordinatoreSicurezza"]: "Coordinatore sicurezza D.Lgs 81/2008 (ex D.Lgs 626/94)",
        ["Domicilio"]: "Domicilio",
        ["Domini"]: "Gestione ed Amministrazione di Servizi di dominio",
        ["Doppiatore"]: "Doppiatore",
        ["DownloadReport"]: "Download report",
        ["DR-Approvata"]: "Approvata",
        ["DR-DaApprovare"]: "Da Approvare",
        ["DR-Passa"]: "Passa",
        ["DR-Rifiutata"]: "Rifiutata",
        ["DT-Fideiussione"]: "Fideiussione",
        ["DT-Polizza"]: "Polizza",
        ["Durata"]: "Durata",
        ["DURC"]: "DURC",
        ["E' richiesta la selezione di un file"]: "E' richiesta la selezione di un file",
        ["E' stato denunciato alla Compagnia?"]: "E' stato denunciato alla Compagnia?",
        ["E' stato inserito un valore inferiore al limite MINIMO accettabile: {1-R}"]: "E' stato inserito un valore inferiore al limite MINIMO accettabile: {1-R}",
        ["E' stato inserito un valore superiore al limite MASSIMO accettabile: {1-R}"]: "E' stato inserito un valore superiore al limite MASSIMO accettabile: {1-R}",
        ["Ecologo"]: "Ecologo",
        ["Economista"]: "Economista",
        ["Editore"]: "Editore",
        ["EDP"]: "EDP",
        ["Elaborazione"]:
            "Elaborazione dati ed informazioni per conto di terzi (esclusi servizi di pagamento quali ad esempio: Internet Banking, programmi per scommesse e giochi d’azzardo, sistemi di pagamento del tipo “PayPal”, ecc.)",
        ["Elimina"]: "Elimina",
        ["Email"]: "Email",
        ["Email us"]: "Mandaci una email!",
        ["EMAS"]: "EMAS",
        ["Ematologia"]: "Ematologia",
        ["Emetti"]: "Emetti",
        ["Emetti quietanza"]: "Emetti quietanza",
        ["Emettitore"]: "Da",
        ["Endocrinologia"]: "Endocrinologia e Malattie Del Ricambio",
        ["Endorsement number"]: "Appendice numero",
        ["Endorsement system"]: "Sistema approvazioni appendici",
        ["Enologo"]: "Enologo",
        ["Ente Pubblico"]: "Ente Pubblico",
        ["Enti"]: "Enti",
        ["Enter the address"]: "Inserisci l'indirizzo...",
        ["Epatologia"]: "Epatologia",
        ["Equilibrio patrimoniale"]: "Equilibrio patrimoniale",
        ["Equini"]: "Attività professionale relativa ad animali da reddito ed equini",
        ["Erborista"]: "Erborista",
        ["Errore caricamento dati"]: "Errore caricamento dati",
        ["Errore lettura"]: "Errore lettura",
        ["Errore"]: "Errore",
        ["ERRORE"]: "ERRORE",
        ["ErroreAggiornamentoAutorizzazione"]: "Errore Aggiornamento Autorizzazione",
        ["ErroreAggiornamentoFideCoobbligato"]: "Errore Aggiornamento Coobbligato",
        ["ErroreAggiornamentoGaranzia"]: "Errore Aggiornamento Garanzia",
        ["ErroreAggiornamentoLimite"]: "Errore Aggiornamento Limite",
        ["ErroreAggiornamentoProvvigione"]: "Errore Aggiornamento Provvigione",
        ["ErroreAggiornamentoUtente"]: "Errore Aggiornamento Utente",
        ["ErroreAnagMultipli"]: "Errore nell'anagrafica collegata al login: duplicata",
        ["ErroreAnagNonPresente"]: "Errore nell'anagrafica collegata al login: non presente",
        ["ErroreAzioneAbilitata"]: "Errore: Permesso Negato",
        ["ErroreBuildSignProcedure"]: "Errore nell'invio della richiesta di firma digitale",
        ["ErroreCalcola"]: "Errore Calcola",
        ["ErroreCambioPolizzaApprovazioneNonPermesso"]: "Errore Cambio Polizza Approvazione Non Permesso",
        ["ErroreCambioStatoDuplicatoGruppo"]: "Errore Cambio Stato Duplicato",
        ["ErroreCambioStatoNonPermesso"]: "Errore: cambio stato non permesso",
        ["ErroreCancellazioneBinder"]: "Errore Cancellazione Binder",
        ["ErroreCartaServizi"]: "Errore Carta Servizi",
        ["ErroreCartaServzi"]: "Errore Carta Servizi",
        ["ErroreCoAssicurazione"]: "Errore CoAssicurazione",
        ["ErroreEmissionePolizza"]: "Errore Emissione Polizza",
        ["ErroreFileNonEliminabile"]: "Errore File Non Eliminabile",
        ["ErroreFileNonPresente"]: "Errore File Non Presente",
        ["ErroreInserimentoAffidamento"]: "Errore Inserimento Affidamento",
        ["ErroreInserimentoAnagrafica"]: "Errore Inserimento Anagrafica",
        ["ErroreInserimentoAutorizzazione"]: "Errore Inserimento Autorizzazione",
        ["ErroreInserimentoBinder"]: "Errore Inserimento Binder",
        ["ErroreInserimentoBinderVisibile"]: "Non si dispone dei permessi per salvare il binder o per gestire le società coinvolte",
        ["ErroreInserimentoDatoEconomico"]: "Errore Inserimento Dato Economico",
        ["ErroreInserimentoDeroga"]: "Errore Inserimento Deroga",
        ["ErroreInserimentoFideCoobbligato"]: "Errore Inserimento Fide Coobbligato",
        ["ErroreInserimentoFideValutazione"]: "Errore Inserimento Valutazione",
        ["ErroreInserimentoFile"]: "Errore Inserimento File",
        ["ErroreInserimentoGaranzia"]: "Errore Inserimento Garanzia",
        ["ErroreInserimentoPolizza"]: "Errore Inserimento Polizza",
        ["ErroreInserimentoProvvigione"]: "Errore Inserimento Provvigione",
        ["ErroreInserimentoTassi"]: "Errore Inserimento Tassi",
        ["ErroreInserimentoUtente"]: "Errore Inserimento Utente",
        ["ErroreLettura"]: "Errore Lettura",
        ["ErroreLimiteBinderAccessori  (oltre il proprio limite)"]: "ErroreLimiteBinderAccessori  (oltre il proprio limite)",
        ["ErroreLimiteBinderDirittiFissi  (oltre il proprio limite)"]: "Errore Limite Binder Diritt Fissi  (oltre il proprio limite)",
        ["ErroreLimiteBinderPremioMinimo  (oltre il proprio limite)"]: "ErroreLimiteBinderPremioMinimo  (oltre il proprio limite)",
        ["ErroreLimiteBinderSingoloProdotto  (oltre il proprio limite)"]: "Errore Limite Binder Singolo Prodotto  (oltre il proprio limite)",
        ["ErroreLimiteGruppo  (oltre il proprio limite)"]: "Errore Limite Gruppo  (oltre il proprio limite)",
        ["ErroreLimiteGruppoNonSettato"]: "ErroreLimiteGruppoNonSettato",
        ["ErroreLimiteTassiTassoMin  (oltre il proprio limite)"]: "Errore Limite Tassi Tasso Min  (oltre il proprio limite)",
        ["ErroreLoginOTPCodice"]: "Errore Login OTP Codice",
        ["ErroreLoginOTPEMail"]: "Errore Login OTP Email",
        ["ErroreLoginOTPLog"]: "Errore Login OTP Log",
        ["ErroreLoginOTPScaduto"]: "Errore Login OTP Scaduto",
        ["ErroreLoginPasswordScaduta"]: "Login Password Scaduta - Controllare la propria casella email",
        ["ErrorePremioMinimo"]: "Errore Premio Minimo",
        ["ErroreRecuperaPasswordAggiornamentoUtente"]: "Errore Recupera Password Aggiornamento Utente",
        ["ErroreRecuperaPasswordDoppiaRichiesta"]: "Errore Recupera Password Doppia Richiesta",
        ["ErroreRecuperaPasswordEMail"]: "Errore Recupera Password Email",
        ["ErroreRecuperaPasswordLog"]: "Errore Recupera Password Log",
        ["ErroreRecuperaPasswordLogin"]: "Errore Recupera Password Login",
        ["ErroreRecuperaPasswordScaduta"]: "Errore Recupera Password Scaduta",
        ["ErroreSanzioni:{1-S}"]: "Errore sanzioni: {1-S}",
        ["ErroreSessioneDataRiferimento"]: "Errore Sessione Data Riferimento",
        ["ErroreSicurezza"]: "Errore Sicurezza",
        ["ErroreSovrapposizioneBinder"]: "Errore: sovrapposizone Binder",
        ["ErroreSovrapposizioneFideAffidamento"]: "Errore: Sovrapposizione Affidamento",
        ["ErroreTassoMin"]: "Errore Tasso Min",
        ["Esiste già un capogruppo impossibile impostarne un secondo"]: "Esiste già un capogruppo impossibile impostarne un secondo",
        ["Esiste già un capogruppo, impossibile impostarne un secondo"]: "Esiste già un capogruppo, impossibile impostarne un secondo",
        ["Esiste già una deroga in stato di approvazione, impossibile inserirne un'altra"]: "Esiste già una deroga in stato di approvazione, impossibile inserirne un'altra",
        ["Esiste già una sede legale, impossibile impostarne una seconda"]: "Esiste già una sede legale, impossibile impostarne una seconda",
        ["EsisteGiaUnaSedeLegaleImpossibileImpostarneUnaSeconda"]: "Esiste già una sede legale: impossibile impostarne una seconda",
        ["Esistono azionisti che detengono più del 10% del capitale della società?"]: "Esistono azionisti che detengono più del 10% del capitale della società?",
        ["Esito"]: "Esito",
        ["EspandiInfo"]: "Espandi Info",
        ["EstensioneEffettuazioneOpereAltoRischio"]: "Estensione effettuazione opere ad alto rischio",
        ["Estetista"]: "Estetista",
        ["Estrai dati"]: "Estrai dati",
        ["Estrazione dati da ente esterno"]: "Estrazione dati da ente esterno",
        ["Estrazione"]: "Estrazione Minerali, Altre Industrie Estrattive,Costruzioni",
        ["EtichettaATI"]: "Etichetta",
        ["Ex Cliente"]: "Ex Cliente",
        ["Excel"]: "Excel",
        ["Expand"]: "Mostra",
        ["Extension Endorsement"]: "Appendice di proroga",
        ["F-730"]: "730",
        ["FAA-ApprovatoNegativo"]: "Approvato con parere negativo",
        ["FAA-ApprovatoPositivo"]: "Approvato con parere positivo",
        ["FA-Affidamento"]: "Affidamento",
        ["FAA-Proposta"]: "FAA-Proposta",
        ["FAE-ApprovatoNegativo"]: "Valutato con parere negativo",
        ["FAE-ApprovatoPositivo"]: "Valutato con parere positivo",
        ["FAE-CreazioneAffidamento"]: "Creazione affidamento",
        ["FAE-Morto"]: "Morto",
        ["FAE-PreProposta"]: "Pre proposta",
        ["FAE-Proposta"]: "Proposta",
        ["FAE-PropostaRiapertura"]: "Proposta Riapertura",
        ["FAE-Revisione"]: "Revisione",
        ["FAE-Rifiuto"]: "Rifiuto",
        ["FAE-Rinnovo"]: "Rinnovo",
        ["FAE-Sospensione"]: "Sospensione",
        ["FAE-Sottoposto"]: "Sottoposto",
        ["FAE-Sottoscritto"]: "Sottoscritto",
        ["F-Altro"]: "Altro",
        ["FA-NonProvvisorie"]: "Non Provvisorie",
        ["F-Appendice"]: "Appendice",
        ["F-AppendiceBinder"]: "Appendice Binder",
        ["FA-Provvisorie"]: "Provvisorie",
        ["Farmacista"]: "Farmacista",
        ["Farmacologia"]: "Farmacologia",
        ["F-AttoCostitutivo"]: "Atto Costitutivo",
        ["Fattura"]: "Fattura",
        ["Fatturato"]: "Premi lordi",
        ["NuovoFatturatoPassatoEsercizio"]: "Nuovo Fatturato Consuntivo",
        ["FatturatoPassatoEsercizio"]: "Attuale Fatturato Consuntivo",
        ["FatturatoStimaEsercizioCorrente"]: "Fatturato Preventivo",
        ["FattureDatiEconomici"]: "Fatture Dati Economici",
        ["F-Autorizzazione"]: "Autorizzazione",
        ["Fax"]: "Fax",
        ["F-BandoGara"]: "BandoGara",
        ["F-Bilancio"]: "Bilancio",
        ["F-BusinessPlan"]: "Business Plan",
        ["FC-Anag"]: "Anagrafica",
        ["F-CartaIdentita"]: "Carta Identita",
        ["FC-Binder"]: "Binder",
        ["FC-DatoEconomico"]: "Dato Economico",
        ["F-CertificatoSal"]: "Certificato Sal",
        ["F-CertificazioneAmbientale"]: "CertificazioneAmbientale",
        ["FC-FideAffidamento"]: "Affidamento",
        ["FC-FideCoobbligati"]: "Coobbligati",
        ["FC-FideValutazione"]: "Valutazione",
        ["F-ClasseAppartenenzaRifiuti"]: "Classe Appartenenza Rifiuti",
        ["F-Collaudo"]: "Collaudo",
        ["F-ContrattoAggiudicazione"]: "Contratto Aggiudicazione",
        ["F-ContrattoBinder"]: "Contratto Binder",
        ["F-ContrattoOggetto"]: "Contratto Oggetto",
        ["F-ContrattoPreliminareVendita"]: "ContrattoPreliminareVendita",
        ["F-Convenzione"]: "Convenzione",
        ["F-Coobbligazioni"]: "Coobbligazioni",
        ["F-CopiaAgenzia"]: "Copia Agenzia",
        ["FC-Polizza"]: "Polizza",
        ["F-DisciplinareGara"]: "Disciplinare di gara",
        ["F-Documento"]: "Documento",
        ["F-DocumentoSvincolo"]: "Documento Svincolo",
        ["F-DURC"]: "DURC",
        ["Femmina"]: "Femmina",
        ["Ferrovie"]: "Ferrovie",
        ["F-Fattura"]: "Fattura",
        ["FideAffidamento"]: "Affidamento",
        ["FideAffidamentoApprovazione - Approvato con parere negativo"]: "Affidamento - Approvato con parere negativo",
        ["FideAffidamentoApprovazione - Approvato con parere positivo"]: "Affidamento - Approvato con parere positivo",
        ["FideAffidamentoApprovazione - Proposta affidamento"]: "Proposta affidamento",
        ["FideAffidamentoDatiPOS"]: "Fide Affidamento Dati POS",
        ["FideAffidamentoEsito"]: "Esito",
        ["FideAffidamentoEsitoApprovazioneCommenti"]: "Approvazione commenti dell'Affidamento",
        ["FideAffidamentoPadreNonPresente"]: "Affidamento Padre Non Presente",
        ["FideAffidamentoSenzaSOAValidata"]: "Affidamento senza SOA validato",
        ["FideAffidamentoSenzaValutazioneAccettata"]: "Affidamento senza valutazione accettato",
        ["FideCoobbligati"]: "Coobbligati",
        ["Fideiussioni non provvisorie"]: "Fideiussioni non provvisorie",
        ["Fideiussioni provvisorie"]: "Fideiussioni provvisorie",
        ["Fideiussioni"]: "Fideiussioni",
        ["FideValutazione"]: "Valutazione",
        ["FideValutazioneEsito"]: "Esito",
        ["File caricato"]: "File caricato",
        ["File validato"]: "File validato",
        ["File {1-S} was rejected."]: "Il file {1-S} è stato rifiutato.",
        ["File {1-S} was successfully added."]: "Il file {1-S} è stato aggiunto con successo.",
        ["Fill in the missing fields"]: "Compila i campi mancanti",
        ["Firma"]: "Firma",
        ["Firma con marca"]: "Firma con marca temporale",
        ["Fin"]: "Società finanziarie, di qualunque tipo",
        ["Fine"]: "Fine",
        ["FineCopertura"]: "Fine Copertura",
        ["FirmaDigitale"]: "Firma Digitale",
        ["Fisiatria"]: "Fisiatria/Medicina Fisica e Riabilitativa",
        ["Fisioterapista"]: "Fisioterapista",
        ["F-ISO14001"]: "ISO14001",
        ["F-ISO14067"]: "ISO14067",
        ["F-ISO18001"]: "ISO18001",
        ["F-ISO9000"]: "ISO9001",
        ["Flessibilita"]: "Flessibilità",
        ["F-ModelloIVA"]: "ModelloIVA",
        ["F-Mutuo"]: "Mutuo",
        ["Foniatria"]: "Foniatria e Audiologia",
        ["Force Legal Interest Amount"]: 'Forza "Importo interesse legale"',
        ["Formatore"]: "Formatore in corsi professionali pubblici e privati (esempio: corsi finanziati da fondi EU)",
        ["Fornitura"]: "Fornitura di Servizi Internet e Servizi ad essi collegati",
        ["Fotografo"]: "Fotografo",
        ["F-Passaporto"]: "Passaporto",
        ["F-Patente"]: "Patente",
        ["F-PermessoCostruire"]: "Permesso di costruire",
        ["F-PolizzaEmessaP7M"]: "Polizza emessa (P7M)",
        ["F-PolizzaEmessaPDF"]: "Polizza emessa (PDF)",
        ["F-Privacy"]: "Privacy",
        ["F-ProgettoContributo"]: "Progetto Contributo",
        ["FR-AffNonProvvisorie"]: "Affidamento Non Provvisorie",
        ["FR-AffProvvisorie"]: "Affidamento Provvisorie",
        ["Franchigia"]: "Franchigia",
        ["FranchigiaGaranzia"]: "Franchigia della garanzia",
        ["FraseMandanti"]: "Assicurati (Indicare i Dipendenti/Collaboratori come da elenco trasmesso all’OAM)",
        ["FraseRPE1"]: "Le attività e funzioni di seguito elencate se non selezionate non sono coperte",
        ["FraseRPE2"]:
            "La funzione di Sindaco per gli Organismi di seguito elencati è esclusa dall'assicurazione. Se qualcuno degli assicurandi svolge tale funzione, potrà indicare per quali organismi; gli Assicuratori si riservano di concedere l'eventuale estensione a tale funzione",
        ["FraseSoggetti"]: "Indicare altri soggetti assicurati oltre al Contraente/Assicurato",
        ["Frazionamento"]: "Frazionamento",
        ["FR-CoobAff"]: "Coobbligati Affidamento",
        ["FR-CoobPol"]: "Coobbligati Polizza",
        ["F-Rendicontazione"]: "Rendicontazione",
        ["F-ReportFatturaDatiEconomici"]: "Report Fattura Dati Economici",
        ["F-RicevutaPagamento"]: "Ricevuta Pagamento",
        ["FR-NonProvvisorie"]: "Non Provvisorie",
        ["FR-Provvisorie"]: "Provvisorie",
        ["FS-Caricato"]: "Caricato",
        ["FS-Inviato"]: "File inviato",
        ["FS-Firmato"]: "File firmato",
        ["F-SchemaFide"]: "Schema Fideiussione",
        ["F-SOA"]: "SOA",
        ["FS-Validato"]: "FValidato",
        ["F-UnicoPersone"]: "Unico Persone",
        ["F-UnicoSocieta"]: "Unico Societa",
        ["Funivie"]: "Funivie",
        ["Funzione che aggiorna i dati su altre tabelle"]: "Funzione che aggiorna i dati su altre tabelle",
        ["Funzione che blocca il cambio stato"]: "Funzione che blocca il cambio stato",
        ["Funzione che controlla dipendenze con altre tabelle"]: "Funzione che controlla dipendenze con altre tabelle",
        ["Funzione"]: "Funzione",
        ["Funzioni Pubbliche"]: "Funzioni Pubbliche",
        ["FunzioniPubbliche"]: "Funzioni Pubbliche",
        ["Fusioni"]: "Fusioni ed Acquisizioni, Operazioni su Società, Associazioni, Aziende",
        ["F-VisuraCamerale"]: "Visura Camerale",
        ["F-VisuraCatastale"]: "Visura Catastale",
        ["Gallerie"]: "Gallerie",
        ["Garanzie"]: "Garanzie",
        ["GARANZIE"]: "Garanzie",
        ["GaranzieAggiornateCorrettamente"]: "Garanzie aggiornate correttamente",
        ["GARANZIEERRORE"]: "Errore - Garanzie",
        ["Garanzia Manutenzione"]: "Garanzia Manutenzione",
        ["GaranzieNonImpostate"]: "Garanzie Non Impostate",
        ["Gastroenterologia"]: "Gastroenterologia",
        ["GeneraCartaServizi"]: "Genera Carta Servizi",
        ["GENERAZIONE CARTA SERVIZI"]: "GENERAZIONE CARTA SERVIZI",
        ["GenerazioneCartaServiziAvvenutaConSuccesso"]: "Carta Servizi creata correttamente",
        ["GeneticaMedica"]: "Genetica Medica",
        ["Geografo"]: "Geografo",
        ["Geologi"]: "Geologi",
        ["Geometri"]: "Geometri",
        ["Geriatria"]: "Geriatria",
        ["Gestione accoppiamenti Binder, Garanzie, Funzioni di calcolo"]: "Gestione accoppiamenti Binder, Garanzie, Funzioni di calcolo",
        ["Gestione affidamenti"]: "Gestione affidamenti",
        ["Gestione anagrafica"]: "Gestione anagrafica",
        ["Gestione binder"]: "Gestione binder",
        ["Gestione contabilità"]: "Gestione contabilità",
        ["Gestione coobbligati"]: "Gestione coobbligati",
        ["Gestione dati economici"]: "Gestione dati economici",
        ["Gestione del proprio utente"]: "Gestione del proprio utente",
        ["Gestione documenti"]: "Gestione documenti",
        ["Gestione Garanzie dei prodotti"]: "Gestione Garanzie dei prodotti",
        ["Gestione gruppi"]: "Gestione gruppi",
        ["Gestione menu a tendina"]: "Gestione menu a tendina",
        ["Gestione news"]: "Gestione news",
        ["Gestione password"]: "Gestione password",
        ["Gestione polizze fideiussioni"]: "Gestione polizze fideiussioni",
        ["Gestione polizze RCP"]: "Gestione polizze RCP",
        ["Gestione polizze"]: "Gestione polizze",
        ["Gestione prodotti"]: "Gestione prodotti",
        ["Gestione provvigioni"]: "Gestione provvigioni",
        ["Gestione Rifiuti"]: "Gestione Rifiuti",
        ["Gestione tabelle di sistema"]: "Gestione tabelle di sistema",
        ["Gestione tassi"]: "Gestione tassi",
        ["Gestione utenti"]: "Gestione utenti",
        ["Gestione valutazioni"]: "Gestione valutazioni",
        ["GestioneGaranzie"]: "Gestione garanzie",
        ["Giardiniere"]: "Giardiniere",
        ["GinecologiaOstetricia"]: "Ginecologia e Ostetricia",
        ["Giornalista"]: "Giornalista / Pubblicista",
        ["Giorni"]: "Giorni",
        ["GL-AffidamentoNonProvvisorie"]: "Affidamento Non Provvisorie",
        ["GL-AffidamentoProvvisorie"]: "Affidamento Provvisorie",
        ["Gli Amministratori ed i Componenti aziendali anche con riferimento alla Società, sono a conoscenza di fatti che potrebbero dare luogo a richieste di RISARCIMENTO o procedimenti penali anche in materia di diritto del lavoro?"]:
            "Gli Amministratori ed i Componenti aziendali anche con riferimento alla Società, sono a conoscenza di fatti che potrebbero dare luogo a richieste di RISARCIMENTO o procedimenti penali anche in materia di diritto del lavoro?",
        ["Gli amministratori ed i componenti aziendali sono mai stati sottoposti a procedimenti penali?"]:
            "Gli amministratori ed i componenti aziendali sono mai stati sottoposti a procedimenti penali?",
        ["GL-Massimale"]: "Limite su massimale",
        ["GL-Premio"]: "Premio",
        ["GO"]: "GO",
        ["Grafici"]: "Grafici",
        ["Grafologo"]: "Grafologo",
        ["Gruppi"]: "Gruppi",
        ["GRUPPO ERRORE"]: "GRUPPO ERRORE",
        ["Gruppo salvato correttamente con ID: {1-S}"]: "Gruppo salvato correttamente con ID: {1-S}",
        ["Gruppo"]: "Gruppo",
        ["GRUPPO"]: "GRUPPO",
        ["Gruppo1"]: "Amministratori",
        ["Gruppo10"]: "POS MD",
        ["Gruppo11"]: "Insurer Senior",
        ["Gruppo12"]: "Insurer Junior",
        ["Gruppo13"]: "POS Utente",
        ["Gruppo17"]: "Insurer",
        ["Gruppo2"]: "Lettori",
        ["Gruppo3"]: "Tester",
        ["Gruppo4"]: "Visualizzatori",
        ["Gruppo6"]: "Insurer MD",
        ["Gruppo7"]: "Coverholder MD",
        ["Gruppo8"]: "Coverholder Senior",
        ["Gruppo9"]: "Coverholder Junior",
        ["HACCP"]: "HACCP/Prevenzione incidenti",
        ["Hide"]: "Nascondere",
        ["Home"]: "Home",
        ["HR"]: "HR - Coordinatore Risorse Umane",
        ["ID"]: "ID",
        ["ID_AnagBeneficiario"]: "Beneficiario",
        ["ID_AnagContraente"]: "Contraente",
        ["ID_Gruppo"]: "ID Gruppo",
        ["ID_ModalitaEmissione"]: "Modalità emissione",
        ["ID_Polizza"]: "ID Polizza",
        ["ID_TipoProdotto"]: "Tipo Prodotto",
        ["ID_TipoStatoArrivo"]: "Tipo Stato Arrivo",
        ["Identificativo"]: "Identificativo",
        ["Igiene"]: "Igiene e Medicina preventiva",
        ["IgienistaDentale"]: "Igienista dentale",
        ["IgienistiDentali"]: "Igienisti Dentali",
        ["IgnoreDuplicates"]: "Ignorare le pratiche attive per lo stesso prodotto",
        ["Il codice fiscale non è valido"]: "Il Codice Fiscale non è valido",
        ["Il Proponente è a conoscenza di azioni, omissioni o fatti dai quali possano derivare richieste di risarcimento o azioni volte all’accertamento di responsabilità civile o penale del Proponente, anche se non notificate all’Assicuratore?"]:
            "Il Proponente è a conoscenza delle seguenti azioni, omissioni o fatti dai quali possano derivare richieste di risarcimento o azioni volte all’accertamento di responsabilità civile o penale del Proponente, anche se non notificate all’Assicuratore. Le seguenti circostanze si intendono escluse dalla copertura se non diversamente pattuito",
        ["Il Proponente ha mai sottoscritto o è mai stato assicurato per la Responsabilità Civile Professionale?"]:
            "Il Proponente ha sottoscritto o è stato assicurato per la Responsabilità Civile Professionale",
        ["Il proponente, negli ultimi 5 anni, ha stipulato coperture assicurative per questa tipologia di rischio?"]:
            "Il proponente, negli ultimi 5 anni, ha stipulato coperture assicurative per questa tipologia di rischio?",
        ["il tuo profilo"]: "Il tuo profilo",
        ["Il contraente/Legale rappresentante"]: "Il contraente/Legale rappresentante",
        ["IlContraenteHaGiaUnaPraticaAttivaPerLoStessoProdotto"]: "Il contraente ha già una pratica attiva per lo stesso prodotto",
        ["Illimitata"]: "Illimitata",
        ["Immagine"]: "Immagine",
        ["ImpegnoRilascio"]: "Impegno al rilascio",
        ["Impianti energie rinnovabili"]: "Impianti energie rinnovabili",
        ["Implantologia"]: "Implantologia",
        ["ImplantologiaAltre"]: "Altra Implantologia",
        ["ImplantologiaAltreDescr"]: "Descrizione tipo di Implantologia",
        ["ImplantologiaOsteointegrata"]: "Implantologia Osteointegrata",
        ["Imponibile"]: "Imponibile",
        ["ImponibileCalcolato{1-I}ImponibileInseritoDifferenti{2-I}"]: "L'imponibile calcolato {1-I} è diverso dall'imponibile inserito {2-I}",
        ["ImponibileCalcolato{1-I}ImponibileInseritoDifferenti{2-I}Differenza{3-I}"]: "L'imponibile calcolato {1-I} è diverso dall'imponibile inserito {2-I}: {3-I}",
        ["Importo affidamento"]: "Importo affidamento",
        ["Importo complessivo"]: "Importo complessivo",
        ["Importo garantito"]: "Importo garantito",
        ["Importo interesse legale"]: "Importo interesse legale",
        ["Importo"]: "Importo",
        ["ImportoComplessivo"]: "Importo complessivo",
        ["ImportoComplessivoAnticipazioni"]: "Valore Anticipazione Concessa",
        ["ImportoComplessivoProvvisoria"]: "Importo a base di gara",
        ["ImportoComplessivoRatadiSaldo"]: "Valore Capitale",
        ["ImportoGarantito"]: "Somma garantita",
        ["ImportoInteresseLegale"]: "Importo interesse legale",
        ["ImportoRichiesto"]: "Importo Richiesto",
        ["Impossibile emettere la polizza, le quote assicurate non coprono il 100%"]: "Impossibile emettere la polizza, le quote assicurate non coprono il 100%",
        ["Impossibile impostare la quota di {1-P} perché supererebbe la quota della mandataria"]: "Impossibile impostare la quota di {1-P} perché supererebbe la quota della mandataria",
        ["Impossibile impostare la quota di {1-P} perché supererebbe la soglia del 100% totale"]: "Impossibile impostare la quota di {1-R} perché supererebbe la soglia del 100% totale",
        ["Imposte"]: "Imposte",
        ["In acquisizione"]: "In acquisizione",
        ["In completamento"]: "In completamento",
        ["In valutazione"]: "In valutazione",
        ["IncarichiProfessionaliRegimeDiGeneralContractor"]: "Incarichi professionali in regime di General Contractor",
        ["Incassa"]: "Incassa",
        ["Indagine"]:
            "A seguito di indagine, il Proponente e/o gli Assicurati risultano essere a conoscenza delle seguenti Circostanze o Eventi che possano dare origine a una richiesta di risarcimento nei confronti del Proponente stesso in relazione all'incarico professionale – Attività di Sindaco/Revisore dei Conti, Amm.re società, Attività OdV 231/2001 (o altro) – indicato nella presente proposta?",
        ["IndiceSettorialeAssetTurnover"]: "Asset Turnover",
        ["IndiceSettorialeCoperturaInteressi"]: "Copertura Interessi",
        ["IndiceSettorialeCurrentRatio"]: "Current Ratio",
        ["IndiceSettorialeDurataMediaDeiDebiti"]: "Durata Media dei Debiti",
        ["IndiceSettorialeIndiceDiAutocoperturaDelleImmobilizzazioni"]: "Indice ii Autocopertura delle Immobilizzazioni",
        ["IndiceSettorialeLeverage"]: "Leverage",
        ["IndiceSettorialeOneriFinanziariValoreProduzione"]: "Oneri Finanziari Valore Produzione",
        ["IndiceSettorialeQuickRatio"]: "QuickRatio",
        ["IndiceSettorialeROE"]: "ROE",
        ["IndiceSettorialeROI"]: "ROI",
        ["IndiceSettorialeROS"]: "ROS",
        ["Indietro"]: "Indietro",
        ["IndietroLista"]: "IndietroLista",
        ["Indirizzi"]: "Indirizzi",
        ["Indirizzo"]: "Indirizzo",
        ["Industrie"]:
            "Industrie Manifatturiere, Industrie Alimentari, Tessili, Abbigliamento, Conciarie, Cuoio, Legno, Mobili, Carta, Editoria, Stampa, Minerali non metalliferi, Produzione e lavorazione metalli, Fabbricazione macchine – apparecchi meccanici - apparecchi elettrici ed elettronici, Autoveicoli, Produzione e distribuzione energia elettrica – gas - acqua, Smaltimento rifiuti",
        ["InfoFatturato"]: "Fatturato",
        ["InfoFatturatoTotale"]: "Fatturato Totale",
        ["Informatici"]: "Servizi Informatici",
        ["Information"]: "Informazioni",
        ["Informatore"]: "Informatore scientifico del farmaco/Rappresentante farmaceutico",
        ["Informazioni"]: "Informazioni",
        ["Info"]: "Informazione",
        ["InformazioniAccessorie"]: "Informazioni Accessorie",
        ["InformazioniAzioni"]:
            "Il Proponente è a conoscenza di azioni, omissioni o fatti dai quali possano derivare richieste di risarcimento o azioni volte all’accertamento di responsabilità civile o penale del Proponente, anche se non notificate all’Assicuratore?",
        ["InformazioniPrecedentiAssicurativi"]: "Il Proponente ha sottoscritto o è stato assicurato per la Responsabilità Civile Professionale?",
        ["InformazioniSinistri"]: "Informazioni precedenti assicurativi/ sinistri/ circostanze",
        ["Infortuni"]: "Infortuni",
        ["Ingegneri"]: "Ingegneri",
        ["Inglese"]: "Inglese",
        ["Inizio"]: "Inizio",
        ["InizioCopertura"]: "Inizio Copertura",
        ["Inserimento Legale Rappresentante"]: "Inserimento Legale Rappresentante",
        ["Inserisci"]: "Inserisci",
        ["Insurer JU"]: "Compagnia JU FIDE",
        ["Insurer RCP"]: "Compagnia RCP",
        ["Insurer SU"]: "Compagnia SU FIDE",
        ["Insurer"]: "Compagnia",
        ["IntrattenitoreCulturale"]: "Intrattenitore Culturale",
        ["Invalid Date Format"]: "Formato data non valido",
        ["InvestigatorePrivato"]: "Investigatore privato",
        ["Invia"]: "Invia",
        ["InviaSchermo"]: "Invia Schermata per aiuto ",
        ["Iscrizione Albo Rifiuti"]: "Iscrizione Albo Rifiuti",
        ["ISO 14001"]: "ISO 14001",
        ["ISO 14067"]: "ISO 14067",
        ["ISO 18001"]: "ISO 18001",
        ["ISO 9000"]: "ISO 9001",
        ["Issued"]: "Emesso",
        ["IstruttoreGuida"]: "Istruttore di guida",
        ["IstruttoreYoga"]: "Istruttore yoga",
        ["Italiana"]: "Italiana",
        ["Kinesiologo"]: "Kinesiologo",
        ["La compagnia {1-S} richiede di essere delegataria ma ha una quota del {2-P} inferiore o uguale alla quota di {3-S} pari al {4-P}"]:
            "La compagnia {1-S} richiede di essere delegataria ma ha una quota del {2-P} inferiore o uguale alla quota di {3-S} pari al {4-P} .",
        ["La compagnia {1-S} richiede di essere delegataria"]: "La compagnia {1-S} richiede di essere delegataria",
        ["La data non può essere posteriore il: {1-D}"]: "La data non può essere successiva del {1-D}",
        ["La Partita iva non è valida"]: "La Partita IVA non è valida",
        ["La società ha acquisito o si è fusa con altre società negli ultimi 3 anni?"]: "La società ha acquisito o si è fusa con altre società negli ultimi 3 anni?",
        ["La Società ha avuto o ha in programma di avviare nei prossimi 12 mesi procedure di licenziamento o pensionamento anticipato?"]:
            "La Società ha avuto o ha in programma di avviare nei prossimi 12 mesi procedure di licenziamento o pensionamento anticipato?",
        ["La società ha in programma acquisizioni, offerte pubbliche o fusioni, oppure intende effettuare un’offerta pubblica o privata di titoli entro il prossimo anno?"]:
            "La società ha in programma acquisizioni, offerte pubbliche o fusioni, oppure intende effettuare un’offerta pubblica o privata di titoli entro il prossimo anno?",
        ["La Società ha modificato la propria ragione sociale negli ultimi 5 anni?"]: "La Società ha modificato la propria ragione sociale negli ultimi 5 anni?",
        ["La data non può essere antecedente il: {1-D}"]: "La data non può essere antecedente il: {1-D}",
        ["LaDataNonPuoEssereAntecedenteIl{1-D}"]: "La data non può essere antecedente il {1-D}",
        ["LAR-Appendice"]: "Appendice",
        ["LAR-FideAffidamento"]: "Affidamento",
        ["LAR-FideAffidamentoContraente"]: "Affidamento Contraente",
        ["LAR-Polizza"]: "Polizza",
        ["LastMonth"]: "Mese precedente",
        ["LastQuarter"]: "Trimestre precedente",
        ["LastWeek"]: "Settimana precedente",
        ["Le valutazioni per gli affidamenti"]: "Le valutazioni per gli affidamenti",
        ["LeasingAuto"]: "Leasing Auto",
        ["LeasingStrutturale"]: "Leasing Strutturale",
        ["Legale Rappresentante"]: "Legale Rappresentante",
        ["LeggiTutto"]: "Leggi tutto",
        ["Lettori"]: "Lettori",
        ["Lettura"]: "Lettura",
        ["Level up della richiesta di deroga"]: "Level up della richiesta di deroga",
        ["LevelUP"]: "Level UP",
        ["LiberoProfessionista"]: "Libero Professionista",
        ["LiberoProfSSNExtramoenia"]: "Attività Libero Professionale - Convenzionato SSN - Extramoenia",
        ["Lim. Fideiussione POS"]: "Lim. Fideiussione POS",
        ["Lim. Fideiussione"]: "Lim. Fideiussione",
        ["Lim. max contraente"]: "Lim. max contraente",
        ["Lim. Max Contraente"]: "Lim. Max Contraente",
        ["Lim. Max Contraente_NonProvvisorie"]: "Non provv. - Lim. Max Contraente",
        ["Lim. Max Contraente_Provvisorie"]: "Provv. - Lim. Max Contraente",
        ["Lim. max fideiussione - POS"]: "Lim. max fideiussione - POS",
        ["Lim. Max Fideiussione POS"]: "Lim. Max Fideiussione POS",
        ["Lim. Max Fideiussione POS_NonProvvisorie"]: "Non provv. - Lim. Max Fideiussione POS",
        ["Lim. Max Fideiussione POS_Provvisorie"]: "Provv. - Lim. Max Fideiussione POS",
        ["Lim. Max Fideiussione"]: "Lim. Max Fideiussione",
        ["Lim. Max Fideiussione_NonProvvisorie"]: "Non provv. - Lim. Max Fideiussione",
        ["Lim. Max Fideiussione_Provvisorie"]: "Provv. - Lim. Max Fideiussione",
        ["Lim. max sottoscrittore"]: "Lim. max sottoscrittore",
        ["Limite accessori"]: "Limite accessori",
        ["Limite Affidamento"]: "Limite Affidamento",
        ["Limite diritti fissi"]: "Limite diritti fissi",
        ["Limite flessibilita"]: "Limite flessibilita",
        ["LIMITE INFERIORE SUPERATO"]: "LIMITE INFERIORE SUPERATO",
        ["Limite per Contraente / Importo Affidamento"]: "Limite per Contraente / Importo Affidamento",
        ["Limite per contraente"]: "Limite per contraente",
        ["Limite per singolo contraente"]: "Limite per singolo contraente",
        ["Limite per singolo prodotto"]: "Limite per singola polizza",
        ["Limite rimasto"]: "Limite residuo",
        ["Limite sottoscrittore"]: "Limite sottoscrittore",
        ["Limite su importo affidamento non provvisorie"]: "Limite su importo affidamento non provvisorie",
        ["Limite su importo affidamento non provvisorio"]: "Limite su importo affidamento",
        ["Limite su importo affidamento provvisorie"]: "Limite su importo affidamento provvisorie",
        ["Limite su importo affidamento provvisorio"]: "Limite su importo affidamento",
        ["Limite su importo affidamento"]: "Limite su importo affidamento",
        ["Limite su massimale"]: "Limite su massimale",
        ["Limite su premio"]: "Limite su premio",
        ["LIMITE SUPERIORE SUPERATO"]: "LIMITE SUPERIORE SUPERATO",
        ["Limite utilizzato"]: "Limite utilizzato",
        ["LimiteMassimoContraente"]: "Limite massimo contraente",
        ["LimiteMassimoContraente_NonProvvisorie"]: "Non provv. - Limite massimo contraente",
        ["LimiteMassimoContraente_Provvisorie"]: "Provv. - Limite massimo contraente",
        ["LimiteMassimoFideiussione"]: "Limite massimo fideiussione",
        ["LimiteMassimoFideiussione_NonProvvisorie"]: "Non provv. - Limite massimo fideiussione",
        ["LimiteMassimoFideiussione_Provvisorie"]: "Provv. - Limite massimo fideiussione",
        ["Limiti aggiornati correttamente"]: "Limiti aggiornati correttamente",
        ["Limiti"]: "Limiti",
        ["LIMITI"]: "LIMITI",
        ["LinguaNotifiche"]: "Lingua Notifiche",
        ["ListaApprovazioniRichieste"]: "Lista Approvazioni Richieste",
        ["ListaBinder"]: "Lista binder",
        ["ListaBinderErrataCompagnia"]: "La lista dei binder inserita non è corretta",
        ["ListaBinderRichiesta"]: "Questo affidamento richiede una lista di binder",
        ["ListaBinderVuota"]: "La lista dei binder è vuota",
        ["ListaErrore"]: "ListaErrore",
        ["ListaGruppiNotificaJSON"]: "Lista Gruppi Notifica JSON",
        ["Livello"]: "Livello",
        ["Livello1"]: "Livello1",
        ["Livello2"]: "Livello2",
        ["Livello3"]: "Livello3",
        ["Livello4"]: "Livello4",
        ["Local Producer MD"]: "Local Producer MD FIDE",
        ["Local Producer User"]: "Local Producer User FIDE",
        ["Login"]: "Login",
        ["Logopedista"]: "Logopedista",
        ["Logout"]: "Logout",
        ["Lordo"]: "Premio Lordo",
        ["LoScopertoMaxDeveEssereMaggioreUgualeDelloScopertoMin"]: "Il massimo dello scoperto deve essere maggiore o uguale al minimo",
        ["Luogo esecuzione"]: "Luogo di esecuzione",
        ["Luogo nascita"]: "Luogo di nascita",
        ["LuogoEsecuzione"]: "Luogo di esecuzione",
        ["MalattieAppCardiovasc"]: "Malattie dell'Apparato Cardiovascolare",
        ["MalattieInfettive"]: "Malattie infettive",
        ["MalattieTropicali"]: "Malattie tropicali",
        ["Mandante"]: "Mandante",
        ["Mandanti"]: "Mandanti",
        ["Manuale utente"]: "Manuale utente",
        ["Margine Operativo Lordo"]: "Margine Operativo Lordo",
        ["Margine Operativo"]: "Margine operativo",
        ["Maschio"]: "Maschio",
        ["Massaggiatore"]: "Massaggiatore",
        ["Massimale"]: "Massimale",
        ["MassimaleCopertura"]: "Massimale per sinistro/per anno",
        ["MassimaleCoperturaAggregato"]: "Massimale per anno",
        ["MassimaleCoperturaSingolo"]: "Massimale per sinistro",
        ["Massimale / Sinistro alla Stipula"]: "Massimale / Sinistro alla Stipula",
        ["Massofisioterapista"]: "Massofisioterapista",
        ["Massoterapista"]: "Massoterapista",
        ["Mediatore"]: "Mediatore",
        ["Mediatori"]: "Mediatori Creditizi",
        ["Medici"]: "Medici Chirurghi",
        ["MedicinaDelLavoro"]: "Medicina del Lavoro",
        ["MedicinaEmergenza"]: "Medicina d'Emergenza - Urgenza",
        ["MedicinaER"]: "Medicina ER",
        ["MedicinaGenerale"]: "Medicina Generale",
        ["MedicinaInterna"]: "Medicina Interna",
        ["MedicinaLavoro"]: "Medicina Del Lavoro compresa l’attività di Medico Competente-Ispettore Sanitario",
        ["MedicinaLegale"]: "Medicina Legale e delle Assicurazioni",
        ["MedicinaNucleare"]: "Medicina Nucleare",
        ["MedicinaSport"]: "Medicina dello Sport",
        ["MedicinaTropicale"]: "Medicina Tropicale",
        ["MedicoFrequentatore"]: "MEDICI-FREQUENTATORI",
        ["MedicoGenerico"]: "Medicina Generale/Medico Generico/Medico di Base",
        ["MedicoSES"]: "Medicina Del Servizio Di Emergenza Sanitaria",
        ["MembroCdA"]: "Membro del Consiglio di Amministrazione",
        ["Menu amministrativo"]: "Menu amministrativo",
        ["Mesi"]: "Mesi",
        ["Meteorologo"]: "Meteorologo",
        ["Miscellaneous"]: "Miscellaneous",
        ["Microcredito"]: "Tutor Microcredito",
        ["Modalita emissione"]: "Modalità emissione",
        ["Modello IVA"]: "Modello IVA",
        ["Modifica"]: "Modifica",
        ["Modificato"]: "Modificato",
        ["MoneyTransfer"]: "Money Transfer",
        ["Motivo"]: "Motivazione",
        ["Musicista"]: "Musicista e produttore",
        ["Mutui"]: "Mutui",
        ["Mutuo"]: "Mutuo",
        ["Naturopata"]: "Naturopata",
        ["Nazione"]: "Nazione",
        ["ND"]: "ND",
        ["Ne{1-S}ne{2-S}sonoStatiCompilati"]: "Né {1-S} né {2-S} sono stati compilati",
        ["Nefrologia"]: "Nefrologia",
        ["Negli ultimi tre anni e con riferimento ad ogni singolo anno, la Società ha ridotto o incrementato il numero totale dei dipendenti in misura superiore al 25% della forza lavorativa in essere l’anno precedente?"]:
            "Negli ultimi tre anni e con riferimento ad ogni singolo anno, la Società ha ridotto o incrementato il numero totale dei dipendenti in misura superiore al 25% della forza lavorativa in essere l’anno precedente?",
        ["nel formato giorno/mese/anno"]: "nel formato giorno/mese/anno",
        ["Neolaureato"]: "Neolaureato: L'assicurato dichiara di non essere iscritto all'Albo dei Medici Chirurghi da oltre 3 anni e di non aver compiuto i 34 anni di età.",
        ["Nessun dato presente"]: "Nessun dato presente",
        ["Nessun record corrisponde ai parametri di ricerca"]: "Nessun record corrisponde ai parametri di ricerca",
        ["Nessun risultato trovato"]: "Nessun risultato trovato",
        ["Nessuna"]: "Nessuna",
        ["Neurochirurgia"]: "Neurochirurgia",
        ["NeurologiaNeuropsichiatria"]: "Neurologia e NeuroPsichiatria (anche infantile)",
        /*  ["Neuropsichiatria"]: "NeuroPsichiatria(anche infantile)",*/
        ["NeuropsichiatriaSolo"]: "Neuropsichiatria",
        ["News"]: "Ultime notizie",
        ["New password"]: "Nuova password",
        ["Next"]: "Prossimo",
        ["NO"]: "NO",
        ["No"]: "No",
        ["No, è un cliente diretto"]: "No, è un cliente diretto",
        ["Nome"]: "Nome",
        ["Nome del Intermediario"]: "Nome del Intermediario",
        ["NomeFile"]: "NomeFile",
        ["Nominativo"]: "Nominativo",
        ["Non è possibile invalidare un file, potrebbe essere in uso in altre pratiche, contattare l'amministratore di sistema"]:
            "Non è possibile invalidare un file, potrebbe essere in uso in altre pratiche, contattare l'amministratore di sistema",
        ["Non hai i permessi per accedere alla pagina"]: "Non hai i permessi per accedere alla pagina",
        ["Non provvisorie"]: "Non provvisorie",
        ["Non tutti i file necessari sono stati selezionati e validati"]: "Non tutti i file necessari sono stati selezionati e validati",
        ["Non tutti i file necessari sono stati validati correttamente"]: "Non tutti i file necessari sono stati validati correttamente",
        ["NonèPossibileRichiedereLEmissioneDiUnaPolizzaNonEmettibile"]: "Non è possibile richiedere l'emissione di una polizza non emettibile",
        ["NonèPossibileRichiedereLEmissioneDiUnaPolizzaNonEmettibileInviareRichiestaSottoscrittore"]:
            "Non è possibile richiedere l'emissione di una polizza non emettibile - inviare una richiesta al Sottoscrittore",
        ["NonEStatoIndicatoNessunFatturatoSindacoRevisoreMembroCdA"]: "Non è stato indicato nessun fatturato per il Sindaco/Revisore/Membro CdA",
        ["NonProvvisorie{1-I}"]: "Non provv.: {1-I}",
        ["Note deroga"]: "Note deroga",
        ["Note"]: "Note",
        ["Notizia"]: "Notizia",
        ["NP Annullata"]: "NP Annullata",
        ["NP Bozza accettata"]: "NP Bozza accettata",
        ["NP Bozza emessa"]: "NP Bozza emessa",
        ["NP Polizza emessa"]: "NP Polizza emessa",
        ["NP Polizza sottoscritta"]: "NP Polizza sottoscritta",
        ["NP Preventivo di polizza"]: "NP Preventivo di polizza",
        ["NP Proposta riaperta"]: "NP Proposta riaperta",
        ["NP Proposta rifiutata"]: "NP Proposta rifiutata",
        ["NP Proposta sospesa"]: "NP Proposta sospesa",
        ["NP Stornata"]: "NP Stornata",
        ["NP Svincolata"]: "NP Svincolata",
        ["NP Titolo emesso"]: "NP Titolo emesso",
        ["NP Titolo incassato"]: "NP Titolo incassato",
        ["NP Trattativa chiusa"]: "NP Trattativa chiusa",
        ["null"]: " ",
        ["NULL"]: " ",
        ["Numero"]: "Numero",
        ["Numero documento"]: "N° documento",
        ["Numero Polizza"]: "Numero Polizza",
        ["NumeroAnniCoperturaPrecedenteContinua"]: "Anni copertura continua",
        ["NumeroAssicurati"]: "Numero Assicurati",
        ["NumeroDipendenti"]: "Numero di dipendenti",
        ["NumeroIscrizione"]: "Numero Iscrizione",
        ["NumeroMassimoInformazioniInseribiliRaggiunto"]: "Numero Massimo Informazioni Inseribili Raggiunto",
        ["NumeroPolizza"]: "NumeroPolizza",
        ["Nuova password"]: "Nuova password",
        ["Nuova polizza neutra"]: "Nuova polizza neutra",
        ["Nuova polizza CAR"]: "Nuova polizza CAR",
        ["Nuovi affidamenti/Nuove fideiussioni"]: "Fideiussioni: nuovi affidamenti/nuove polizze",
        ["Nuovo indirizzo"]: "Nuovo indirizzo",
        ["Nuovo mandante"]: "Nuovo mandante",
        ["Nuovo preventivo"]: "Nuovo preventivo",
        ["Nuovo recapito"]: "Nuovo recapito",
        ["Nuovo"]: "Nuovo",
        ["NUOVO"]: "NUOVO",
        ["Nutrizionista"]: "Nutrizionista",
        ["Non temporanea"]: "Non temporanea",
        ["OCC"]: "OCC Organismo per la composizione della crisi da sovraindebitamento",
        ["Odontoiatri"]: "Odontoiatri",
        ["Odontoiatria"]: "Odontoiatria senza implantologia",
        ["OdontoiatriaImplantologia"]: "Odontoiatria con implantologia",
        ["Odontotecnico"]: "Odontotecnico",
        ["ODV"]: "ODV Organismo di Vigilanza",
        ["of"]: "di",
        ["Oftalmologia"]: "Oftalmologia",
        ["Oggetto"]: "Oggetto",
        ["OggettoGaranzia"]: "Oggetto Garanzia",
        ["Oncologia"]: "Oncologia",
        ["Oneri di Urbanizzazione"]: "Oneri di Urbanizzazione",
        ["OperaMerloni"]: "Opera Merloni",
        ["Operatività"]: "Operatività",
        ["Operazione avvenuta correttamente"]: "Operazione avvenuta correttamente",
        ["Operazione"]: "Operazione",
        ["OpereSubacquee"]: "Opere subacquee",
        ["Optometrista"]: "Optometrista",
        ["Ordina"]: "Ordina",
        ["Ordine"]: "Ordine",
        ["OrtopediaTraumatologia"]: "Ortopedia e Traumatologia",
        ["OSS"]: "Operatore socio sanitario",
        ["Osteopata"]: "Osteopata",
        ["Otorinolaringoiatria"]: "Otorinolaringoiatria",
        ["PA"]: "Pubblica Amministrazione, Istruzione",
        ["PA-ApprovatoNegativo"]: "Approvato con parere negativo",
        ["PA-ApprovatoPositivo"]: "Approvato con parere positivo",
        ["Pannello Autorizzazioni"]: "Pannello Autorizzazioni",
        ["PA-Proposta"]: "Proposta",
        ["ParametriRiferimento"]: "Parametri di riferimento del Settore",
        ["Parere"]: "Parere dell'Analista",
        ["Passaporto"]: "Passaporto",
        ["PassatoEsercizio"]: "Fatturato Consuntivo",
        ["Password"]: "Password",
        ["PasswordAggiornata"]: "Password aggiornata",
        ["PasswordBloccata"]: "Password Bloccata",
        ["PasswordErrata"]: "Utente e/o password errati",
        ["Passwords mismatch"]: "Passwords mismatch",
        ["Patente"]: "Patente",
        ["Patologia"]: "Patologia Clinica, esclusa effettuazione di analisi genetiche",
        ["PatologiaClinica"]: "Patologia Clinica",
        ["Patrimonio netto"]: "Patrimonio Netto",
        ["Patrocinatori"]: "Patrocinatori Stragiudiziali",
        ["PCP-Calcolo"]: "Calcolo",
        ["PCP-Compagnia"]: "Compagnia",
        ["PCP-POS"]: "POS",
        ["PCP-UW"]: "Sottoscrittore",
        ["PEC"]: "PEC",
        ["Pedagogista"]: "Pedagogista",
        ["PediatraLiberaScelta"]: "Pediatra di Libera Scelta",
        ["Pediatria"]: "Pediatria (Esclusa Neonatologia E Rianimazione)",
        ["PediatriaSolo"]: "Pediatria",
        ["Pegno"]: "Pegno",
        ["Per contraente"]: "Per contraente",
        ["Per fideiussione"]: "Per fideiussione",
        ["Per questa polizza ti sei avvalso della collaborazione di un altro intermediario assicurativo (iscritto in sezione A o B del RUI)?"]: "Per questa polizza ti sei avvalso della collaborazione di un altro intermediario assicurativo (iscritto in sezione A o B del RUI)?",
        ["Percentuale del Capitale Sociale"]: "% del capitale sociale",
        ["Percentuale"]: "Percentuale",
        ["PercentualeAttivita"]: "% Attività",
        ["PercentualeDighe"]: "% Dighe",
        ["PercentualeFerrovie"]: "% Ferrovie",
        ["PercentualeFunivie"]: "% Funivie",
        ["PercentualeGallerie"]: "% Gallerie",
        ["PercentualeOpereSubacquee"]: "5 Opere Subacquee",
        ["PerditePatrimoniali"]: "Perdite Patrimoniali",
        ["PeritiAssicurativi"]: "Periti Assicurativi",
        ["PeritiIndustriali"]: "Periti Industriali",
        ["PeritiStandard"]: "Periti",
        ["Perito"]: "Attività di Perito (laddove il professionista è autorizzato per legge allo svolgimento di tale funzione)",
        ["PeritoAgrario"]: "Periti Agrari",
        ["Permesso di costruire"]: "Permesso di costruire",
        ["Persona fisica"]: "Persona fisica",
        ["Persona giuridica"]: "Persona giuridica",
        ["Persona giuridica/Professionista"]: "Persona giuridica/Professionista",
        ["PersonaFisica"]: "Persona fisica",
        ["PersonaGiuridica"]: "Persona giuridica",
        ["Personale"]: "Personale",
        ["PersonalTrainer"]: "Personal Trainer",
        ["Pesca"]: "Settore Pesca",
        ["PIVA"]: "P.IVA",
        ["PIVACF"]: "P.IVA/C.F.",
        ["PlaceholderData"]: "Data",
        ["Pneumologia"]: "Pneumologia/Malattie dell'Apparato Respiratorio",
        ["Policies Number"]: "Numero polizze",
        ["Policy ID"]: "Polizza ID",
        ["Polizza AgentiMediatori"]: "Polizza Agenti Mediatori",
        ["Polizza AmministratoriCondominio"]: "Polizza Amministratore di stabili condominiali",
        ["Polizza AreaMedica"]: "Polizza Area Medica",
        ["Polizza AreaOdontoiatrica"]: "Polizza Odontoiatri",
        ["Polizza Avvocati"]: "Polizza Avvocati",
        ["Polizza bloccata correttamente con ID: {1-S}"]: "Polizza bloccata correttamente con ID: {1-S}",
        ["Polizza ColpaGrave"]: "Polizza Colpa Grave Medici SSN",
        ["Polizza Commercialisti Sindaci/Revisori/Membri CdA"]: "Polizza Commercialisti Sindaci/Revisori/Membri CdA",
        ["Polizza Commercialisti"]: "Polizza Commercialisti",
        ["Polizza Consulenti del lavoro Sindaci/Revisori/Membri CdA"]: "Polizza Consulenti del lavoro Sindaci/Revisori/Membri CdA",
        ["Polizza Consulenti del lavoro"]: "Polizza Consulenti del lavoro",
        ["Polizza emessa correttamente"]: "Polizza emessa correttamente",
        ["Polizza emessa correttamente con ID: {1-S}"]: "Polizza emessa correttamente con ID: {1-S}",
        ["Polizza annullata correttamente"]: "Polizza annullata correttamente",
        ["Polizza inviata correttamente"]: "Polizza inviata correttamente",
        ["Polizza emessa"]: "Polizza emessa",
        ["Polizza emessa e firmata"]: "Polizza emessa e firmata",
        ["Polizza emessa e rinnovata"]: "Polizza emessa e rinnovata",
        ["Quietanza di rinnovo emessa"]: "Quietanza di rinnovo emessa",
        ["Polizza in rinnovo consolidato"]: "Polizza in rinnovo consolidato",
        ["Polizza in rinnovo approvata"]: "Polizza in rinnovo approvata",
        ["Polizza in rinnovo"]: "Polizza in rinnovo",
        ["Polizza Miscellaneous"]: "Polizza Miscellaneous",
        ["Polizza non verificata"]: "Polizza non verificata",
        ["Polizza Patrocinatori"]: "Polizza Patrocinatori",
        ["Polizza PeritoAgrario"]: "Polizza Periti Agrari",
        ["Polizza RCAmministratori"]: "Polizza D&O",
        ["Polizza RespServProtPrev"]: "Polizza R.S.P.P.",
        ["Polizza rifiutata"]: "Polizza rifiutata",
        ["Polizza salvata correttamente con ID: {1-S}"]: "Polizza salvata correttamente con ID: {1-S}",
        ["Polizza SanitariNonMedici"]: "Polizza Sanitari Non Medici",
        ["Polizza ServiziInformatici"]: "Polizza Servizi Informatici",
        ["Polizza sottoscritta POS"]: "Polizza sottoscritta POS",
        ["Polizza sottoscritta"]: "Polizza sottoscritta",
        ["Polizza Veterinari"]: "Polizza Veterinari",
        ["Polizza"]: "Polizza",
        ["Polizza Neutra"]: "Polizza Neutra",
        ["Polizza CAR"]: "Polizza CAR",
        ["POLIZZA"]: "POLIZZA",
        ["PolizzaApprovazione - Approvato con parere negativo"]: "Polizza - Approvato con parere negativo",
        ["PolizzaApprovazione - Approvato con parere positivo"]: "Polizza - Approvato con parere positivo",
        ["PolizzaApprovazione - Proposta"]: "Polizza Approvazione - Proposta",
        ["PolizzaStato"]: "Stato",
        ["PolizzaStatoApprovazioneCommenti"]: "Polizza Stato Approvazione Commenti",
        ["PolizzePreventivi"]: "Polizze e Preventivi",
        ["Polizze"]: "Polizze",
        ["PompeFunebri"]: "Pompe funebri",
        ["POS RCP FIDE"]: "POS abilitato RCP e FIDE",
        ["POS RCP"]: "POS abilitato RCP",
        ["POS"]: "Intermediario",
        ["Possibilità di effettuare il logout"]: "Possibilità di effettuare il logout",
        ["Possibilità di gestire il pannello di amministrazione"]: "Possibilità di gestire il pannello di amministrazione",
        ["Possibilità di gestire la carta servizi"]: "Possibilità di gestire la carta servizi",
        ["Possibilità di richiedere deroghe"]: "Possibilità di richiedere deroghe",
        ["Postuma"]: "Postuma",
        ["PR"]: "Pubbliche Relazioni",
        ["Precedente ragione sociale"]: "Precedente ragione sociale",
        ["Pregiudizievoli"]: "Pregiudizievoli",
        ["Premio calcolato correttamente"]: "Premio calcolato correttamente",
        ["Premio finito"]: "Premio finito",
        ["Premio fisso"]: "Premio fisso",
        ["Premio minimo"]: "Premio minimo",
        ["Premio netto"]: "Premio Netto",
        ["Premio proposto dal POS"]: "Premio proposto dal POS",
        ["Premio proposto dal sottoscrittore"]: "Premio proposto dal sottoscrittore",
        ["Premio proposto dalla compagnia (special acceptance)"]: "Premio proposto dalla compagnia (special acceptance)",
        ["Premio"]: "Premio",
        ["PremioFinito"]: "Premio finito",
        ["PremioImponibile"]: "Premio imponibile",
        ["PremioNetto"]: "Premio Netto",
        ["PremioNettoMaggiorato"]: "Premio Netto Maggiorato",
        ["PremioPagato"]: "Premio Pagato",
        ["Preventivi"]: "Preventivi",
        ["Preventivi bozza inviata"]: "Preventivi bozza inviata",
        ["Preventivo di polizza approvato"]: "Preventivo di polizza approvato",
        ["Preventivo di polizza consolidato"]: "Preventivo di polizza consolidato",
        ["Preventivo di polizza sottoposto al sottoscrittore"]: "Preventivo di polizza sottoposto al sottoscrittore",
        ["Preventivo di polizza"]: "Preventivo di polizza",
        ["Preventivo di polizza(bozza inviata)"]: "Preventivo di polizza(bozza inviata)",
        ["Preventivo non modificabile"]: "Preventivo non modificabile",
        ["Preventivo cancellato correttamente con ID: {1-S}"]: "Preventivo cancellato correttamente con ID: {1-S}",
        ["Preventivo salvato correttamente con ID: {1-S}"]: "Preventivo salvato correttamente con ID: {1-S}",
        ["Preventivo"]: "Preventivo",
        ["Previous"]: "Precedente",
        ["Privacy"]: "Privacy",
        ["Procedi"]: "Procedi",
        ["Procedure concorsuali"]: "Procedure concorsuali",
        ["ProcedureConcorsuali"]: "Procedure concorsuali",
        ["Prodotti emessi"]: "Prodotti emessi",
        ["Prodotti"]: "Prodotti",
        ["ProdottiEmessi"]: "Report per prodotti emessi",
        ["Prodotto"]: "Prodotto",
        ["Ramo"]: "Ramo",
        ["Professional Indemnity"]: "RC Professionale",
        ["Professionale"]: "Professionale",
        ["Professione"]: "Professione",
        ["Profilo utente"]: "Profilo utente",
        ["Progettazione"]: "Progettazione",
        ["Progetto Contributo"]: "Progetto Contributo",
        ["Progressivo"]: "Progressivo",
        ["Pre proposta affidamento"]: "Pre proposta affidamento",
        ["Property"]: "Property",
        ["Proprietari"]: "Proprietari",
        ["Il proprietario è stato cambiato"]: "Il proprietario è stato cambiato",
        ["Proposta affidamento"]: "Proposta affidamento",
        ["Proposta riaperta"]: "Proposta riaperta",
        ["Proposta riapertura affidamento"]: "Proposta riapertura affidamento",
        ["Proposta sospesa"]: "Proposta sospesa",
        ["Proposta"]: "Proposta",
        ["Proroga"]: "Proroga",
        ["Protesti"]: "Protesti",
        ["Provincia"]: "Provincia",
        ["Provv-Accessori"]: "Accessori provvigioni",
        ["Provv-Diritti"]: "Diritti provvigioni",
        ["Provvigione calcolata sugli accessori"]: "Provvigione calcolata sugli accessori",
        ["Provvigione calcolata sui diritti fissi"]: "Provvigione calcolata sui diritti fissi",
        ["Provvigione calcolata sul premio netto"]: "Provvigione calcolata sul premio netto",
        ["ProvvigionePercentuale"]: "Provvigione Percentuale (%)",
        ["Provvigioni"]: "Provvigioni",
        ["Provigione Accessori"]: "Provigione Accessori",
        ["Provigione POS"]: "Provigione POS",
        ["Provigione Compagnia"]: "Provigione Compagnia",
        ["PROVVIGIONI"]: "PROVVIGIONI",
        ["ProvvigioniAggiornateCorrettamente"]: "ProvvigioniAggiornateCorrettamente",
        ["PROVVIGIONIERRORE"]: "ERRORE PROVVIGIONI",
        ["ProvvigioniNonImpostate"]: "Provvigioni Non Impostate",
        ["Provvisorie"]: "Provvisorie",
        ["Provvisorie{1-I}"]: "Provvisorie: {1-I}",
        ["Provv-Netto"]: "Netto provvigioni",
        ["PS-Annullata"]: "Annullata",
        ["PS-Bloccata"]: "Bloccata",
        ["PS-BozzaAccettata"]: "Bozza Accettata",
        ["PS-BozzaEmessa"]: "Bozza Emessa",
        ["PS-Emessa"]: "Emessa",
        ["PS-EmessaFirmata"]: "Emessa e firmata",
        ["PS-EmessaRinnovata"]: "Emessa e rinnovata",
        ["Psichiatria"]: "Psichiatria",
        ["Psicologia"]: "Psicologia",
        ["Psicologo"]: "Psicologo",
        ["PS-NP-Annullata"]: "Annullata",
        ["PS-NP-BozzaAccettata"]: "Bozza Accettata",
        ["PS-NP-BozzaEmessa"]: "Bozza Emessa",
        ["PS-NP-PolizzaEmessa"]: "Polizza Emessa",
        ["PS-NP-PolizzaSottoscritta"]: "Polizza Sottoscritta",
        ["PS-NP-Preventivo"]: "Preventivo",
        ["PS-NP-PropostaRiaperta"]: "Proposta Riaperta",
        ["PS-NP-PropostaRifiutata"]: "Proposta Rifiutata",
        ["PS-NP-PropostaSospesa"]: "Proposta Sospesa",
        ["PS-NP-Stornata"]: "Stornata",
        ["PS-NP-Svincolata"]: "Svincolata",
        ["PS-NP-TitoloEmesso"]: "Titolo Emesso",
        ["PS-NP-TitoloIncassato"]: "Titolo Incassato",
        ["PS-NP-TrattativaChiusa"]: "Trattativa Chiusa",
        ["PS-PolizzaSottoscritta"]: "Polizza Sottoscritta",
        ["PS-PolizzaSottoscrittaPOS"]: "Polizza Sottoscritta POS",
        ["PS-Preventivo"]: "Preventivo",
        ["PS-PropostaRiaperta"]: "Proposta Riaperta",
        ["PS-PropostaSospesa"]: "Proposta Sospesa",
        ["PS-Rifiuto"]: "Rifiuto",
        ["PS-Stornata"]: "Stornata",
        ["PS-Svincolata"]: "Svincolata",
        ["PS-TitoloEmesso"]: "Titolo Emesso",
        ["PS-TitoloIncassato"]: "Titolo Incassato",
        ["PS-TrattativaChiusa"]: "Trattativa Chiusa",
        ["Punteggio"]: "Punteggio",
        ["Q-Appendice"]: "Appendice",
        ["Q-Polizza"]: "Polizza",
        ["Q-Rata"]: "Rata",
        ["QS-Emessa"]: "Emessa",
        ["QS-Incassata"]: "Incassata",
        ["Q-StornoConImposte"]: "Storno con imposte",
        ["Q-StornoSenzaImposte"]: "Storno senza imposte",
        ["Quadrimestrale"]: "Quadrimestrale",
        ["Qualita"]: "Qualità - Tecnico del controllo qualità",
        ["Qualora il bilancio della Società sia soggetto a certificazione, la relativa società di revisione ha certificato il bilancio apportando commenti?"]:
            "Qualora il bilancio della Società sia soggetto a certificazione, la relativa società di revisione ha certificato il bilancio apportando commenti?",
        ["Questionario"]: "Questionario",
        ["Quietanza che non comporta pagamento"]: "Quietanza che non comporta pagamento",
        ["Quietanza di storno con imposte"]: "Quietanza di storno con imposte",
        ["Quietanza di storno senza imposte"]: "Quietanza di storno senza imposte",
        ["Quietanza emessa"]: "Quietanza emessa",
        ["Quietanza incassata"]: "Quietanza incassata",
        ["Quietanza per l'intera polizza"]: "Quietanza per l'intera polizza",
        ["Quietanza per una rata"]: "Quietanza per una rata",
        ["Quietanza per un'appendice"]: "Quietanza per un'appendice",
        ["Quietanza"]: "Quietanza",
        ["Quietanze"]: "Quietanze",
        ["Quota mandataria"]: "Quota mandataria",
        ["Quota rimanente"]: "Quota rimanente",
        ["Quota"]: "Quota",
        ["Quotate"]:
            "Sindaco di società quotate nei mercati finanziari/aziende di credito o bancarie/finanziarie/assicurazioni/aziende che fanno ricorso al mercato del capitale di rischio/aziende tenute al bilancio consolidato/consorzi",
        ["Q-Zero"]: "Zero",
        ["Radiodiagnostica"]: "Radiodiagnostica",
        ["Radioterapia"]: "Radioterapia",
        ["Raffinerie"]: "Raffinerie, Trattamento Combustibili Nucleari, Industria Chimica, Fibre, Gomma Plastica",
        ["Ragione Sociale"]: "Ragione Sociale",
        ["RagioneSocialeIVA"]: "Ragione sociale (compresa P.IVA)",
        ["Range"]: "Periodo",
        ["Rata di saldo"]: "Rata di saldo",
        ["RCAmministratori"]: "D&O",
        ["RCP"]: "RCP",
        ["RCPG-Accessoria-AmministratoreCondomini"]: "Attività di amministratore di stabili condominiali",
        ["RCPG-Accessoria-AttFiscRevEntiPubb"]: "Attività fiscale, tributaria",
        ["RCPG-Accessoria-DanniATerziDaInterruzioneAttivita"]: "Estensione ad interruzione o sospensione di attività",
        ["RCPG-Accessoria-DanniAttrezzatureLaboratorio"]: "Danni alle Attrezzature di Laboratorio",
        ["RCPG-Accessoria-EffettuazioneOpereAltoRischio"]: "Effettuazione Opere ad Alto Rischio",
        ["RCPG-Accessoria-FunzioniPubbliche"]: "Funzioni Pubbliche",
        ["RCPG-Accessoria-GeneralContractor"]: "General Contractor",
        ["RCPG-Accessoria-Implantologia"]: "Implantologia",
        ["RCPG-Accessoria-LiquidazioneCuratela"]: "Liquidazione e Curatela",
        ["RCPG-Accessoria-Neolaureati"]: "Neolaureati",
        ["RCPG-Accessoria-OCC"]: "OCC Organismo per la composizione della crisi da sovraindebitamento",
        ["RCPG-Accessoria-ODV"]: "ODV Organismo di Vigilanza",
        ["RCPG-Accessoria-PatrocinatoriStragiudiziali"]: "Patrocinatori Stragiudiziali",
        ["RCPG-Accessoria-PerditePatrimoniali"]: "Perdite Patrimoniali",
        ["RCPG-Accessoria-Postuma"]: "Postuma",
        ["RCPG-Accessoria-Retroattivita"]: "Retroattività",
        ["RCPG-Accessoria-FunzioneRevisoreContabile"]: "Funzione di revisione contabile",
        ["RCPG-Accessoria-FunzioneRevisoreContabileEP"]: "Funzione di revisione contabile in Enti Pubblici",
        ["RCPG-Accessoria-MembroCdA"]: "Membro del consiglio di amministrazione",
        ["RCPG-Accessoria-Sindaco"]: "Attività di Sindaco",
        ["RCPG-Accessoria-SindacoRevisoreMembroCdA"]: "Sindaco Revisore Membro CdA",
        ["RCPG-Accessoria-VistoLeggero"]: "Visto Leggero",
        ["RCPG-Accessoria-VistoPesante"]: "Visto Pesante",
        ["RCPG-BaseAgenti"]: "Agenti",
        ["RCPG-BaseAgentiMediatori"]: "Agenti e Mediatori",
        ["RCPG-BaseAmministratoriCondominio"]: "Amministratore di stabili condominiali",
        ["RCPG-BaseArchitetti"]: "Architetti",
        ["RCPG-BaseAreaMedica"]: "Medici Chirurghi",
        ["RCPG-BaseAreaOdontoiatrica"]: "Odontoiatri",
        ["RCPG-BaseAvvocati"]: "Avvocati",
        ["RCPG-BaseColpaGrave"]: "Colpa Grave Medici SSN",
        ["RCPG-BaseCommercialisti"]: "Commercialisti",
        ["RCPG-BaseCommercialistiRevisori"]: "Commercialisti Revisori",
        ["RCPG-BaseConsulentiLavoro"]: "Consulenti Lavoro",
        ["RCPG-BaseConsulentiLavoroRevisori"]: "Consulenti Lavoro Revisori",
        ["RCPG-BaseGeologi"]: "Geologi",
        ["RCPG-BaseGeometri"]: "Geometri",
        ["RCPG-BaseIgienistiDentali"]: "Igienisti Dentali",
        ["RCPG-BaseIngegneri"]: "Ingegneri",
        ["RCPG-BaseMediatori"]: "Mediatori",
        ["RCPG-BaseMiscellaneous"]: "Miscellaneous",
        ["RCPG-BasePatrocinatori"]: "Base Patrocinatori",
        ["RCPG-BasePeritiStandard"]: "Periti",
        ["RCPG-BasePeritoAgrario"]: "Periti Agrari",
        ["RCPG-BaseRCAmministratori D&O"]: "D&O",
        ["RCPG-BaseRCAmministratori"]: "D&O",
        ["RCPG-BaseRespServProtPrev"]: "R.S.P.P.",
        ["RCPG-BaseSanitariNonMedici"]: "Sanitari Non Medici",
        ["RCPG-BaseServiziInformatici"]: "Servizi Informatici",
        ["RCPG-BaseVeterinari"]: "Veterinari",
        ["Recapiti"]: "Recapiti",
        ["Recapito"]: "Recapito",
        ["Record non trovato clicca il bottone per crearne uno"]: "Record non trovato clicca il bottone per crearne uno",
        ["Recupera password"]: "Recupera password",
        ["Redditivita"]: "Redditivita",
        ["Reddito complessivo"]: "Reddito complessivo",
        ["Reddito Immobili"]: "Reddito Immobili",
        ["REFERRAL"]: "REFERRAL",
        ["Regola{1-S}NonPresente"]: "Regola {1-S} Non Presente",
        ["Regole da applicare sui campi delle form"]: "Regole da applicare sui campi delle form",
        ["Reinsurer"]: "Riassicuratore",
        ["Relativo Mercato"]: "Relativo Mercato",
        ["Release Endorsement"]: "Appendice di svincolo",
        ["Rendicontazione"]: "Rendicontazione",
        ["Reparto"]: "Reparto",
        ["Residenza"]: "Residenza",
        ["ResponsabilitaAcclarate"]: "Responsabilità Acclarate",
        ["Rete distributiva"]: "Rete distributiva",
        ["Retroattivita"]: "Retroattività",
        ["Reumatologia"]: "Reumatologia",
        ["Revisione affidamento"]: "Revisione affidamento",

        ["Revisore"]: "Attività fiscale, tributaria",

        ["RevisoreComm"]: "Funzione di revisore contabile",
        ["RevisoreCommEP"]: "Funzione di revisore contabile in enti pubblici",
        ["Ribasso asta"]: "Ribasso asta",
        ["RibassoAsta"]: "Ribasso asta",
        ["Ricerca"]: "Ricerca",
        ["Ricevente"]: "A",
        ["Ricevuta Pagamento"]: "Ricevuta Pagamento",
        ["Richiedi Deroga"]: "Richiedi deroga",
        ["Richiedi"]: "Richiedi",
        ["RichiediDeroga"]: "Richiedi deroga",
        ["Richiesta cambio stato avvenuto con successo"]: "Richiesta cambio stato avvenuto con successo",
        ["Richiesta deroga inserita correttamente"]: "Richiesta deroga inserita correttamente",
        ["Richiesta deroga"]: "Richiesta deroga",
        ["Richiesta riapertura"]: "Richiesta riapertura",
        ["Richiesta per la firma digitale inviata correttamente"]: "Richiesta per la firma digitale inviata correttamente",
        ["Richiesto"]: "Richiesto",
        ["RicostruttoriUnghie"]: "Ricostruttori Unghie",
        ["Rifiuta"]: "Rifiuta",
        ["Rifiutata"]: "Rifiutata",
        ["Rifiuto"]: "Rifiuto",
        ["Rifiuto affidamento"]: "Rifiuto affidamento",
        ["RifiutoCopertura"]: "Al Proponente sono state rifiutate le seguenti coperture assicurative per la Responsabilità Civile Professionale?",
        ["RifiutoCopertureAssicurative"]: "Rifiuto Coperture Assicurative",
        ["Rilasciato da"]: "Rilasciato da",
        ["Rilasciato in data"]: "Rilasciato in data",
        ["RilascioFideiussioni"]: "Rilascio Fideiussioni",
        ["RilieviCatastaliTopografici"]: "Rilievi catastali e topografici",
        ["Rimborsi IVA"]: "Rimborsi IVA",
        ["Rimetti in preventivo"]: "Rimetti in preventivo",
        ["Rimuovi"]: "Rimuovi",
        ["Rinnovi"]: "Rinnovi",
        ["Rinnovo"]: "Rinnovo",
        ["Rinnova"]: "Rinnova",
        ["RinnovoDomanda1"]: "Sono intervenuti cambiamenti materiali del rischio rispetto a quanto dichiarato nel questionario dell’anno precedente?",
        ["RinnovoDomanda2"]: "Sono intervenuti cambiamenti nel fatturato consuntivo dichiarato nel questionario dell’anno precedente?",
        ["RinnovoDomanda3"]: "Sono intervenuti sinistri e/o richieste di risarcimento e/o fatti e/o circostanze dai/dalle quali possano ragionevolmente derivare 'richieste di risarcimento'?                                                                                                                                                                     ",
        ["RinnovoNote1"]: "Intervenuti cambiamenti materiali del rischio rispetto a quanto dichiarato nel questionario dell’anno precedente",
        ["RinnovoNote3"]: "Intervenuti sinistri e/o richieste di risarcimento e/o fatti e/o circostanze dai/dalle quali possano ragionevolmente derivare 'richieste di risarcimento'                                                                                                                                                                     ",

        ["Rinnovo affidamento"]: "Rinnovo affidamento",
        ["Ripristino"]: "Ripristino",
        ["Rischio"]: "Società che fanno ricorso al mercato del capitale di rischio",
        ["RischiPattuizioneEspressa"]: "Rischi a pattuizione espressa",
        ["Rows per page"]: "Righe per pagina:",
        ["RSPP"]: "R.S.P.P.  Responsabili Servizio di Prevenzione e Protezione",
        ["RTI"]: "R.T.I.",
        ["Ruolo"]: "Ruolo",
        ["RUP"]: "R.U.P. (Responsabile Unico del Procedimento)",
        ["S.a.s."]: "S.a.s.",
        ["S.c.a.r.l."]: "S.c.a.r.l.",
        ["S.n.c."]: "S.n.c.",
        ["S.P.A."]: "S.P.A.",
        ["S.r.l."]: "S.r.l.",
        ["S.r.l.s."]: "S.r.l.s.",
        ["S.s."]: "S.s.",
        ["Salva anagrafica"]: "Salva anagrafica",
        ["Salva Anagrafica"]: "Salva Anagrafica",
        ["Salva"]: "Salva",
        ["Salva (bozza inviata)"]: "Salva (bozza inviata)",
        ["SalvaAnagrafica"]: "Salva Anagrafica",
        ["Salva appendici"]: "Salva appendici",
        ["Sanita"]: "Sanità, Servizi Sociali",
        ["Sanitari"]: "Sanitari Non Medici",
        ["Scadenza Affidamento"]: "Scadenza Affidamento",
        ["ScadenzaAffidamento"]: "Scadenza Affidamento",
        ["ScaricaFile"]: "Scarica il documento",
        ["SCARSA"]: "SCARSA",
        ["Scoperto {1-P} con il minimo di {2-I} e massimo {3-I}"]: "Scoperto {1-P} con il minimo di {2-I} e massimo {3-I}",
        ["Scoperto"]: "Scoperto",
        ["Scoperto Partita 1"]: "Scoperto - Partita 1",
        ["Scoperto Partita 2"]: "Scoperto - Partita 2",
        ["Scoperto Partita 3"]: "Scoperto - Partita 3",
        ["Scoperto Sezione B"]: "Scoperto - Sezione B",
        ["Sezione B Limit"]: "Sezione B Limito",
        ["Scoperto Minimo Partita 1"]: "Scoperto Minimo - Partita 1",
        ["Scoperto Minimo Partita 2"]: "Scoperto Minimo - Partita 2",
        ["Scoperto Minimo Partita 3"]: "Scoperto Minimo - Partita 3",
        ["Scoperto Minimo Sezione B"]: "Scoperto Minimo - Sezione B",
        ["Scoperto10Minimi1500Massimo3000"]: "Scoperto 10%  minimo € 1.500,00 e massimo € 3.000,00",
        ["ScopertoMax"]: "Massimo",
        ["ScopertoMin"]: "Minimo",
        ["Scrittura"]: "Scrittura",
        ["Sede Legale"]: "Sede Legale",
        ["Sede Principale"]: "Sede Principale",
        ["Sede Secondaria"]: "Sede Secondaria",
        ["Sede"]: "Sede",
        ["SediSecondarie"]: "Sedi Secondarie",
        ["Seleziona"]: "Seleziona",
        ["Seleziona..."]: "Seleziona...",
        ["SelezionareAnagraficaContraente"]: "Selezionare Anagrafica Contraente",
        ["SelezionareGaranziaAccessoriaRetroattivita"]: "Selezionare garanzia accessoria retroattività",
        ["SelezionareProfessione"]: "Selezionare Professione",
        ["Selezionati"]: "Selezionati",
        ["Selezionato"]: "Selezionato",
        ["Semestrale"]: "Semestrale",
        ["Sessione duplicata"]: "Sessione duplicata",
        ["Sessione scaduta"]: "Sessione scaduta",
        ["SessioneNonValida"]: "Sessione Non Valida",
        ["SessioneScaduta"]: "Sessione Scaduta",
        ["Sesso"]: "Sesso",
        ["SetInformativo"]: "Set informativo",
        ["Sezioni"]: "Sezioni",
        ["Show"]: "Spettacolo",
        ["SI"]: "SI",
        ["Si"]: "Si",
        ["SindacoComm"]: "Attività di Sindaco",
        ["Sindaco"]: "Funzione di Sindaco",
        ["SindacoQuotate"]:
            "Sindaco di Società quotate nei mercati finanziari/aziende di credito o bancarie/finanziarie/assicurazioni/aziende che fanno ricorso al mercato del capitale di rischio/aziende tenute al bilancio consolidato/consorzi",
        ["Sinistri"]: "Sinistri",
        ["Situazione finanziaria"]: "Situazione finanziaria",
        ["SOA"]: "SOA",
        ["SOA-I"]: "SOA-I",
        ["SOA-II"]: "SOA-II",
        ["SOA-III"]: "SOA-III",
        ["SOA-IIIbis"]: "SOA-IIIbis",
        ["SOA-IV"]: "SOA-IV",
        ["SOA-IVbis"]: "SOA-IVbis",
        ["SOA-V"]: "SOA-V",
        ["SOA-VI"]: "SOA-VI",
        ["SOA-VII"]: "SOA-VII",
        ["SOA-VIII"]: "SOA-VIII",
        ["SocEDP"]: "Il Proponente si avvale dei servizi di una ditta EDP e ne possiede la maggioranza?",
        ["Società acquisita"]: "Società acquisita",
        ["Società consortile"]: "Società consortile",
        ["Societa"]: "Società",
        ["Società"]: "Società",
        ["SoftwareTerzi"]: "Distribuzione / Commercializzazione / Cessione di: Software prodotti da terzi",
        ["Somma garantitaA"]: "Somma garantita A",
        ["Somma garantitaDa"]: "Somma garantita Da",
        ["Somme Assicurate Partita 1"]: "Somme Assicurate - Partita 1",
        ["Somme Assicurate Partita 2"]: "Somme Assicurate - Partita 2",
        ["Somme Assicurate Partita 3"]: "Somme Assicurate - Partita 3",
        ["Sono ammessi solo numeri, caratteri e virgole"]: "Sono ammessi solo numeri, caratteri e virgole",
        ["Sono mai state avanzate richieste di RISARCIMENTO, anche in materia di diritto del lavoro, nei confronti della società e/o degli amministratori?"]:
            "Sono mai state avanzate richieste di RISARCIMENTO, anche in materia di diritto del lavoro, nei confronti della società e/o degli amministratori?",
        ["Sono state avanzate richieste di risarcimento o sono state promosse azioni volte ad accertare la responsabilità civile o penale nei confronti del Proponente negli ultimi 5 (cinque) anni, anche se non notificate all’Assicuratore?"]:
            "Sono state avanzate le seguenti richieste di risarcimento o sono state promosse azioni volte ad accertare la responsabilità civile o penale nei confronti del Proponente negli ultimi 5 (cinque) anni (o anche in epoca antecedente qualora le suddette richieste di risarcimento e/o azioni perdurino a tutt’oggi o siano terminate sempre nell’arco degli ultimi 5 anni), anche se non notificate all’Assicuratore. I seguenti sinistri sono esclusi dalla copertura",
        ["Sono stati ricoperti o si ricoprono tutt'ora incarichi di Sindaco o di Amministratore presso società sottoposte a procedure concorsuali?"]:
            "Sono stati ricoperti o si ricoprono tutt'ora incarichi di Sindaco o di Amministratore presso le seguenti società sottoposte a procedure concorsuali?",
        ["Sospensione affidamento"]: "Sospensione affidamento",
        ["Sottoposto a sottoscrizione"]: "Sottoposto a sottoscrizione",
        ["Sottoscrittore"]: "Sottoscrittore",
        ["Sottoscrizione affidamento"]: "Sottoscrizione affidamento",
        ["Specializzando"]: "Specializzando (In una delle branche di cui sopra - nei primi cinque anni di iscrizione all'albo)",
        ["Specializzazioni"]: "Specializzazioni",
        ["StabiliCondominiali"]: "Amministratore di stabili condominiali",
        ["Stampa bozza"]: "Stampa bozza",
        ["Stampa"]: "Stampa",
        ["Stampa Word"]: "Stampa Word",
        ["Stati aggiornati correttamente"]: "Stati aggiornati correttamente",
        ["STATI ERRORE"]: "STATI ERRORE",
        ["Stati"]: "Stati",
        ["STATI"]: "STATI",
        ["Statistico"]: "Statistico",
        ["Stato aggiornato correttamente"]: "Stato aggiornato correttamente",
        ["Stato dell’azienda"]: "Stato dell’azienda",
        ["Stato Deroga"]: "Stato",
        ["Stato polizza"]: "Stato polizza",
        ["Stato"]: "Stato",
        ["StatoCircostanza"]: "Stato dell'Evento",
        ["StatoSinistro"]: "Stato Sinistro",
        ["Status"]: "Stato",
        ["StazioneAppaltante"]: "Stazione appaltante",
        ["Stilista"]: "Stilista",
        ["StimaEsercizioCorrente"]: "Fatturato Preventivo",
        ["StimePerizie"]: "Stime e perizie",
        ["Storico"]: "Storico/ Storico dell'arte",
        ["Stornata"]: "Stornata",
        ["StornoSenzaImposta"]: "Storno senza imposta",
        ["StornoConImposta"]: "Storno con imposta",
        ["StornoSenzaImposte"]: "Storno senza imposte",
        ["StornoConImposte"]: "Storno con imposte",
        ["Struttura"]: "Struttura pubblica o privata",
        ["StudioAssociato"]: "Soggetti Assicurati",
        ["StudioAssociatoOdontoiatriIgienistiDentali"]: "Studio Associato Odontoiatri Igienisti Dentali",
        ["Sub Agente"]: "Sub Agente",
        ["Subappaltatore"]: "Subappaltatore",
        ["SUCCESS"]: "SUCCESSO",
        ["Supporto"]: "Supporto",
        ["Svincolo"]: "Svincolo",
        ["Svincolata"]: "Svincolata",
        ["TacitoRinnovo"]: "Tacito rinnovo",
        ["EmissioneDirettaPOS"]: "Emissione diretta POS",
        ["Tasse"]: "Imposte",
        ["Tassi salvati correttamente"]: "Tassi salvati correttamente",
        ["Tassi"]: "Tassi",
        ["TASSI"]: "TASSI",
        ["Tasso interesse legale"]: "Tasso interesse legale",
        ["Tasso min"]: "Tasso min",
        ["Tasso"]: "Tasso",
        ["TassoInteresseLegale"]: "Tasso interesse legale",
        ["Tatuatore"]: "Tatuatore",
        ["TecnicoAudiometrista"]: "Tecnico Audiometrista",
        ["TecnicoAudioprotesista"]: "Tecnico Audioprotesista",
        ["TecnicoDietista"]: "Tecnico nell'Alimentazione Dietetica",
        ["Telefono"]: "Telefono",
        ["Template salvato correttamente"]: "Template salvato correttamente",
        ["Temporanea"]: "Temporanea",
        ["TerapistaShiatsu"]: "Terapista Shiatsu",
        ["TerminiRinnovo"]: "Termini di Rinnovo proposti dall'attuale Compagnia",
        ["Test"]: "Test",
        ["Testo richiesto"]: "Testo richiesto",
        ["Testo"]: "Testo",
        ["TestoRichiesto"]: "Testo richiesto",
        ["The status is changed successfully"]: "Richiesta cambio stato avvenuto con successo",
        ["TipiProdotti"]: "TipiProdotti",
        ["TipiProdotto"]: "TipiProdotto",
        ["TypeWorks"]: "Tipi di lavori",
        ["Tipo affidamento"]: "Tipo affidamento",
        ["Tipo Anagrafica"]: "Tipo Anagrafica",
        ["Tipo Deroga"]: "Tipo",
        ["Tipo durata"]: "Tipo durata",
        ["Tipo Società"]: "Tipo Società",
        ["Tipo"]: "Tipo",
        ["TipoAnag"]: "Tipo",
        ["TipoAnagStato"]: "Stato",
        ["TipoCambioStato"]: "Cambio Stato",
        ["TipoCambioStatoPercorso"]: "Cambio Stato Percorso",
        ["TipoDocumento"]: "Tipo documento",
        ["Tipo Documento"]: "Tipo di documento verificato e in corso di validità",
        ["TipoFile"]: "Tipo",
        ["TipoFileStati"]: "Tipo",
        ["TipoFileStato"]: "Tipo",
        ["TipologiaAttivita"]: "Tipologia di attività",
        ["TipoProdotto"]: "Prodotto",
        ["TipoRamo"]: "Ramo",
        ["TipoStatoArrivo"]: "Stato di Arrivo",
        ["TipoStatoPartenza"]: "Stato di Partenza",
        ["TipoValutazioneEsito"]: "Tipo",
        ["Titolo emesso"]: "Titolo emesso",
        ["Titolo incassato"]: "Titolo incassato",
        ["Titolo"]: "Titolo",
        ["Tossicologia"]: "Tossicologia Medica",
        ["Totale"]: "Totale",
        ["Totale interesse legale"]: "Totale interesse legale",
        ["Totale passivo"]: "Totale passivo",
        ["TotaleInteresseLegale"]: "Importo Totale Garantito",
        ["TotalePremioLordo"]: "Totale Premio Lordo",
        ["Traduttore"]: "Traduttore/Interprete",
        ["Trattativa chiusa"]: "Trattativa chiusa",
        ["Turistico"]: "Turismo - Promotore Turistico",
        ["Tutti i documenti caricati"]: "Tutti i documenti caricati",
        ["Ufficio"]: "Ufficio",
        ["UltimiAggiornamenti"]: "Ultimi aggiornamenti",
        ["Ultimo anno"]: "Ultimo anno",
        ["Ultimo Bilancio Coobbligati"]: "Ultimo Bilancio Coobbligati",
        ["Ultimo Bilancio depositato"]: "Ultimo Bilancio depositato",
        ["Ultimo Unico Amministratore"]: "Ultimo Unico Amministratore",
        ["Ultimo Unico per societa"]: "Ultimo Unico per societa",
        ["Ultimo Unico persone"]: "Ultimo Unico persone",
        ["undefined"]: "non trovato",
        ["Underwriter"]: "Underwriter",
        ["Unico Coobbligati"]: "Unico Coobbligati",
        ["Unico Persone"]: "Unico Persone",
        ["Unico Società"]: "Unico Società",
        ["UnitaImmobiliare"]: "Dati relativi all'unità immobiliare",
        ["Upload"]: "Upload",
        ["Urologia"]: "Urologia",
        ["Username"]: "Nome utente",
        ["Utente sottoscrittore"]: "Utente sottoscrittore",
        ["Utente"]: "Utente",
        ["UtenteAnag"]: "Utente",
        ["UtenteErrato"]: "Utente Errato",
        ["Utenti"]: "Utenti",
        ["Utile (perdita) d'esercizio"]: "Utile (perdita) d'esercizio",
        ["Utility"]: "Utility",
        ["Utilizzo affidamento"]: "Utilizzo affidamento",
        ["UW RCP"]: "Sottoscrittore RCP",
        ["Va inserito solo il codice numero delle ISO delimitato da ,"]: "Va inserito solo il codice numero delle ISO delimitato da ,",
        ["VA-Accettata"]: "Accettata",
        ["Vai"]: "Go",
        ["VA-InValutazione"]: "In Valutazione",
        ["Validato"]: "Validato",
        ["Validazione Affidamento"]: "Validazione Affidamento",
        ["Valore produzione anno precedente"]: "Valore Produzione Anno Precedente",
        ["Valore Produzione Ultimo Anno"]: "Valore Produzione Ultimo Anno",
        ["Valore Produzione"]: "Valore Produzione",
        ["Valore"]: "Valore",
        ["ValoreOpera"]: "Valore opera",
        ["Value is not valid"]: "Il valore non è valido",
        ["Valutazione salvata correttamente con ID: {1-S}"]: "Valutazione salvata correttamente con ID: {1-S}",
        ["Valutazione"]: "Valutazione",
        ["VALUTAZIONE"]: "VALUTAZIONE",
        ["ValutazioneNegativa"]: "Valutazione Negativa",
        ["ValutazioneNonValida"]: "Valutazione non valida: è impossibile emettere la polizza",
        ["ValutazionePositiva"]: "Valutazione Positiva",
        ["Valutazioni"]: "Valutazioni",
        ["VA-Rifiutata"]: "Rifiutata",
        ["Vecchia password"]: "Vecchia password",
        ["Verifica salvata correttamente"]: "Verifica salvata correttamente",
        ["Verifica"]: "Verifica",
        ["Veterinari"]: "Veterinari",
        ["Vi sono titoli della Società negoziati in mercati regolamentati?"]: "Vi sono titoli della Società negoziati in mercati regolamentati?",
        ["VistoLeggero"]: "Visto di conformità 'Legge 102' (visto leggero)",
        ["VistoPesante"]: "Apposizione di 'visto pesante'",
        ["Visualizza il capogruppo"]: "Visualizza il capogruppo",
        ["Visualizza"]: "Visualizza",
        ["Visualizzatori"]: "Visualizzatori",
        ["Visura Camerale"]: "Visura Camerale",
        ["Visura Catastale"]: "Visura Catastale",
        ["Visure Coobbligati"]: "Visure Coobbligati",
        ["WARNING"]: "ATTENZIONE",
        ["Warning"]: "Attenzione",
        ["WebDesign"]: "Web design e servizi a questo collegati",
        ["Year - Month - Week"]: "Anno - Mese - Settimana",
        ["ErroreDataScadenzaPolizzaInferioreDataInizioPolizza"]: "Data scadenza polizza inferiore alla data d'inizio",
        ["ErroreSovrapposizionePeriodiAssicurativi"]: "Sovrapposizione periodi assicurativi",
        ["ErroreDataInizio"]: "Data inizio errata",
        ["ErroreDataScadenza"]: "Data scadenza errata",
        ["ErrorePolizzaPrecedenteAlpha"]: "Polizza precedente Alpha",
        ["PolizzaGiaEmessa"]: "Polizza già emessa",
        ["Utilizza"]: "Utilizza",
        ["StessoID_Anag"]: "Stessa impresa",
        ["StessoID_Utente"]: "Stesso utente",
        ["NumeroUtilizzi"]: "Utilizzi",
        ["BancaDatiGare"]: "Banca dati gare",
        ["NoMaxNoDistraintInstallmentReduction"]: "Non è possibile procedere con la Delega perchè il Cedente raggiunge i Requisiti Pensionistici durante il Finanziamento",
        ["NoMaxDistraintInstallmentReduction"]:
            "Non è possibile procedere con la Delega in considerazione dei PIGNORAMENTI presenti; inoltre il Cedente raggiunge i Requisiti Pensionistici durante la durata del Finanziamento",
        ["NoMaxDistraintNoInstallmentReduction"]: "Non è possibile procedere con la Delega in considerazione dei PIGNORAMENTI presenti",
        ["MaxNoDistraintInstallmentReduction"]:
            "La Rata Ceduta è oltre il Quinto Cedibile pari ad {1-I} inoltre non è possibile procedere con la Delega perchè il Cedente raggiunge i Requisiti Pensionistici durante il Finanziamento",
        ["MaxNoDistraintNoInstallmentReduction"]: "La rata non può superare 1/5 dello Stipendio Netto Mensile. In questo caso la Rata Ceduta Massima è pari ad {1-I}",
        ["MaxDistraintInstallmentReduction"]:
            "La Rata Ceduta è oltre il Quinto Cedibile pari ad {1-I} inoltre non è possibile procedere con la Delega perchè sono presenti PIGNORAMENTI e perchè il Cedente raggiunge i Requisiti Pensionistici durante la durata del Finanziamento",
        ["MaxDistraintNoInstallmentReduction"]: "La Rata Ceduta è oltre il Quinto Cedibile pari ad {1-I} inoltre non è possibile procedere con la Delega in considerazione dei PIGNORAMENTI presenti",
        ["MilitaryNoMaxNoDistraintInstallmentReduction"]: "Non è possibile procedere con la Delega perchè il Cedente (Militare) raggiunge i Requisiti Pensionistici durante il Finanziamento",
        ["MilitaryNoMaxDistraintInstallmentReduction"]:
            "Non è possibile procedere con la Delega in considerazione dei PIGNORAMENTI presenti; inoltre il Cedente (Militare) raggiunge i Requisiti Pensionistici durante la durata del Finanziamento",
        ["MilitaryMaxNoDistraintInstallmentReduction"]:
            "La Rata Ceduta è oltre il Quinto Cedibile pari ad {1-I} inoltre, non è possibile procedere con la Delega perchè il Cedente (Militare) raggiunge i Requisiti Pensionistici durante il Finanziamento",
        ["MilitaryMaxDistraintInstallmentReduction"]:
            "La Rata Ceduta è oltre il Quinto Cedibile pari ad {1-I} inoltre non è possibile procedere con la Delega perchè sono presenti PIGNORAMENTI e perchè il Cedente (Militare) raggiunge i Requisiti Pensionistici durante la durata del Finanziamento",
        ["No Copertura"]: "No Copertura",
        ["12 mesi"]: "12 mesi",
        ["24 mesi"]: "24 mesi",
        ["Nuovi edifici civili commerciali  industriali, scuole, ospedali, garages etc"]: "Nuovi edifici civili commerciali  industriali, scuole, ospedali, garages etc",
        ["Ristrutturazione edifici di cui al punto 1) senza intervento su strutture portanti"]: "Ristrutturazione edifici di cui al punto 1) senza intervento su strutture portanti",
        ["Ristrutturazione edifici di cui al punto 1) con  intervento su strutture portanti (escluse sottomurazioni e sottofondazioni)"]: "Ristrutturazione edifici di cui al punto 1) con  intervento su strutture portanti (escluse sottomurazioni e sottofondazioni)",
        ["Interventi su edifici che prevedano sottomurazioni e/o sottofondazioni"]: "Interventi su edifici che prevedano sottomurazioni e/o sottofondazioni",
        ["Relizzazione o ristrutturazione strade con opere d'arte inferiori al 20% contratto (ponti viadotto gallerie art. - no gallerie naturali )"]: "Relizzazione o ristrutturazione strade con opere d'arte inferiori al 20% contratto (ponti viadotto gallerie art. - no gallerie naturali )",
        ["Relizzazione o ristrutturazione strade con opere d'arte dal 20% al 50% contratto (ponti viadotto gallerie art. - no gallerie naturali )"]: "Relizzazione o ristrutturazione strade con opere d'arte dal 20% al 50% contratto (ponti viadotto gallerie art. - no gallerie naturali )",
        ["Relizzazione o ristrutturazione strade con opere d'arte superiori al 50% contratto (ponti viadotto gallerie art. - no gallerie naturali )"]: "Relizzazione o ristrutturazione strade con opere d'arte superiori al 50% contratto (ponti viadotto gallerie art. - no gallerie naturali )",
        ["Opere urbanizzazioni primarie e secondarie, impianti depurazioni e discariche"]: "Opere urbanizzazioni primarie e secondarie, impianti depurazioni e discariche",
        ["Realizzazione acquedotti e opere irrigazione"]: "Realizzazione acquedotti e opere irrigazione",
        ["Opere Bagnate"]: "Opere Bagnate",
        ["€ 500.000,00"]: "€ 500.000,00",
        ["€ 750.000,00"]: "€ 750.000,00",
        ["€ 1.000.000,00"]: "€ 1.000.000,00",
        [""]: "",
    };

    private readonly TestiES: { [T: string]: string } = {
        [""]: "",
        ["{1-N}"]: "{1-N}",
        ["{1-T}"]: "{1-T}",
        ["{1-S}"]: "{1-S}",
        ["{1-B}"]: "{1-B}",
        ["{1-D}"]: "{1-D}",
        ["{1-I}"]: "{1-I}",
        ["{1-R}"]: "{1-R}"
    };

    private readonly TestiDE: { [T: string]: string } = {
        [""]: "",
        ["{1-N}"]: "{1-N}",
        ["{1-T}"]: "{1-T}",
        ["{1-S}"]: "{1-S}",
        ["{1-B}"]: "{1-B}",
        ["{1-D}"]: "{1-D}",
        ["{1-I}"]: "{1-I}",
        ["{1-R}"]: "{1-R}"
    };

    private readonly TestiFR: { [T: string]: string } = {
        [""]: "",
        ["{1-N}"]: "{1-N}",
        ["{1-T}"]: "{1-T}",
        ["{1-S}"]: "{1-S}",
        ["{1-B}"]: "{1-B}",
        ["{1-D}"]: "{1-D}",
        ["{1-I}"]: "{1-I}",
        ["{1-R}"]: "{1-R}"
    };

    private Lingue: { [L: string]: { [T: string]: string } } = {
        ["it"]: this.TestiIT,
        ["en"]: this.TestiEN,
        ["es"]: this.TestiES,
        ["de"]: this.TestiDE,
        ["fr"]: this.TestiFR
    };

    public FormatoLingua(): string {
        switch (this.Lingua) {
            case "it":
                return "it-IT";
            case "en":
                return "en-GB";
            case "es":
                return "es-ES";
            case "de":
                return "de-DE";
            case "fr":
                return "fr-FR";
        }
        return "en-US";
    }

    public FormatoImporto(): string {
        switch (this.Lingua) {
            case "it":
            case "es":
            case "de":
            case "fr":
            case "en":
                return "EUR";
            //return "GBP";
        }
        return "EUR";
        //return "USD";
    }

    public PrecisioneImporto(): number {
        switch (this.Lingua) {
            case "it":
            case "en":
            case "es":
            case "de":
            case "fr":
                return 2;
        }
        return 2;
    }

    public NumberSeparator(): { Decimal: string; Thousand: string } {
        switch (this.Lingua) {
            case "it":
                return { Decimal: ",", Thousand: "." };
        }
        return { Decimal: ".", Thousand: "," };
    }

    public AggiornaTrad(lingua: string, testo: string, trad: string): boolean {
        if (this.Lingue[lingua][testo] != trad) {
            this.Lingue[lingua][testo] = trad;
            return true;
        } else {
            return false;
        }
    }

    constructor(lingua: string) {
        this.Lingua = lingua;
    }

    private _Lingua: string = "";
    get Lingua(): string {
        return this._Lingua;
    }
    set Lingua(lingua: string) {
        if (lingua == "") {
            lingua = navigator.language.substring(0, 2);
        }
        if (this.Lingue[lingua] == null) {
            lingua = "en";
        }
        this._Lingua = lingua;
    }

    private DataTrad(Data: string | Date): string {
        if (Data == undefined || Data == null) {
            return "";
        } else {
            let Formato = Trad.Trad("DD/MM/YYYY");
            if (Formato.substr(0, 1) == "[") {
                Glob.Log(Glob.LogCat.Trad, false, "DataTrad senza traduzione", moment(Data));
                return moment(Data).format("DD/MM/YYYY");
            } else {
                Glob.Log(Glob.LogCat.Trad, false, "DataTrad con traduzione", moment(Data), Trad.Trad("DD/MM/YYYY"), moment(Data).format(Trad.Trad("DD/MM/YYYY")));
                return moment(Data).format(Trad.Trad("DD/MM/YYYY"));
            }
        }
    }

    public Trad(testo: string | Date): string {
        if (testo instanceof Date) {
            return this.DataTrad(testo);
        } else {
            if (testo == "") {
                return "";
            } else {
                var REDateISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z?$/.exec(testo);
                if (REDateISO) {
                    return this.DataTrad(testo);
                } else {
                    let R: string = this.Lingue[this.Lingua][testo];
                    if (R == undefined) {
                        return "[" + this.Lingua + "]" + testo;
                    }
                    return this.Lingue[this.Lingua][testo];
                }
            }
        }
    }

    //N = Numero                 int      | number,
    //S = Stringa                string   | string
    //T = Stringa con traduzione string   | string
    //B = SiNo                   bool     | boolean
    //D = DataOra                DateTime | Date
    //R = Reale                  decimal  | number
    //I = Importo                decimal  | number
    //P = Percentuale            decimal  | number
    public TradParam(testo: string, parametri: any[]): string {
        Glob.Log(Glob.LogCat.Trad, false, "TradParam", testo, parametri);
        let R: string = this.Trad(testo);
        if (Compat.ES6_String_startWith(R, "[" + this.Lingua + "]")) {
            R = "P" + R;
        }
        for (let P = 0; P < parametri.length; P++) {
            let Pos = R.indexOf("{" + (P + 1));
            if (Pos >= 0) {
                let PosChiusura = R.indexOf("}", Pos);
                let PosTipo = R.indexOf("-", Pos);
                let Tipo = "";
                if (PosTipo < PosChiusura) {
                    Tipo = R.substring(PosTipo + 1, R.indexOf("}", Pos));
                }
                let Valore = "";
                switch (Tipo) {
                    case "N":
                        Valore = new Intl.NumberFormat(this.FormatoLingua(), {
                            maximumSignificantDigits: 13
                        }).format(parametri[P]);
                        break;
                    case "":
                    case "T":
                        Valore = this.Trad(parametri[P]);
                        break;
                    case "S":
                        Valore = parametri[P];
                        break;
                    case "B":
                        Valore = Trad.Trad(parametri[P] ? "Si" : "No");
                        break;
                    case "D":
                        Valore = Trad.Trad(parametri[P]);
                        break;
                    case "I":
                        Valore = new Intl.NumberFormat(this.FormatoLingua(), {
                            style: "currency",
                            currency: "EUR" /*this.FormatoValuta()*/,
                            minimumFractionDigits: this.PrecisioneImporto(),
                            maximumFractionDigits: this.PrecisioneImporto()
                        }).format(parametri[P]);
                        break;
                    case "R":
                        Valore = new Intl.NumberFormat(this.FormatoLingua(), {
                            currency: this.FormatoImporto(),
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 5
                        }).format(parametri[P]);
                        break;
                    case "P":
                        Valore =
                            new Intl.NumberFormat(this.FormatoLingua(), {
                                currency: this.FormatoImporto(),
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 5
                            }).format(parametri[P]) + "%";
                        break;
                }
                //Strano, ma utile, il replace di JavaScript sostituisce solo la prima occorrenza trovata
                R = R.replace("{" + (P + 1) + (Tipo.length == 0 ? "" : "-" + Tipo) + "}", Valore);
                Glob.Log(Glob.LogCat.Trad, false, "Traduzione " + P, Valore, "Indice: " + (P + 1), "Tipo: " + Tipo, R);
            }
        }
        return R;
    }
}

export let Trad = new CTrad(navigator.language.substring(0, 2));

export class Lingua extends React.PureComponent<Glob.IGlobaleProps, {}> {
    private StileIT: React.CSSProperties = {
        opacity: 0.5
    };

    private StileEN: React.CSSProperties = {
        opacity: 0.5
    };

    //    private StileDE: React.CSSProperties = {
    //opacity: 0.5
    //    }

    //    private StileES: React.CSSProperties = {
    //opacity: 0.5
    //    }
    //    private StileFR: React.CSSProperties = {
    //opacity: 0.5
    //    }

    private SetLingua(lingua: string) {
        var L = Glob.GetLocale();
        if (L != undefined) {
            L.Lingua = lingua;
            this.props.SetLocale(L);
        }
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIListaTrad, datiNuovi: boolean): React.ReactNode {
        let Aggiornato = false;
        for (var D in dati.Dati) {
            if (Trad.AggiornaTrad(dati.Dati[D].Lingua.toLowerCase(), dati.Dati[D].Testo, dati.Dati[D].Trad)) {
                Aggiornato = true;
            }
        }
        if (Aggiornato) {
            var L = Glob.GetLocale();
            this.props.SetLocale(L);
        }
        return false;
    }

    public render() {
        let Lingua = Glob.GetLocale() && Glob.GetLocale().Lingua;
        this.StileIT = { opacity: Lingua == "it" ? 1 : 0.5 };
        this.StileEN = { opacity: Lingua == "en" ? 1 : 0.5 };
        //this.StileES = { opacity: (Lingua == "es" ? 1 : 0.5) };
        //this.StileDE = { opacity: (Lingua == "de" ? 1 : 0.5) };
        //this.StileFR = { opacity: (Lingua == "fr" ? 1 : 0.5) };

        return (
            <span className="kt-nav__link-text">
                <ChiamaAPI Aggiornare={1} URL="/api/trad/ListaTrad?lingua=it" OnRis={(s, d, dn) => this.OnRis(s, d, dn)} />
                <ChiamaAPI Aggiornare={1} URL="/api/trad/ListaTrad?lingua=en" OnRis={(s, d, dn) => this.OnRis(s, d, dn)} />
                <a
                    href="#"
                    onClick={e => {
                        e.preventDefault();
                        this.SetLingua("it");
                    }}
                >
                    <img src="images/it.png" style={this.StileIT} />
                </a>
                <a
                    href="#"
                    onClick={e => {
                        e.preventDefault();
                        this.SetLingua("en");
                    }}
                >
                    <img src="images/uk.png" style={this.StileEN} />
                </a>
            </span>
        );
    }
}

//da inserire nel return quando attive
//<a href="#" onClick={(e) => { e.preventDefault(); this.SetLingua('es') }}><img src="images/es.png" style={this.StileES} /></a>
//<a href="#" onClick={(e) => { e.preventDefault(); this.SetLingua('fr') }}><img src="images/fr.png" style={this.StileFR} /></a>
//<a href="#" onClick={(e) => { e.preventDefault(); this.SetLingua('de') }}><img src="images/de.png" style={this.StileDE} /></a>



// WEBPACK FOOTER //
// ./src/components/Trad.tsx